//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }
}

@Injectable()
export class ArticolServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getArticolList(): Observable<ArticolEditareDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/getArticolList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticolList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticolList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolEditareDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolEditareDto[]>;
        }));
    }

    protected processGetArticolList(response: HttpResponseBase): Observable<ArticolEditareDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolEditareDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolEditareDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getArticolForCsv(): Observable<ArticolExportCSV[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/getArticolForCsv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticolForCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticolForCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolExportCSV[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolExportCSV[]>;
        }));
    }

    protected processGetArticolForCsv(response: HttpResponseBase): Observable<ArticolExportCSV[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolExportCSV.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolExportCSV[]>(null as any);
    }

    /**
     * @param furnizorPretId (optional) 
     * @return Success
     */
    getArticolForCsvFurnizor(furnizorPretId: number | undefined): Observable<ArticolExportCSV[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/getArticolForCsvFurnizor?";
        if (furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' cannot be null.");
        else if (furnizorPretId !== undefined)
            url_ += "furnizorPretId=" + encodeURIComponent("" + furnizorPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticolForCsvFurnizor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticolForCsvFurnizor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolExportCSV[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolExportCSV[]>;
        }));
    }

    protected processGetArticolForCsvFurnizor(response: HttpResponseBase): Observable<ArticolExportCSV[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolExportCSV.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolExportCSV[]>(null as any);
    }

    /**
     * @return Success
     */
    getArticolDtoList(): Observable<ArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/getArticolDtoList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticolDtoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticolDtoList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDto[]>;
        }));
    }

    protected processGetArticolDtoList(response: HttpResponseBase): Observable<ArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTipDimensionalList(): Observable<TipDimensionalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/GetTipDimensionalList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipDimensionalList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipDimensionalList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto[]>;
        }));
    }

    protected processGetTipDimensionalList(response: HttpResponseBase): Observable<TipDimensionalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipDimensionalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMapListArticolTip(): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/services/app/Articol/GetMapListArticolTip";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMapListArticolTip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMapListArticolTip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetMapListArticolTip(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)[key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param articolId (optional) 
     * @return Success
     */
    articolEditarePrecompletare(articolId: number | undefined): Observable<ArticolEditareDto> {
        let url_ = this.baseUrl + "/api/services/app/Articol/ArticolEditarePrecompletare?";
        if (articolId === null)
            throw new Error("The parameter 'articolId' cannot be null.");
        else if (articolId !== undefined)
            url_ += "articolId=" + encodeURIComponent("" + articolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolEditareDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolEditareDto>;
        }));
    }

    protected processArticolEditarePrecompletare(response: HttpResponseBase): Observable<ArticolEditareDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolEditareDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolEditareDto>(null as any);
    }

    /**
     * @param articolId (optional) 
     * @param body (optional) 
     * @return Success
     */
    articolEditare(articolId: number | undefined, body: ArticolEditareDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Articol/ArticolEditare?";
        if (articolId === null)
            throw new Error("The parameter 'articolId' cannot be null.");
        else if (articolId !== undefined)
            url_ += "articolId=" + encodeURIComponent("" + articolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    articolAdaugare(body: ArticolEditareDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Articol/ArticolAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processArticolAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param articolId (optional) 
     * @return Success
     */
    getArticol(articolId: number | undefined): Observable<ArticolDto> {
        let url_ = this.baseUrl + "/api/services/app/Articol/GetArticol?";
        if (articolId === null)
            throw new Error("The parameter 'articolId' cannot be null.");
        else if (articolId !== undefined)
            url_ += "articolId=" + encodeURIComponent("" + articolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDto>;
        }));
    }

    protected processGetArticol(response: HttpResponseBase): Observable<ArticolDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDto>(null as any);
    }

    /**
     * @param articolId (optional) 
     * @return Success
     */
    articolDelete(articolId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Articol/articolDelete?";
        if (articolId === null)
            throw new Error("The parameter 'articolId' cannot be null.");
        else if (articolId !== undefined)
            url_ += "articolId=" + encodeURIComponent("" + articolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<ArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<ArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    articolListNameContains(input: string | null | undefined): Observable<ArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/ArticolListNameContains?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolListNameContains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolListNameContains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDto[]>;
        }));
    }

    protected processArticolListNameContains(response: HttpResponseBase): Observable<ArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDto[]>(null as any);
    }

    /**
     * @return Success
     */
    articolListDropDownSort(): Observable<ArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Articol/ArticolListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDto[]>;
        }));
    }

    protected processArticolListDropDownSort(response: HttpResponseBase): Observable<ArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<ArticolDto> {
        let url_ = this.baseUrl + "/api/services/app/Articol/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<ArticolDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDto>(null as any);
    }
}

@Injectable()
export class ArticolDevizServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    articolDevizList(): Observable<ArticolDevizDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ArticolDevizList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDto[]>;
        }));
    }

    protected processArticolDevizList(response: HttpResponseBase): Observable<ArticolDevizDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    articolDevizAdd(body: ArticolDevizDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ArticolDevizAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolDevizAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    articolDevizAddForDialog(body: ArticolDevizDto | undefined): Observable<ArticolDevizDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ArticolDevizAddForDialog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizAddForDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizAddForDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDto>;
        }));
    }

    protected processArticolDevizAddForDialog(response: HttpResponseBase): Observable<ArticolDevizDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolDevizDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDto>(null as any);
    }

    /**
     * @param articolId (optional) 
     * @return Success
     */
    articolDevizDelete(articolId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ArticolDevizDelete?";
        if (articolId === null)
            throw new Error("The parameter 'articolId' cannot be null.");
        else if (articolId !== undefined)
            url_ += "articolId=" + encodeURIComponent("" + articolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolDevizDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param nume (optional) 
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(nume: string | null | undefined, dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<ArticolDevizDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ListaFiltruData?";
        if (nume !== undefined && nume !== null)
            url_ += "nume=" + encodeURIComponent("" + nume) + "&";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<ArticolDevizDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<ArticolDevizDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<ArticolDevizDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolDevizDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDto>(null as any);
    }

    /**
     * @return Success
     */
    articolDevizDropDownSort(): Observable<ArticolDevizDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ArticolDevizDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDto[]>;
        }));
    }

    protected processArticolDevizDropDownSort(response: HttpResponseBase): Observable<ArticolDevizDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipDimensionalDropDownSort(): Observable<TipDimensionalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/TipDimensionalDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto[]>;
        }));
    }

    protected processTipDimensionalDropDownSort(response: HttpResponseBase): Observable<TipDimensionalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipDimensionalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto[]>(null as any);
    }

    /**
     * @param articolDevizId (optional) 
     * @return Success
     */
    getArticolDevizDetaliuDto(articolDevizId: number | undefined): Observable<ArticolDevizDetaliiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/GetArticolDevizDetaliuDto?";
        if (articolDevizId === null)
            throw new Error("The parameter 'articolDevizId' cannot be null.");
        else if (articolDevizId !== undefined)
            url_ += "articolDevizId=" + encodeURIComponent("" + articolDevizId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticolDevizDetaliuDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticolDevizDetaliuDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDetaliiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDetaliiDto[]>;
        }));
    }

    protected processGetArticolDevizDetaliuDto(response: HttpResponseBase): Observable<ArticolDevizDetaliiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizDetaliiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDetaliiDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveArticolDeviz(body: ArticolDevizDetaliiEditDto | undefined): Observable<ArticolDevizDetaliiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/SaveArticolDeviz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveArticolDeviz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveArticolDeviz(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDetaliiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDetaliiDto[]>;
        }));
    }

    protected processSaveArticolDeviz(response: HttpResponseBase): Observable<ArticolDevizDetaliiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizDetaliiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDetaliiDto[]>(null as any);
    }

    /**
     * @param articolDevizDetaliuId (optional) 
     * @param articolDevizId (optional) 
     * @return Success
     */
    deleteArticolDeviz(articolDevizDetaliuId: number | undefined, articolDevizId: number | undefined): Observable<ArticolDevizDetaliiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/DeleteArticolDeviz?";
        if (articolDevizDetaliuId === null)
            throw new Error("The parameter 'articolDevizDetaliuId' cannot be null.");
        else if (articolDevizDetaliuId !== undefined)
            url_ += "articolDevizDetaliuId=" + encodeURIComponent("" + articolDevizDetaliuId) + "&";
        if (articolDevizId === null)
            throw new Error("The parameter 'articolDevizId' cannot be null.");
        else if (articolDevizId !== undefined)
            url_ += "articolDevizId=" + encodeURIComponent("" + articolDevizId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArticolDeviz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArticolDeviz(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDetaliiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDetaliiDto[]>;
        }));
    }

    protected processDeleteArticolDeviz(response: HttpResponseBase): Observable<ArticolDevizDetaliiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizDetaliiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDetaliiDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateArticolDevizDetaliiList(body: ArticolDevizDetaliiDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/UpdateArticolDevizDetaliiList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateArticolDevizDetaliiList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateArticolDevizDetaliiList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateArticolDevizDetaliiList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    articolListNameContains(input: string | null | undefined): Observable<ArticolDevizDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ArticolListNameContains?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolListNameContains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolListNameContains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDto[]>;
        }));
    }

    protected processArticolListNameContains(response: HttpResponseBase): Observable<ArticolDevizDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDto[]>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    articolDevizCategorieListNameContains(input: string | null | undefined): Observable<ArticolDevizCategorieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/ArticolDevizCategorieListNameContains?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizCategorieListNameContains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizCategorieListNameContains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizCategorieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizCategorieDto[]>;
        }));
    }

    protected processArticolDevizCategorieListNameContains(response: HttpResponseBase): Observable<ArticolDevizCategorieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizCategorieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizCategorieDto[]>(null as any);
    }

    /**
     * @param articolDevizId (optional) 
     * @return Success
     */
    getArticolDeviz(articolDevizId: number | undefined): Observable<ArticolDevizDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDeviz/GetArticolDeviz?";
        if (articolDevizId === null)
            throw new Error("The parameter 'articolDevizId' cannot be null.");
        else if (articolDevizId !== undefined)
            url_ += "articolDevizId=" + encodeURIComponent("" + articolDevizId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticolDeviz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticolDeviz(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizDto>;
        }));
    }

    protected processGetArticolDeviz(response: HttpResponseBase): Observable<ArticolDevizDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolDevizDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizDto>(null as any);
    }
}

@Injectable()
export class ArticolDevizCategorieServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    articolDevizCategorieList(): Observable<ArticolDevizCategorieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDevizCategorie/ArticolDevizCategorieList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizCategorieList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizCategorieList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizCategorieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizCategorieDto[]>;
        }));
    }

    protected processArticolDevizCategorieList(response: HttpResponseBase): Observable<ArticolDevizCategorieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizCategorieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizCategorieDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    articolDevizCategorieAdd(body: ArticolDevizCategorieDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDevizCategorie/ArticolDevizCategorieAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizCategorieAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizCategorieAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolDevizCategorieAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param articolId (optional) 
     * @return Success
     */
    articolDevizCategorieDelete(articolId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDevizCategorie/ArticolDevizCategorieDelete?";
        if (articolId === null)
            throw new Error("The parameter 'articolId' cannot be null.");
        else if (articolId !== undefined)
            url_ += "articolId=" + encodeURIComponent("" + articolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolDevizCategorieDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolDevizCategorieDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolDevizCategorieDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<ArticolDevizCategorieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolDevizCategorie/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDevizCategorieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDevizCategorieDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<ArticolDevizCategorieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDevizCategorieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDevizCategorieDto[]>(null as any);
    }
}

@Injectable()
export class ArticolPretServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param articolId (optional) 
     * @return Success
     */
    articolPretList(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, articolId: number | null | undefined): Observable<ArticolPretDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ArticolPret/ArticolPretList?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (articolId !== undefined && articolId !== null)
            url_ += "articolId=" + encodeURIComponent("" + articolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolPretList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolPretList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolPretDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolPretDto[]>;
        }));
    }

    protected processArticolPretList(response: HttpResponseBase): Observable<ArticolPretDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolPretDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolPretDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    articolPretAdaugare(body: ArticolPretDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ArticolPret/ArticolPretAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolPretAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolPretAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processArticolPretAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param articolPretEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    articolPretEditare(articolPretEditId: number | undefined, body: ArticolPretDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticolPret/ArticolPretEditare?";
        if (articolPretEditId === null)
            throw new Error("The parameter 'articolPretEditId' cannot be null.");
        else if (articolPretEditId !== undefined)
            url_ += "ArticolPretEditId=" + encodeURIComponent("" + articolPretEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolPretEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolPretEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolPretEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param articolPretId (optional) 
     * @return Success
     */
    articolPretEditarePrecompletare(articolPretId: number | undefined): Observable<ArticolPretDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticolPret/ArticolPretEditarePrecompletare?";
        if (articolPretId === null)
            throw new Error("The parameter 'articolPretId' cannot be null.");
        else if (articolPretId !== undefined)
            url_ += "ArticolPretId=" + encodeURIComponent("" + articolPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolPretEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolPretEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolPretDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolPretDto>;
        }));
    }

    protected processArticolPretEditarePrecompletare(response: HttpResponseBase): Observable<ArticolPretDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolPretDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolPretDto>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<ArticolPretDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticolPret/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolPretDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolPretDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<ArticolPretDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticolPretDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolPretDto>(null as any);
    }

    /**
     * @param articolPretId (optional) 
     * @return Success
     */
    articolPretDelete(articolPretId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticolPret/ArticolPretDelete?";
        if (articolPretId === null)
            throw new Error("The parameter 'articolPretId' cannot be null.");
        else if (articolPretId !== undefined)
            url_ += "articolPretId=" + encodeURIComponent("" + articolPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolPretDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolPretDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolPretDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BenchmarkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startId (optional) 
     * @param endId (optional) 
     * @return Success
     */
    testFraudaRange(startId: number | undefined, endId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/TestFraudaRange?";
        if (startId === null)
            throw new Error("The parameter 'startId' cannot be null.");
        else if (startId !== undefined)
            url_ += "startId=" + encodeURIComponent("" + startId) + "&";
        if (endId === null)
            throw new Error("The parameter 'endId' cannot be null.");
        else if (endId !== undefined)
            url_ += "endId=" + encodeURIComponent("" + endId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestFraudaRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestFraudaRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestFraudaRange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    testFrauda(constatVersId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/TestFrauda?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "ConstatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestFrauda(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestFrauda(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestFrauda(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    testeazaModificariArticolPret(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/TesteazaModificariArticolPret?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTesteazaModificariArticolPret(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTesteazaModificariArticolPret(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTesteazaModificariArticolPret(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param startId (optional) 
     * @param endId (optional) 
     * @return Success
     */
    generateBmkAnalizaAbatere(startId: number | undefined, endId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GenerateBmkAnalizaAbatere?";
        if (startId === null)
            throw new Error("The parameter 'startId' cannot be null.");
        else if (startId !== undefined)
            url_ += "startId=" + encodeURIComponent("" + startId) + "&";
        if (endId === null)
            throw new Error("The parameter 'endId' cannot be null.");
        else if (endId !== undefined)
            url_ += "endId=" + encodeURIComponent("" + endId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBmkAnalizaAbatere(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBmkAnalizaAbatere(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateBmkAnalizaAbatere(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    testeazaModificariOperRemed(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/TesteazaModificariOperRemed?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTesteazaModificariOperRemed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTesteazaModificariOperRemed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processTesteazaModificariOperRemed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param data (optional) 
     * @return Success
     */
    benchmark(data: moment.Moment | undefined): Observable<BmkProcTipArticolDto> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/Benchmark?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "Data=" + encodeURIComponent(data ? "" + data.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmark(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmark(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolDto>;
        }));
    }

    protected processBenchmark(response: HttpResponseBase): Observable<BmkProcTipArticolDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BmkProcTipArticolDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolDto>(null as any);
    }

    /**
     * @param data (optional) 
     * @return Success
     */
    benchmarkAvECons(data: moment.Moment | undefined): Observable<BmkProcTipArticolAvEConsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BenchmarkAvECons?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "Data=" + encodeURIComponent(data ? "" + data.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmarkAvECons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmarkAvECons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
        }));
    }

    protected processBenchmarkAvECons(response: HttpResponseBase): Observable<BmkProcTipArticolAvEConsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolAvEConsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolAvEConsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    generateBenchmarkToday(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GenerateBenchmarkToday";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBenchmarkToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBenchmarkToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateBenchmarkToday(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    benchmarkPeriod(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<BmkProcTipArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BenchmarkPeriod?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmarkPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmarkPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolDto[]>;
        }));
    }

    protected processBenchmarkPeriod(response: HttpResponseBase): Observable<BmkProcTipArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolDto[]>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    benchmarkPeriodLunar(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<BmkProcTipArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BenchmarkPeriodLunar?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmarkPeriodLunar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmarkPeriodLunar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolDto[]>;
        }));
    }

    protected processBenchmarkPeriodLunar(response: HttpResponseBase): Observable<BmkProcTipArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolDto[]>(null as any);
    }

    /**
     * @return Success
     */
    benchmarkAllPeriod(): Observable<BmkProcTipArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BenchmarkAllPeriod";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmarkAllPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmarkAllPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolDto[]>;
        }));
    }

    protected processBenchmarkAllPeriod(response: HttpResponseBase): Observable<BmkProcTipArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolDto[]>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param bmkProcTipArticolAvEConsId (optional) 
     * @return Success
     */
    benchmarkPeriodTipAvarieElemConstrZilnic(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, bmkProcTipArticolAvEConsId: number | null | undefined): Observable<BmkProcTipArticolAvEConsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BenchmarkPeriodTipAvarieElemConstrZilnic?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (bmkProcTipArticolAvEConsId !== undefined && bmkProcTipArticolAvEConsId !== null)
            url_ += "bmkProcTipArticolAvEConsId=" + encodeURIComponent("" + bmkProcTipArticolAvEConsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmarkPeriodTipAvarieElemConstrZilnic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmarkPeriodTipAvarieElemConstrZilnic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
        }));
    }

    protected processBenchmarkPeriodTipAvarieElemConstrZilnic(response: HttpResponseBase): Observable<BmkProcTipArticolAvEConsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolAvEConsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolAvEConsDto[]>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param bmkProcTipArticolAvEConsId (optional) 
     * @return Success
     */
    benchmarkPeriodTipAvarieElemConstrLunar(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, bmkProcTipArticolAvEConsId: number | null | undefined): Observable<BmkProcTipArticolAvEConsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BenchmarkPeriodTipAvarieElemConstrLunar?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (bmkProcTipArticolAvEConsId !== undefined && bmkProcTipArticolAvEConsId !== null)
            url_ += "bmkProcTipArticolAvEConsId=" + encodeURIComponent("" + bmkProcTipArticolAvEConsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmarkPeriodTipAvarieElemConstrLunar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmarkPeriodTipAvarieElemConstrLunar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
        }));
    }

    protected processBenchmarkPeriodTipAvarieElemConstrLunar(response: HttpResponseBase): Observable<BmkProcTipArticolAvEConsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolAvEConsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolAvEConsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    benchmarkAllPeriodTipAvarieElemConstr(): Observable<BmkProcTipArticolAvEConsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BenchmarkAllPeriodTipAvarieElemConstr";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBenchmarkAllPeriodTipAvarieElemConstr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBenchmarkAllPeriodTipAvarieElemConstr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
        }));
    }

    protected processBenchmarkAllPeriodTipAvarieElemConstr(response: HttpResponseBase): Observable<BmkProcTipArticolAvEConsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolAvEConsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolAvEConsDto[]>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    genereazaBenchmarkPeriod(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GenereazaBenchmarkPeriod?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenereazaBenchmarkPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenereazaBenchmarkPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenereazaBenchmarkPeriod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    genereazaBenchmarkAvEConsPeriod(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GenereazaBenchmarkAvEConsPeriod?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenereazaBenchmarkAvEConsPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenereazaBenchmarkAvEConsPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenereazaBenchmarkAvEConsPeriod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getDataStartEnd(): Observable<DataStartEndDto> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GetDataStartEnd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataStartEnd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataStartEnd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStartEndDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStartEndDto>;
        }));
    }

    protected processGetDataStartEnd(response: HttpResponseBase): Observable<DataStartEndDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataStartEndDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataStartEndDto>(null as any);
    }

    /**
     * @return Success
     */
    getDataStartEndAvECons(): Observable<DataStartEndDto> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GetDataStartEndAvECons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataStartEndAvECons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataStartEndAvECons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStartEndDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStartEndDto>;
        }));
    }

    protected processGetDataStartEndAvECons(response: HttpResponseBase): Observable<DataStartEndDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataStartEndDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataStartEndDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    afisareDevizSiBenchmarks(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<AfisareDevizSiBenchmarkDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/AfisareDevizSiBenchmarks?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAfisareDevizSiBenchmarks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAfisareDevizSiBenchmarks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AfisareDevizSiBenchmarkDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AfisareDevizSiBenchmarkDto[]>;
        }));
    }

    protected processAfisareDevizSiBenchmarks(response: HttpResponseBase): Observable<AfisareDevizSiBenchmarkDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AfisareDevizSiBenchmarkDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AfisareDevizSiBenchmarkDto[]>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param tipAvarieId (optional) 
     * @param elementConstructivId (optional) 
     * @return Success
     */
    afisareDevizSiBenchmarksTipAvElemConstr(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, tipAvarieId: number | undefined, elementConstructivId: number | undefined): Observable<AfisareDevizSiBenchmarkTipAvElemConstrDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/AfisareDevizSiBenchmarksTipAvElemConstr?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (tipAvarieId === null)
            throw new Error("The parameter 'tipAvarieId' cannot be null.");
        else if (tipAvarieId !== undefined)
            url_ += "tipAvarieId=" + encodeURIComponent("" + tipAvarieId) + "&";
        if (elementConstructivId === null)
            throw new Error("The parameter 'elementConstructivId' cannot be null.");
        else if (elementConstructivId !== undefined)
            url_ += "elementConstructivId=" + encodeURIComponent("" + elementConstructivId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAfisareDevizSiBenchmarksTipAvElemConstr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAfisareDevizSiBenchmarksTipAvElemConstr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AfisareDevizSiBenchmarkTipAvElemConstrDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AfisareDevizSiBenchmarkTipAvElemConstrDto[]>;
        }));
    }

    protected processAfisareDevizSiBenchmarksTipAvElemConstr(response: HttpResponseBase): Observable<AfisareDevizSiBenchmarkTipAvElemConstrDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AfisareDevizSiBenchmarkTipAvElemConstrDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AfisareDevizSiBenchmarkTipAvElemConstrDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getBmkDeviatieLimita(): Observable<BmkDeviatieLimitaDto> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GetBmkDeviatieLimita";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmkDeviatieLimita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmkDeviatieLimita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkDeviatieLimitaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkDeviatieLimitaDto>;
        }));
    }

    protected processGetBmkDeviatieLimita(response: HttpResponseBase): Observable<BmkDeviatieLimitaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BmkDeviatieLimitaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkDeviatieLimitaDto>(null as any);
    }

    /**
     * @param data (optional) 
     * @return Success
     */
    getBmkProcTipArticolAvECons(data: moment.Moment | undefined): Observable<BmkProcTipArticolAvECons[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/getBmkProcTipArticolAvECons?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent(data ? "" + data.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmkProcTipArticolAvECons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmkProcTipArticolAvECons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolAvECons[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolAvECons[]>;
        }));
    }

    protected processGetBmkProcTipArticolAvECons(response: HttpResponseBase): Observable<BmkProcTipArticolAvECons[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolAvECons.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolAvECons[]>(null as any);
    }

    /**
     * @param bmkProcTipArticolAvEConsId (optional) 
     * @return Success
     */
    getBmkProcTipArticolAvEConsById(bmkProcTipArticolAvEConsId: number | null | undefined): Observable<BmkProcTipArticolAvEConsDto> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/getBmkProcTipArticolAvEConsById?";
        if (bmkProcTipArticolAvEConsId !== undefined && bmkProcTipArticolAvEConsId !== null)
            url_ += "bmkProcTipArticolAvEConsId=" + encodeURIComponent("" + bmkProcTipArticolAvEConsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmkProcTipArticolAvEConsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmkProcTipArticolAvEConsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolAvEConsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolAvEConsDto>;
        }));
    }

    protected processGetBmkProcTipArticolAvEConsById(response: HttpResponseBase): Observable<BmkProcTipArticolAvEConsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BmkProcTipArticolAvEConsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolAvEConsDto>(null as any);
    }

    /**
     * @param data (optional) 
     * @return Success
     */
    getBmkProcTipArticolAvEConsByData(data: moment.Moment | undefined): Observable<BmkProcTipArticolAvEConsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GetBmkProcTipArticolAvEConsByData?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent(data ? "" + data.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBmkProcTipArticolAvEConsByData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBmkProcTipArticolAvEConsByData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkProcTipArticolAvEConsDto[]>;
        }));
    }

    protected processGetBmkProcTipArticolAvEConsByData(response: HttpResponseBase): Observable<BmkProcTipArticolAvEConsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkProcTipArticolAvEConsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkProcTipArticolAvEConsDto[]>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    genereazaBenchmarkPeriodTipArticolAvECons(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GenereazaBenchmarkPeriodTipArticolAvECons?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenereazaBenchmarkPeriodTipArticolAvECons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenereazaBenchmarkPeriodTipArticolAvECons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenereazaBenchmarkPeriodTipArticolAvECons(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getTipAvarieElemConstructivDto(): Observable<TipAvarieElemConstructivDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GetTipAvarieElemConstructivDto";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipAvarieElemConstructivDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipAvarieElemConstructivDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieElemConstructivDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieElemConstructivDto[]>;
        }));
    }

    protected processGetTipAvarieElemConstructivDto(response: HttpResponseBase): Observable<TipAvarieElemConstructivDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieElemConstructivDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieElemConstructivDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getDataUltimulBenchmark(): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/GetDataUltimulBenchmark";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataUltimulBenchmark(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataUltimulBenchmark(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment>;
        }));
    }

    protected processGetDataUltimulBenchmark(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param neverificateBool (optional) 
     * @param permissionCheck (optional) 
     * @return Success
     */
    bmkAnalizaAbatere(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, neverificateBool: boolean | undefined, permissionCheck: boolean | undefined): Observable<BmkAnalizatMasterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BmkAnalizaAbatere?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (neverificateBool === null)
            throw new Error("The parameter 'neverificateBool' cannot be null.");
        else if (neverificateBool !== undefined)
            url_ += "neverificateBool=" + encodeURIComponent("" + neverificateBool) + "&";
        if (permissionCheck === null)
            throw new Error("The parameter 'permissionCheck' cannot be null.");
        else if (permissionCheck !== undefined)
            url_ += "permissionCheck=" + encodeURIComponent("" + permissionCheck) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBmkAnalizaAbatere(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBmkAnalizaAbatere(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkAnalizatMasterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkAnalizatMasterDto[]>;
        }));
    }

    protected processBmkAnalizaAbatere(response: HttpResponseBase): Observable<BmkAnalizatMasterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkAnalizatMasterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkAnalizatMasterDto[]>(null as any);
    }

    /**
     * @param bmkAbatereId (optional) 
     * @return Success
     */
    modifyCheckAbatere(bmkAbatereId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/ModifyCheckAbatere?";
        if (bmkAbatereId === null)
            throw new Error("The parameter 'bmkAbatereId' cannot be null.");
        else if (bmkAbatereId !== undefined)
            url_ += "bmkAbatereId=" + encodeURIComponent("" + bmkAbatereId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifyCheckAbatere(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifyCheckAbatere(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifyCheckAbatere(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param analizatConstatVersId (optional) 
     * @param tipAvarieId (optional) 
     * @param checkType (optional) 
     * @return Success
     */
    modifyCheckAbatereAll(analizatConstatVersId: number | undefined, tipAvarieId: number | undefined, checkType: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/ModifyCheckAbatereAll?";
        if (analizatConstatVersId === null)
            throw new Error("The parameter 'analizatConstatVersId' cannot be null.");
        else if (analizatConstatVersId !== undefined)
            url_ += "analizatConstatVersId=" + encodeURIComponent("" + analizatConstatVersId) + "&";
        if (tipAvarieId === null)
            throw new Error("The parameter 'tipAvarieId' cannot be null.");
        else if (tipAvarieId !== undefined)
            url_ += "tipAvarieId=" + encodeURIComponent("" + tipAvarieId) + "&";
        if (checkType === null)
            throw new Error("The parameter 'checkType' cannot be null.");
        else if (checkType !== undefined)
            url_ += "checkType=" + encodeURIComponent("" + checkType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifyCheckAbatereAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifyCheckAbatereAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModifyCheckAbatereAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    bmkAnalizaAbatereLimitaList(): Observable<BmkAnalizaAbatereLimitaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BmkAnalizaAbatereLimitaList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBmkAnalizaAbatereLimitaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBmkAnalizaAbatereLimitaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkAnalizaAbatereLimitaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkAnalizaAbatereLimitaDto[]>;
        }));
    }

    protected processBmkAnalizaAbatereLimitaList(response: HttpResponseBase): Observable<BmkAnalizaAbatereLimitaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkAnalizaAbatereLimitaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkAnalizaAbatereLimitaDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    salvareBmkAnalizaAbatereLimitaList(body: BmkAnalizaAbatereLimitaDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/SalvareBmkAnalizaAbatereLimitaList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalvareBmkAnalizaAbatereLimitaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalvareBmkAnalizaAbatereLimitaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSalvareBmkAnalizaAbatereLimitaList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param bmkAnalizaAbatereLimitaId (optional) 
     * @return Success
     */
    deleteBmkAnalizaAbatereLimita(bmkAnalizaAbatereLimitaId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/DeleteBmkAnalizaAbatereLimita?";
        if (bmkAnalizaAbatereLimitaId === null)
            throw new Error("The parameter 'bmkAnalizaAbatereLimitaId' cannot be null.");
        else if (bmkAnalizaAbatereLimitaId !== undefined)
            url_ += "bmkAnalizaAbatereLimitaId=" + encodeURIComponent("" + bmkAnalizaAbatereLimitaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBmkAnalizaAbatereLimita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBmkAnalizaAbatereLimita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBmkAnalizaAbatereLimita(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    bmkDeviatieLimitaList(): Observable<BmkDeviatieLimitaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/BmkDeviatieLimitaList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBmkDeviatieLimitaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBmkDeviatieLimitaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BmkDeviatieLimitaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BmkDeviatieLimitaDto[]>;
        }));
    }

    protected processBmkDeviatieLimitaList(response: HttpResponseBase): Observable<BmkDeviatieLimitaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BmkDeviatieLimitaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BmkDeviatieLimitaDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    salvareBmkDeviatieLimitaList(body: BmkDeviatieLimitaDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/SalvareBmkDeviatieLimitaList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalvareBmkDeviatieLimitaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalvareBmkDeviatieLimitaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSalvareBmkDeviatieLimitaList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param bmkDeviatieLimitaId (optional) 
     * @return Success
     */
    deleteBmkDeviatieLimita(bmkDeviatieLimitaId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Benchmark/DeleteBmkDeviatieLimita?";
        if (bmkDeviatieLimitaId === null)
            throw new Error("The parameter 'bmkDeviatieLimitaId' cannot be null.");
        else if (bmkDeviatieLimitaId !== undefined)
            url_ += "bmkDeviatieLimitaId=" + encodeURIComponent("" + bmkDeviatieLimitaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBmkDeviatieLimita(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBmkDeviatieLimita(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBmkDeviatieLimita(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CategorieElementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    categorieElementAdaugare(body: CategorieElementEditDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/CategorieElementAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCategorieElementAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    categorieElementListDropDownSort(): Observable<CategorieElementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/CategorieElementListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementDto[]>;
        }));
    }

    protected processCategorieElementListDropDownSort(response: HttpResponseBase): Observable<CategorieElementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategorieElementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementDto[]>(null as any);
    }

    /**
     * @param tipZonaAvariataId (optional) 
     * @return Success
     */
    categorieElementList(tipZonaAvariataId: number | null | undefined): Observable<CategorieElementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/CategorieElementList?";
        if (tipZonaAvariataId !== undefined && tipZonaAvariataId !== null)
            url_ += "tipZonaAvariataId=" + encodeURIComponent("" + tipZonaAvariataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementDto[]>;
        }));
    }

    protected processCategorieElementList(response: HttpResponseBase): Observable<CategorieElementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategorieElementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementDto[]>(null as any);
    }

    /**
     * @param categorieElementId (optional) 
     * @return Success
     */
    categorieElementDelete(categorieElementId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/CategorieElementDelete?";
        if (categorieElementId === null)
            throw new Error("The parameter 'categorieElementId' cannot be null.");
        else if (categorieElementId !== undefined)
            url_ += "CategorieElementId=" + encodeURIComponent("" + categorieElementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCategorieElementDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param categorieElementEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    categorieElementEditare(categorieElementEditId: number | undefined, body: CategorieElementEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/CategorieElementEditare?";
        if (categorieElementEditId === null)
            throw new Error("The parameter 'categorieElementEditId' cannot be null.");
        else if (categorieElementEditId !== undefined)
            url_ += "CategorieElementEditId=" + encodeURIComponent("" + categorieElementEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCategorieElementEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param categorieElementId (optional) 
     * @return Success
     */
    categorieElementEditarePrecompletare(categorieElementId: number | undefined): Observable<CategorieElementEditDto> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/CategorieElementEditarePrecompletare?";
        if (categorieElementId === null)
            throw new Error("The parameter 'categorieElementId' cannot be null.");
        else if (categorieElementId !== undefined)
            url_ += "CategorieElementId=" + encodeURIComponent("" + categorieElementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementEditDto>;
        }));
    }

    protected processCategorieElementEditarePrecompletare(response: HttpResponseBase): Observable<CategorieElementEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategorieElementEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementEditDto>(null as any);
    }

    /**
     * @param categorieElementId (optional) 
     * @return Success
     */
    getCategorieElement(categorieElementId: number | undefined): Observable<CategorieElementDto> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/GetCategorieElement?";
        if (categorieElementId === null)
            throw new Error("The parameter 'categorieElementId' cannot be null.");
        else if (categorieElementId !== undefined)
            url_ += "CategorieElementId=" + encodeURIComponent("" + categorieElementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorieElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorieElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementDto>;
        }));
    }

    protected processGetCategorieElement(response: HttpResponseBase): Observable<CategorieElementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategorieElementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<CategorieElementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<CategorieElementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategorieElementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<CategorieElementDto> {
        let url_ = this.baseUrl + "/api/services/app/CategorieElement/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<CategorieElementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategorieElementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementDto>(null as any);
    }
}

@Injectable()
export class CauzaAvarieServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cauzaAvarieAdaugare(body: CauzaAvarieDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/CauzaAvarieAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCauzaAvarieAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCauzaAvarieAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCauzaAvarieAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    cauzaAvarieList(): Observable<CauzaAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/CauzaAvarieList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCauzaAvarieList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCauzaAvarieList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieDto[]>;
        }));
    }

    protected processCauzaAvarieList(response: HttpResponseBase): Observable<CauzaAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CauzaAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieDto[]>(null as any);
    }

    /**
     * @param cauzaAvarieEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    cauzaAvarieEditare(cauzaAvarieEditId: number | undefined, body: CauzaAvarieDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/CauzaAvarieEditare?";
        if (cauzaAvarieEditId === null)
            throw new Error("The parameter 'cauzaAvarieEditId' cannot be null.");
        else if (cauzaAvarieEditId !== undefined)
            url_ += "cauzaAvarieEditId=" + encodeURIComponent("" + cauzaAvarieEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCauzaAvarieEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCauzaAvarieEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCauzaAvarieEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param cauzaAvarieId (optional) 
     * @return Success
     */
    cauzaAvarieDelete(cauzaAvarieId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/CauzaAvarieDelete?";
        if (cauzaAvarieId === null)
            throw new Error("The parameter 'cauzaAvarieId' cannot be null.");
        else if (cauzaAvarieId !== undefined)
            url_ += "cauzaAvarieId=" + encodeURIComponent("" + cauzaAvarieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCauzaAvarieDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCauzaAvarieDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCauzaAvarieDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param cauzaAvarieId (optional) 
     * @return Success
     */
    cauzaAvarieEditarePrecompletare(cauzaAvarieId: number | undefined): Observable<CauzaAvarieDto> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/CauzaAvarieEditarePrecompletare?";
        if (cauzaAvarieId === null)
            throw new Error("The parameter 'cauzaAvarieId' cannot be null.");
        else if (cauzaAvarieId !== undefined)
            url_ += "cauzaAvarieId=" + encodeURIComponent("" + cauzaAvarieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCauzaAvarieEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCauzaAvarieEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieDto>;
        }));
    }

    protected processCauzaAvarieEditarePrecompletare(response: HttpResponseBase): Observable<CauzaAvarieDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CauzaAvarieDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieDto>(null as any);
    }

    /**
     * @param cauzaAvarieId (optional) 
     * @return Success
     */
    getCauzaAvarie(cauzaAvarieId: number | undefined): Observable<CauzaAvarieDto> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/GetCauzaAvarie?";
        if (cauzaAvarieId === null)
            throw new Error("The parameter 'cauzaAvarieId' cannot be null.");
        else if (cauzaAvarieId !== undefined)
            url_ += "cauzaAvarieId=" + encodeURIComponent("" + cauzaAvarieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCauzaAvarie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCauzaAvarie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieDto>;
        }));
    }

    protected processGetCauzaAvarie(response: HttpResponseBase): Observable<CauzaAvarieDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CauzaAvarieDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<CauzaAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<CauzaAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CauzaAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<CauzaAvarieDto> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<CauzaAvarieDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CauzaAvarieDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieDto>(null as any);
    }

    /**
     * @return Success
     */
    cauzaAvarieListDropDownSort(): Observable<CauzaAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CauzaAvarie/CauzaAvarieListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCauzaAvarieListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCauzaAvarieListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieDto[]>;
        }));
    }

    protected processCauzaAvarieListDropDownSort(response: HttpResponseBase): Observable<CauzaAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CauzaAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieDto[]>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ConstatareServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    constatareList(): Observable<ConstatListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatareList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatareList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatareList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatListDto[]>;
        }));
    }

    protected processConstatareList(response: HttpResponseBase): Observable<ConstatListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatListDto[]>(null as any);
    }

    /**
     * @param constatId (optional) 
     * @return Success
     */
    constatareVersList(constatId: number | undefined): Observable<ConstatVersListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatareVersList?";
        if (constatId === null)
            throw new Error("The parameter 'constatId' cannot be null.");
        else if (constatId !== undefined)
            url_ += "constatId=" + encodeURIComponent("" + constatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatareVersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatareVersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatVersListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatVersListDto[]>;
        }));
    }

    protected processConstatareVersList(response: HttpResponseBase): Observable<ConstatVersListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatVersListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatVersListDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    constatViewUnitLocat(constatVersId: number | undefined): Observable<ConstatViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatViewUnitLocat?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatViewUnitLocat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatViewUnitLocat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatViewDto>;
        }));
    }

    protected processConstatViewUnitLocat(response: HttpResponseBase): Observable<ConstatViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstatViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatViewDto>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    constatViewCamereList(constatVersId: number | undefined): Observable<ConstatViewCameraDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatViewCamereList?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatViewCamereList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatViewCamereList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatViewCameraDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatViewCameraDto[]>;
        }));
    }

    protected processConstatViewCamereList(response: HttpResponseBase): Observable<ConstatViewCameraDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatViewCameraDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatViewCameraDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipSpatiuListDropDownSort(): Observable<TipSpatiuDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/TipSpatiuListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipSpatiuListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipSpatiuListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuDto[]>;
        }));
    }

    protected processTipSpatiuListDropDownSort(response: HttpResponseBase): Observable<TipSpatiuDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipSpatiuDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    getConstatId(constatVersId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/GetConstatId?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstatId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstatId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetConstatId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    constatAdd(body: ConstatAddDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConstatAdd(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param constatId (optional) 
     * @param body (optional) 
     * @return Success
     */
    constatEdit(constatId: number | undefined, body: ConstatAddDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatEdit?";
        if (constatId === null)
            throw new Error("The parameter 'constatId' cannot be null.");
        else if (constatId !== undefined)
            url_ += "constatId=" + encodeURIComponent("" + constatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConstatEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    deleteAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    tipZonaAvariataDropDownSort(): Observable<TipZonaAvariataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/TipZonaAvariataDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipZonaAvariataDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipZonaAvariataDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataDto[]>;
        }));
    }

    protected processTipZonaAvariataDropDownSort(response: HttpResponseBase): Observable<TipZonaAvariataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipZonaAvariataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataDto[]>(null as any);
    }

    /**
     * @return Success
     */
    cauzeAvarieDropDownSort(): Observable<CauzaAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/CauzeAvarieDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCauzeAvarieDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCauzeAvarieDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieDto[]>;
        }));
    }

    protected processCauzeAvarieDropDownSort(response: HttpResponseBase): Observable<CauzaAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CauzaAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipAvarieDropDownSort(): Observable<TipAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/TipAvarieDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto[]>;
        }));
    }

    protected processTipAvarieDropDownSort(response: HttpResponseBase): Observable<TipAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto[]>(null as any);
    }

    /**
     * @return Success
     */
    elementConstructivDropDownSort(): Observable<ElementConstructivDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ElementConstructivDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementConstructivDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementConstructivDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivDto[]>;
        }));
    }

    protected processElementConstructivDropDownSort(response: HttpResponseBase): Observable<ElementConstructivDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivDto[]>(null as any);
    }

    /**
     * @param tipAvarieId (optional) 
     * @return Success
     */
    elementConstructivByTipAvarieDropDownSort(tipAvarieId: number | null | undefined): Observable<ElementConstructivDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ElementConstructivByTipAvarieDropDownSort?";
        if (tipAvarieId !== undefined && tipAvarieId !== null)
            url_ += "tipAvarieId=" + encodeURIComponent("" + tipAvarieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementConstructivByTipAvarieDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementConstructivByTipAvarieDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivDto[]>;
        }));
    }

    protected processElementConstructivByTipAvarieDropDownSort(response: HttpResponseBase): Observable<ElementConstructivDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipDimensionalDropDownSort(): Observable<TipDimensionalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/TipDimensionalDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto[]>;
        }));
    }

    protected processTipDimensionalDropDownSort(response: HttpResponseBase): Observable<TipDimensionalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipDimensionalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto[]>(null as any);
    }

    /**
     * @return Success
     */
    judetDropDownSort(): Observable<JudetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/JudetDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJudetDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJudetDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JudetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JudetDto[]>;
        }));
    }

    protected processJudetDropDownSort(response: HttpResponseBase): Observable<JudetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(JudetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JudetDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    constatCameraDaunaAdd(body: ConstatAddCameraDaunaV2Dto | undefined): Observable<ConstatAddCameraDaunaV2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatCameraDaunaAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatCameraDaunaAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatCameraDaunaAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
        }));
    }

    protected processConstatCameraDaunaAdd(response: HttpResponseBase): Observable<ConstatAddCameraDaunaV2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraDaunaV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraDaunaV2Dto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    constatCameraAdd(body: ConstatAddCameraV2Dto | undefined): Observable<ConstatAddCameraV2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatCameraAdd";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatCameraAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatCameraAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraV2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraV2Dto[]>;
        }));
    }

    protected processConstatCameraAdd(response: HttpResponseBase): Observable<ConstatAddCameraV2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraV2Dto[]>(null as any);
    }

    /**
     * @param cameraId (optional) 
     * @return Success
     */
    deleteAddCamera(cameraId: number | undefined): Observable<ConstatAddCameraV2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DeleteAddCamera?";
        if (cameraId === null)
            throw new Error("The parameter 'cameraId' cannot be null.");
        else if (cameraId !== undefined)
            url_ += "CameraId=" + encodeURIComponent("" + cameraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAddCamera(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAddCamera(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraV2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraV2Dto[]>;
        }));
    }

    protected processDeleteAddCamera(response: HttpResponseBase): Observable<ConstatAddCameraV2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraV2Dto[]>(null as any);
    }

    /**
     * @param cameraDaunaId (optional) 
     * @return Success
     */
    deleteAddCameraDauna(cameraDaunaId: number | undefined): Observable<ConstatAddCameraDaunaV2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DeleteAddCameraDauna?";
        if (cameraDaunaId === null)
            throw new Error("The parameter 'cameraDaunaId' cannot be null.");
        else if (cameraDaunaId !== undefined)
            url_ += "CameraDaunaId=" + encodeURIComponent("" + cameraDaunaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAddCameraDauna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAddCameraDauna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
        }));
    }

    protected processDeleteAddCameraDauna(response: HttpResponseBase): Observable<ConstatAddCameraDaunaV2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraDaunaV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraDaunaV2Dto[]>(null as any);
    }

    /**
     * @param pereteId (optional) 
     * @return Success
     */
    getConstatAddCameraPerete(pereteId: number | undefined): Observable<ConstatAddCameraPereteDto> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/GetConstatAddCameraPerete?";
        if (pereteId === null)
            throw new Error("The parameter 'pereteId' cannot be null.");
        else if (pereteId !== undefined)
            url_ += "pereteId=" + encodeURIComponent("" + pereteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstatAddCameraPerete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstatAddCameraPerete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraPereteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraPereteDto>;
        }));
    }

    protected processGetConstatAddCameraPerete(response: HttpResponseBase): Observable<ConstatAddCameraPereteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstatAddCameraPereteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraPereteDto>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    getConstatAddCamere(constatVersId: number | undefined): Observable<ConstatAddCameraV2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/GetConstatAddCamere?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstatAddCamere(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstatAddCamere(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraV2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraV2Dto[]>;
        }));
    }

    protected processGetConstatAddCamere(response: HttpResponseBase): Observable<ConstatAddCameraV2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraV2Dto[]>(null as any);
    }

    /**
     * @param constatCameraId (optional) 
     * @return Success
     */
    constatAddCameraDaune(constatCameraId: number | undefined): Observable<ConstatAddCameraDaunaV2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatAddCameraDaune?";
        if (constatCameraId === null)
            throw new Error("The parameter 'constatCameraId' cannot be null.");
        else if (constatCameraId !== undefined)
            url_ += "constatCameraId=" + encodeURIComponent("" + constatCameraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatAddCameraDaune(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatAddCameraDaune(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
        }));
    }

    protected processConstatAddCameraDaune(response: HttpResponseBase): Observable<ConstatAddCameraDaunaV2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraDaunaV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraDaunaV2Dto[]>(null as any);
    }

    /**
     * @param constatCameraId (optional) 
     * @return Success
     */
    cameraPeretiExpand(constatCameraId: number | undefined): Observable<ConstatCameraDaunaPeretiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/CameraPeretiExpand?";
        if (constatCameraId === null)
            throw new Error("The parameter 'constatCameraId' cannot be null.");
        else if (constatCameraId !== undefined)
            url_ += "constatCameraId=" + encodeURIComponent("" + constatCameraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCameraPeretiExpand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCameraPeretiExpand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatCameraDaunaPeretiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatCameraDaunaPeretiDto[]>;
        }));
    }

    protected processCameraPeretiExpand(response: HttpResponseBase): Observable<ConstatCameraDaunaPeretiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatCameraDaunaPeretiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatCameraDaunaPeretiDto[]>(null as any);
    }

    /**
     * @return Success
     */
    constatCameraDaunaListUpdate(): Observable<ConstatAddCameraDaunaV2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatCameraDaunaListUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatCameraDaunaListUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatCameraDaunaListUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraDaunaV2Dto[]>;
        }));
    }

    protected processConstatCameraDaunaListUpdate(response: HttpResponseBase): Observable<ConstatAddCameraDaunaV2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraDaunaV2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraDaunaV2Dto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addFinisajToPerete(body: ConstatAddCameraPereteFinisajDto | undefined): Observable<ConstatAddCameraPereteDto> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/AddFinisajToPerete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFinisajToPerete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFinisajToPerete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraPereteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraPereteDto>;
        }));
    }

    protected processAddFinisajToPerete(response: HttpResponseBase): Observable<ConstatAddCameraPereteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstatAddCameraPereteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraPereteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stergeFinisajToPerete(body: ConstatAddCameraPereteFinisajDto | undefined): Observable<ConstatAddCameraPereteDto> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/StergeFinisajToPerete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStergeFinisajToPerete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStergeFinisajToPerete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraPereteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraPereteDto>;
        }));
    }

    protected processStergeFinisajToPerete(response: HttpResponseBase): Observable<ConstatAddCameraPereteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstatAddCameraPereteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraPereteDto>(null as any);
    }

    /**
     * @param cameraId (optional) 
     * @param daunaId (optional) 
     * @return Success
     */
    getConstatPeretiDauna(cameraId: number | undefined, daunaId: number | undefined): Observable<ConstatAddCameraPereteLinkDaunaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/GetConstatPeretiDauna?";
        if (cameraId === null)
            throw new Error("The parameter 'cameraId' cannot be null.");
        else if (cameraId !== undefined)
            url_ += "cameraId=" + encodeURIComponent("" + cameraId) + "&";
        if (daunaId === null)
            throw new Error("The parameter 'daunaId' cannot be null.");
        else if (daunaId !== undefined)
            url_ += "daunaId=" + encodeURIComponent("" + daunaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstatPeretiDauna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstatPeretiDauna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraPereteLinkDaunaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraPereteLinkDaunaDto[]>;
        }));
    }

    protected processGetConstatPeretiDauna(response: HttpResponseBase): Observable<ConstatAddCameraPereteLinkDaunaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraPereteLinkDaunaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraPereteLinkDaunaDto[]>(null as any);
    }

    /**
     * @param daunaId (optional) 
     * @param cameraId (optional) 
     * @param body (optional) 
     * @return Success
     */
    saveConstatPeretiDauna(daunaId: number | undefined, cameraId: number | undefined, body: ConstatAddCameraPereteLinkDaunaDto[] | null | undefined): Observable<ConstatAddCameraPereteLinkDaunaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/SaveConstatPeretiDauna?";
        if (daunaId === null)
            throw new Error("The parameter 'daunaId' cannot be null.");
        else if (daunaId !== undefined)
            url_ += "daunaId=" + encodeURIComponent("" + daunaId) + "&";
        if (cameraId === null)
            throw new Error("The parameter 'cameraId' cannot be null.");
        else if (cameraId !== undefined)
            url_ += "cameraId=" + encodeURIComponent("" + cameraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveConstatPeretiDauna(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveConstatPeretiDauna(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddCameraPereteLinkDaunaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddCameraPereteLinkDaunaDto[]>;
        }));
    }

    protected processSaveConstatPeretiDauna(response: HttpResponseBase): Observable<ConstatAddCameraPereteLinkDaunaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatAddCameraPereteLinkDaunaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddCameraPereteLinkDaunaDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    devizDelete(constatVersId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DevizDelete?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDevizDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDevizDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDevizDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    genereazaDevizePentruToateConstatarile(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/GenereazaDevizePentruToateConstatarile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenereazaDevizePentruToateConstatarile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenereazaDevizePentruToateConstatarile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenereazaDevizePentruToateConstatarile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    devizGenerate(constatVersId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DevizGenerate?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDevizGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDevizGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDevizGenerate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param startConstatVersId (optional) 
     * @param endConstatVersId (optional) 
     * @return Success
     */
    devizGenerateInterval(startConstatVersId: number | undefined, endConstatVersId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DevizGenerateInterval?";
        if (startConstatVersId === null)
            throw new Error("The parameter 'startConstatVersId' cannot be null.");
        else if (startConstatVersId !== undefined)
            url_ += "startConstatVersId=" + encodeURIComponent("" + startConstatVersId) + "&";
        if (endConstatVersId === null)
            throw new Error("The parameter 'endConstatVersId' cannot be null.");
        else if (endConstatVersId !== undefined)
            url_ += "endConstatVersId=" + encodeURIComponent("" + endConstatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDevizGenerateInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDevizGenerateInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDevizGenerateInterval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param constatId (optional) 
     * @return Success
     */
    constatAddEditarePrecompletare(constatId: number | undefined): Observable<ConstatAddDto> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatAddEditarePrecompletare?";
        if (constatId === null)
            throw new Error("The parameter 'constatId' cannot be null.");
        else if (constatId !== undefined)
            url_ += "constatId=" + encodeURIComponent("" + constatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatAddEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatAddEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatAddDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatAddDto>;
        }));
    }

    protected processConstatAddEditarePrecompletare(response: HttpResponseBase): Observable<ConstatAddDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConstatAddDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatAddDto>(null as any);
    }

    /**
     * @param dataConstatStart (optional) 
     * @param dataConstatEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataConstatStart: moment.Moment | undefined, dataConstatEnd: moment.Moment | undefined): Observable<ConstatListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ListaFiltruData?";
        if (dataConstatStart === null)
            throw new Error("The parameter 'dataConstatStart' cannot be null.");
        else if (dataConstatStart !== undefined)
            url_ += "DataConstatStart=" + encodeURIComponent(dataConstatStart ? "" + dataConstatStart.toISOString() : "") + "&";
        if (dataConstatEnd === null)
            throw new Error("The parameter 'dataConstatEnd' cannot be null.");
        else if (dataConstatEnd !== undefined)
            url_ += "DataConstatEnd=" + encodeURIComponent(dataConstatEnd ? "" + dataConstatEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatListDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<ConstatListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatListDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatList(constatVersId: number | undefined): Observable<OperatiuneRemediereAfisareCameraDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/OperatiuneRemediereConstatList?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereAfisareCameraDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereAfisareCameraDto[]>;
        }));
    }

    protected processOperatiuneRemediereConstatList(response: HttpResponseBase): Observable<OperatiuneRemediereAfisareCameraDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereAfisareCameraDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereAfisareCameraDto[]>(null as any);
    }

    /**
     * @param constaVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatCalculTabel(constaVersId: number | undefined): Observable<OperatiuneRemediereTabelCalculGrupeDto> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/OperatiuneRemediereConstatCalculTabel?";
        if (constaVersId === null)
            throw new Error("The parameter 'constaVersId' cannot be null.");
        else if (constaVersId !== undefined)
            url_ += "constaVersId=" + encodeURIComponent("" + constaVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatCalculTabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatCalculTabel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereTabelCalculGrupeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereTabelCalculGrupeDto>;
        }));
    }

    protected processOperatiuneRemediereConstatCalculTabel(response: HttpResponseBase): Observable<OperatiuneRemediereTabelCalculGrupeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperatiuneRemediereTabelCalculGrupeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereTabelCalculGrupeDto>(null as any);
    }

    /**
     * @param constaVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatCalculTabel2(constaVersId: number | undefined): Observable<OperatiuneRemediereTabelCalculGrupeDto> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/OperatiuneRemediereConstatCalculTabel2?";
        if (constaVersId === null)
            throw new Error("The parameter 'constaVersId' cannot be null.");
        else if (constaVersId !== undefined)
            url_ += "constaVersId=" + encodeURIComponent("" + constaVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatCalculTabel2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatCalculTabel2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereTabelCalculGrupeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereTabelCalculGrupeDto>;
        }));
    }

    protected processOperatiuneRemediereConstatCalculTabel2(response: HttpResponseBase): Observable<OperatiuneRemediereTabelCalculGrupeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperatiuneRemediereTabelCalculGrupeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereTabelCalculGrupeDto>(null as any);
    }

    /**
     * @param constatId (optional) 
     * @return Success
     */
    isDevizGenerated(constatId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/isDevizGenerated?";
        if (constatId === null)
            throw new Error("The parameter 'constatId' cannot be null.");
        else if (constatId !== undefined)
            url_ += "constatId=" + encodeURIComponent("" + constatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsDevizGenerated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDevizGenerated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsDevizGenerated(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param constatId (optional) 
     * @return Success
     */
    deleteConstat(constatId: number | undefined): Observable<ConstatListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DeleteConstat?";
        if (constatId === null)
            throw new Error("The parameter 'constatId' cannot be null.");
        else if (constatId !== undefined)
            url_ += "constatId=" + encodeURIComponent("" + constatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConstat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConstat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConstatListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConstatListDto[]>;
        }));
    }

    protected processDeleteConstat(response: HttpResponseBase): Observable<ConstatListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConstatListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConstatListDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    isConstatVersGenerated(constatVersId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/IsConstatVersGenerated?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsConstatVersGenerated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsConstatVersGenerated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsConstatVersGenerated(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    validareConstatVers(constatVersId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ValidareConstatVers?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidareConstatVers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidareConstatVers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidareConstatVers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    devalidareConstatVers(constatVersId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/DevalidareConstatVers?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDevalidareConstatVers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDevalidareConstatVers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDevalidareConstatVers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    constatVersDuplicate(constatVersId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConstatVersDuplicate?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConstatVersDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConstatVersDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConstatVersDuplicate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param cauzaAvarieListString (optional) 
     * @param tipAvarieListString (optional) 
     * @param categorieElementListString (optional) 
     * @param tipElementAvariatListString (optional) 
     * @param elementeConstructiveListString (optional) 
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param sumaMin (optional) 
     * @param sumaMax (optional) 
     * @param tipSpatiuListString (optional) 
     * @param judetId (optional) 
     * @param localitate (optional) 
     * @param asigurator (optional) 
     * @param utilizatorConstatare (optional) 
     * @return Success
     */
    getRaportTabelDevExtreme(cauzaAvarieListString: string | null | undefined, tipAvarieListString: string | null | undefined, categorieElementListString: string | null | undefined, tipElementAvariatListString: string | null | undefined, elementeConstructiveListString: string | null | undefined, dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, sumaMin: number | null | undefined, sumaMax: number | null | undefined, tipSpatiuListString: string | null | undefined, judetId: number | undefined, localitate: string | null | undefined, asigurator: string | null | undefined, utilizatorConstatare: string | null | undefined): Observable<RaportGeneratDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/GetRaportTabelDevExtreme?";
        if (cauzaAvarieListString !== undefined && cauzaAvarieListString !== null)
            url_ += "CauzaAvarieListString=" + encodeURIComponent("" + cauzaAvarieListString) + "&";
        if (tipAvarieListString !== undefined && tipAvarieListString !== null)
            url_ += "TipAvarieListString=" + encodeURIComponent("" + tipAvarieListString) + "&";
        if (categorieElementListString !== undefined && categorieElementListString !== null)
            url_ += "CategorieElementListString=" + encodeURIComponent("" + categorieElementListString) + "&";
        if (tipElementAvariatListString !== undefined && tipElementAvariatListString !== null)
            url_ += "TipElementAvariatListString=" + encodeURIComponent("" + tipElementAvariatListString) + "&";
        if (elementeConstructiveListString !== undefined && elementeConstructiveListString !== null)
            url_ += "ElementeConstructiveListString=" + encodeURIComponent("" + elementeConstructiveListString) + "&";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (sumaMin !== undefined && sumaMin !== null)
            url_ += "SumaMin=" + encodeURIComponent("" + sumaMin) + "&";
        if (sumaMax !== undefined && sumaMax !== null)
            url_ += "SumaMax=" + encodeURIComponent("" + sumaMax) + "&";
        if (tipSpatiuListString !== undefined && tipSpatiuListString !== null)
            url_ += "TipSpatiuListString=" + encodeURIComponent("" + tipSpatiuListString) + "&";
        if (judetId === null)
            throw new Error("The parameter 'judetId' cannot be null.");
        else if (judetId !== undefined)
            url_ += "JudetId=" + encodeURIComponent("" + judetId) + "&";
        if (localitate !== undefined && localitate !== null)
            url_ += "Localitate=" + encodeURIComponent("" + localitate) + "&";
        if (asigurator !== undefined && asigurator !== null)
            url_ += "Asigurator=" + encodeURIComponent("" + asigurator) + "&";
        if (utilizatorConstatare !== undefined && utilizatorConstatare !== null)
            url_ += "UtilizatorConstatare=" + encodeURIComponent("" + utilizatorConstatare) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRaportTabelDevExtreme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRaportTabelDevExtreme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaportGeneratDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaportGeneratDto[]>;
        }));
    }

    protected processGetRaportTabelDevExtreme(response: HttpResponseBase): Observable<RaportGeneratDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RaportGeneratDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaportGeneratDto[]>(null as any);
    }

    /**
     * @param param (optional) 
     * @return Success
     */
    convertToListOfInt(param: string | null | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Constatare/ConvertToListOfInt?";
        if (param !== undefined && param !== null)
            url_ += "param=" + encodeURIComponent("" + param) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToListOfInt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToListOfInt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processConvertToListOfInt(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }
}

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param furnizorId (optional) 
     * @param dataStart (optional) 
     * @param csv (optional) 
     * @return Success
     */
    importArticoleCSV(furnizorId: number | undefined, dataStart: moment.Moment | undefined, csv: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/importArticoleCSV?";
        if (furnizorId === null)
            throw new Error("The parameter 'furnizorId' cannot be null.");
        else if (furnizorId !== undefined)
            url_ += "FurnizorId=" + encodeURIComponent("" + furnizorId) + "&";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csv !== null && csv !== undefined)
            content_.append("Csv", csv.data, csv.fileName ? csv.fileName : "Csv");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportArticoleCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportArticoleCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportArticoleCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param furnizorId (optional) 
     * @param dataStart (optional) 
     * @param csv (optional) 
     * @return Success
     */
    importArticoleInternCSV(furnizorId: number | undefined, dataStart: moment.Moment | undefined, csv: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/importArticoleInternCSV?";
        if (furnizorId === null)
            throw new Error("The parameter 'furnizorId' cannot be null.");
        else if (furnizorId !== undefined)
            url_ += "FurnizorId=" + encodeURIComponent("" + furnizorId) + "&";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csv !== null && csv !== undefined)
            content_.append("Csv", csv.data, csv.fileName ? csv.fileName : "Csv");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportArticoleInternCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportArticoleInternCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportArticoleInternCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadArticoleCSV(): Observable<void> {
        let url_ = this.baseUrl + "/downloadArticoleCSV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadArticoleCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadArticoleCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadArticoleCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadArticoleFurnizorCSV(furnizorPretId: number): Observable<void> {
        let url_ = this.baseUrl + "/downloadArticoleFurnizorCSV/{furnizorPretId}";
        if (furnizorPretId === undefined || furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' must be defined.");
        url_ = url_.replace("{furnizorPretId}", encodeURIComponent("" + furnizorPretId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadArticoleFurnizorCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadArticoleFurnizorCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadArticoleFurnizorCSV(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DevizServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    devizAdd(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deviz/DevizAdd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDevizAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDevizAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDevizAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param operatiuneRemediereId (optional) 
     * @param constatCameraId (optional) 
     * @return Success
     */
    devizCalculare(operatiuneRemediereId: number | undefined, constatCameraId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deviz/DevizCalculare?";
        if (operatiuneRemediereId === null)
            throw new Error("The parameter 'operatiuneRemediereId' cannot be null.");
        else if (operatiuneRemediereId !== undefined)
            url_ += "operatiuneRemediereId=" + encodeURIComponent("" + operatiuneRemediereId) + "&";
        if (constatCameraId === null)
            throw new Error("The parameter 'constatCameraId' cannot be null.");
        else if (constatCameraId !== undefined)
            url_ += "constatCameraId=" + encodeURIComponent("" + constatCameraId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDevizCalculare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDevizCalculare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDevizCalculare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ElementConstructivServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param elementConstructivId (optional) 
     * @return Success
     */
    categorieElementConstructivPrecompletare(elementConstructivId: number | undefined): Observable<ElementConstructivEditDto> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/categorieElementConstructivPrecompletare?";
        if (elementConstructivId === null)
            throw new Error("The parameter 'elementConstructivId' cannot be null.");
        else if (elementConstructivId !== undefined)
            url_ += "elementConstructivId=" + encodeURIComponent("" + elementConstructivId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementConstructivPrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementConstructivPrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivEditDto>;
        }));
    }

    protected processCategorieElementConstructivPrecompletare(response: HttpResponseBase): Observable<ElementConstructivEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElementConstructivEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivEditDto>(null as any);
    }

    /**
     * @param elementConstructivEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    elementConstructivEditare(elementConstructivEditId: number | undefined, body: ElementConstructivEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/ElementConstructivEditare?";
        if (elementConstructivEditId === null)
            throw new Error("The parameter 'elementConstructivEditId' cannot be null.");
        else if (elementConstructivEditId !== undefined)
            url_ += "elementConstructivEditId=" + encodeURIComponent("" + elementConstructivEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementConstructivEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementConstructivEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processElementConstructivEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    elementConstructivAdaugare(body: ElementConstructivEditDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/ElementConstructivAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementConstructivAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementConstructivAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processElementConstructivAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param elementConstructivId (optional) 
     * @return Success
     */
    elementConstructivDelete(elementConstructivId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/ElementConstructivDelete?";
        if (elementConstructivId === null)
            throw new Error("The parameter 'elementConstructivId' cannot be null.");
        else if (elementConstructivId !== undefined)
            url_ += "elementConstructivId=" + encodeURIComponent("" + elementConstructivId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementConstructivDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementConstructivDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processElementConstructivDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<ElementConstructivDto> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<ElementConstructivDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElementConstructivDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param tipElementAvariatId (optional) 
     * @return Success
     */
    elementConstructivList(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, tipElementAvariatId: number | null | undefined): Observable<ElementConstructivDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/ElementConstructivList?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (tipElementAvariatId !== undefined && tipElementAvariatId !== null)
            url_ += "tipElementAvariatId=" + encodeURIComponent("" + tipElementAvariatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementConstructivList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementConstructivList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivDto[]>;
        }));
    }

    protected processElementConstructivList(response: HttpResponseBase): Observable<ElementConstructivDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getRapoarte(): Observable<ElementConstructivForJoinDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/GetRapoarte";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRapoarte(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRapoarte(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivForJoinDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivForJoinDto[]>;
        }));
    }

    protected processGetRapoarte(response: HttpResponseBase): Observable<ElementConstructivForJoinDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivForJoinDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivForJoinDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getJoinedElementeConstructive(): Observable<ElementConstructivRaportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/GetJoinedElementeConstructive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJoinedElementeConstructive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJoinedElementeConstructive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivRaportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivRaportDto[]>;
        }));
    }

    protected processGetJoinedElementeConstructive(response: HttpResponseBase): Observable<ElementConstructivRaportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivRaportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivRaportDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getRaport(): Observable<RaportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElementConstructiv/GetRaport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRaport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRaport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaportDto[]>;
        }));
    }

    protected processGetRaport(response: HttpResponseBase): Observable<RaportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RaportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaportDto[]>(null as any);
    }
}

@Injectable()
export class EnumTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    articolTipList(): Observable<EnumTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EnumType/ArticolTipList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolTipList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolTipList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumTypeDto[]>;
        }));
    }

    protected processArticolTipList(response: HttpResponseBase): Observable<EnumTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    calitateElemConstructivList(): Observable<EnumTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EnumType/CalitateElemConstructivList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalitateElemConstructivList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalitateElemConstructivList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumTypeDto[]>;
        }));
    }

    protected processCalitateElemConstructivList(response: HttpResponseBase): Observable<EnumTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipConstatareList(): Observable<EnumTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EnumType/TipConstatareList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipConstatareList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipConstatareList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumTypeDto[]>;
        }));
    }

    protected processTipConstatareList(response: HttpResponseBase): Observable<EnumTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    rapoarteList(): Observable<EnumTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EnumType/RapoarteList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRapoarteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRapoarteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnumTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnumTypeDto[]>;
        }));
    }

    protected processRapoarteList(response: HttpResponseBase): Observable<EnumTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EnumTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EnumTypeDto[]>(null as any);
    }
}

@Injectable()
export class FurnizorPretServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    furnizorPretList(): Observable<FurnizorPretDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/FurnizorPretList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnizorPretList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnizorPretList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FurnizorPretDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FurnizorPretDto[]>;
        }));
    }

    protected processFurnizorPretList(response: HttpResponseBase): Observable<FurnizorPretDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FurnizorPretDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnizorPretDto[]>(null as any);
    }

    /**
     * @param furnizorPretId (optional) 
     * @return Success
     */
    furnizorPretDelete(furnizorPretId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/FurnizorPretDelete?";
        if (furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' cannot be null.");
        else if (furnizorPretId !== undefined)
            url_ += "furnizorPretId=" + encodeURIComponent("" + furnizorPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnizorPretDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnizorPretDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFurnizorPretDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnizorPretAdaugareEditare(body: FurnizorPretDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/FurnizorPretAdaugareEditare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnizorPretAdaugareEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnizorPretAdaugareEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFurnizorPretAdaugareEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param furnizorPretId (optional) 
     * @return Success
     */
    articolMapPret(furnizorPretId: number | undefined): Observable<ArticolFurnizorPretDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/ArticolMapPret?";
        if (furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' cannot be null.");
        else if (furnizorPretId !== undefined)
            url_ += "furnizorPretId=" + encodeURIComponent("" + furnizorPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolMapPret(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolMapPret(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolFurnizorPretDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolFurnizorPretDto[]>;
        }));
    }

    protected processArticolMapPret(response: HttpResponseBase): Observable<ArticolFurnizorPretDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolFurnizorPretDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolFurnizorPretDto[]>(null as any);
    }

    /**
     * @param furnizorPretId (optional) 
     * @return Success
     */
    articolFaraMapPret(furnizorPretId: number | undefined): Observable<ArticolFurnizorPretDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/ArticolFaraMapPret?";
        if (furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' cannot be null.");
        else if (furnizorPretId !== undefined)
            url_ += "furnizorPretId=" + encodeURIComponent("" + furnizorPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolFaraMapPret(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolFaraMapPret(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolFurnizorPretDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolFurnizorPretDto[]>;
        }));
    }

    protected processArticolFaraMapPret(response: HttpResponseBase): Observable<ArticolFurnizorPretDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolFurnizorPretDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolFurnizorPretDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    articolMapSave(body: ArticolFurnizorPretDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/ArticolMapSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolMapSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolMapSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolMapSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param furnizorPretId (optional) 
     * @return Success
     */
    articolMapCuFurnizorPret(furnizorPretId: number | undefined): Observable<ArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/ArticolMapCuFurnizorPret?";
        if (furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' cannot be null.");
        else if (furnizorPretId !== undefined)
            url_ += "furnizorPretId=" + encodeURIComponent("" + furnizorPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolMapCuFurnizorPret(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolMapCuFurnizorPret(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolDto[]>;
        }));
    }

    protected processArticolMapCuFurnizorPret(response: HttpResponseBase): Observable<ArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolDto[]>(null as any);
    }

    /**
     * @param furnizorPretId (optional) 
     * @return Success
     */
    furnizorPretAdaugarePrecompletare(furnizorPretId: number | undefined): Observable<FurnizorPretDto> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/FurnizorPretAdaugarePrecompletare?";
        if (furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' cannot be null.");
        else if (furnizorPretId !== undefined)
            url_ += "furnizorPretId=" + encodeURIComponent("" + furnizorPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnizorPretAdaugarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnizorPretAdaugarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FurnizorPretDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FurnizorPretDto>;
        }));
    }

    protected processFurnizorPretAdaugarePrecompletare(response: HttpResponseBase): Observable<FurnizorPretDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FurnizorPretDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FurnizorPretDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnizorPretAdaugare(body: FurnizorPretDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/FurnizorPretAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnizorPretAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnizorPretAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFurnizorPretAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    furnizorPretActualizareImport(body: { [key: string]: ArticolExportCSV; } | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/FurnizorPretActualizareImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFurnizorPretActualizareImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFurnizorPretActualizareImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFurnizorPretActualizareImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    internPretActualizareImport(body: ArticolExportCSV[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/InternPretActualizareImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternPretActualizareImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternPretActualizareImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternPretActualizareImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param furnizorPretId (optional) 
     * @return Success
     */
    articolPretFisiereList(furnizorPretId: number | undefined): Observable<ArticolPretFisiereDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/ArticolPretFisiereList?";
        if (furnizorPretId === null)
            throw new Error("The parameter 'furnizorPretId' cannot be null.");
        else if (furnizorPretId !== undefined)
            url_ += "furnizorPretId=" + encodeURIComponent("" + furnizorPretId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolPretFisiereList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolPretFisiereList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArticolPretFisiereDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArticolPretFisiereDto[]>;
        }));
    }

    protected processArticolPretFisiereList(response: HttpResponseBase): Observable<ArticolPretFisiereDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ArticolPretFisiereDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticolPretFisiereDto[]>(null as any);
    }

    /**
     * @param articolPretFisierId (optional) 
     * @return Success
     */
    articolPretFisierRollBack(articolPretFisierId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FurnizorPret/ArticolPretFisierRollBack?";
        if (articolPretFisierId === null)
            throw new Error("The parameter 'articolPretFisierId' cannot be null.");
        else if (articolPretFisierId !== undefined)
            url_ += "articolPretFisierId=" + encodeURIComponent("" + articolPretFisierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArticolPretFisierRollBack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArticolPretFisierRollBack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArticolPretFisierRollBack(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InterfataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTipSpatiuList(): Observable<TipSpatiuAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetTipSpatiuList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipSpatiuList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipSpatiuList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuAPIDto[]>;
        }));
    }

    protected processGetTipSpatiuList(response: HttpResponseBase): Observable<TipSpatiuAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipSpatiuAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuAPIDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCauzaAvarieList(): Observable<CauzaAvarieAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetCauzaAvarieList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCauzaAvarieList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCauzaAvarieList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CauzaAvarieAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CauzaAvarieAPIDto[]>;
        }));
    }

    protected processGetCauzaAvarieList(response: HttpResponseBase): Observable<CauzaAvarieAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CauzaAvarieAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CauzaAvarieAPIDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTipAvarieList(): Observable<TipAvarieAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetTipAvarieList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipAvarieList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipAvarieList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieAPIDto[]>;
        }));
    }

    protected processGetTipAvarieList(response: HttpResponseBase): Observable<TipAvarieAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieAPIDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTipZonaAvariataList(): Observable<TipZonaAvariataAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetTipZonaAvariataList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipZonaAvariataList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipZonaAvariataList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataAPIDto[]>;
        }));
    }

    protected processGetTipZonaAvariataList(response: HttpResponseBase): Observable<TipZonaAvariataAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipZonaAvariataAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataAPIDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCategorieElementList(): Observable<CategorieElementAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetCategorieElementList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorieElementList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorieElementList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementAPIDto[]>;
        }));
    }

    protected processGetCategorieElementList(response: HttpResponseBase): Observable<CategorieElementAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategorieElementAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementAPIDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTipElementAvariatList(): Observable<TipElementAvariatAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetTipElementAvariatList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipElementAvariatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipElementAvariatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipElementAvariatAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipElementAvariatAPIDto[]>;
        }));
    }

    protected processGetTipElementAvariatList(response: HttpResponseBase): Observable<TipElementAvariatAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipElementAvariatAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipElementAvariatAPIDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getElementConstructivList(): Observable<ElementConstructivAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetElementConstructivList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElementConstructivList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElementConstructivList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivAPIDto[]>;
        }));
    }

    protected processGetElementConstructivList(response: HttpResponseBase): Observable<ElementConstructivAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivAPIDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getTipDimensionalList(): Observable<TipDimensionalAPIDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetTipDimensionalList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipDimensionalList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipDimensionalList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalAPIDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalAPIDto[]>;
        }));
    }

    protected processGetTipDimensionalList(response: HttpResponseBase): Observable<TipDimensionalAPIDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipDimensionalAPIDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalAPIDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addConstatare(body: ConstatAddWaterfallDto | undefined): Observable<ResultMessageIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/AddConstatare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConstatare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConstatare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessageIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessageIdDto>;
        }));
    }

    protected processAddConstatare(response: HttpResponseBase): Observable<ResultMessageIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessageIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultMessageIdDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    waterfallAdd(tenantId: number | undefined, body: Constat | undefined): Observable<ResultMessageIdDto> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/WaterfallAdd?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWaterfallAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWaterfallAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultMessageIdDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultMessageIdDto>;
        }));
    }

    protected processWaterfallAdd(response: HttpResponseBase): Observable<ResultMessageIdDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultMessageIdDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultMessageIdDto>(null as any);
    }

    /**
     * @param constaVersId (optional) 
     * @return Success
     */
    getValoareDeviz(constaVersId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetValoareDeviz?";
        if (constaVersId === null)
            throw new Error("The parameter 'constaVersId' cannot be null.");
        else if (constaVersId !== undefined)
            url_ += "constaVersId=" + encodeURIComponent("" + constaVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValoareDeviz(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValoareDeviz(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetValoareDeviz(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getDataNomenclatoare(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/GetDataNomenclatoare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDataNomenclatoare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataNomenclatoare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDataNomenclatoare(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    testConstatareAdd(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/TestConstatareAdd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestConstatareAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestConstatareAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestConstatareAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fisierJson (optional) 
     * @param constatVersId (optional) 
     * @param statusCode (optional) 
     * @param message (optional) 
     * @return Success
     */
    addConstatIncarcareApi(fisierJson: string | null | undefined, constatVersId: number | null | undefined, statusCode: number | undefined, message: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Interfata/AddConstatIncarcareApi?";
        if (fisierJson !== undefined && fisierJson !== null)
            url_ += "fisierJson=" + encodeURIComponent("" + fisierJson) + "&";
        if (constatVersId !== undefined && constatVersId !== null)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        if (statusCode === null)
            throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConstatIncarcareApi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConstatIncarcareApi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddConstatIncarcareApi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OperatiuniRemediereServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    elementeConstructiveListDropdown(): Observable<ElementConstructivDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/ElementeConstructiveListDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementeConstructiveListDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementeConstructiveListDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivDto[]>;
        }));
    }

    protected processElementeConstructiveListDropdown(response: HttpResponseBase): Observable<ElementConstructivDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivDto[]>(null as any);
    }

    /**
     * @param elemConstrId (optional) 
     * @param tipAvarieAsocId (optional) 
     * @return Success
     */
    tipuriAvariiListDropdown(elemConstrId: number | undefined, tipAvarieAsocId: number | undefined): Observable<TipAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/TipuriAvariiListDropdown?";
        if (elemConstrId === null)
            throw new Error("The parameter 'elemConstrId' cannot be null.");
        else if (elemConstrId !== undefined)
            url_ += "elemConstrId=" + encodeURIComponent("" + elemConstrId) + "&";
        if (tipAvarieAsocId === null)
            throw new Error("The parameter 'tipAvarieAsocId' cannot be null.");
        else if (tipAvarieAsocId !== undefined)
            url_ += "tipAvarieAsocId=" + encodeURIComponent("" + tipAvarieAsocId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipuriAvariiListDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipuriAvariiListDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto[]>;
        }));
    }

    protected processTipuriAvariiListDropdown(response: HttpResponseBase): Observable<TipAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto[]>(null as any);
    }

    /**
     * @param elemConstrId (optional) 
     * @return Success
     */
    tipuriAvariiAsociateDropdown(elemConstrId: number | undefined): Observable<TipAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/TipuriAvariiAsociateDropdown?";
        if (elemConstrId === null)
            throw new Error("The parameter 'elemConstrId' cannot be null.");
        else if (elemConstrId !== undefined)
            url_ += "elemConstrId=" + encodeURIComponent("" + elemConstrId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipuriAvariiAsociateDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipuriAvariiAsociateDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto[]>;
        }));
    }

    protected processTipuriAvariiAsociateDropdown(response: HttpResponseBase): Observable<TipAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveOperatiuneRemediereAsoc(body: FilterOperatiuneRemediereAsociataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/SaveOperatiuneRemediereAsoc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOperatiuneRemediereAsoc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOperatiuneRemediereAsoc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveOperatiuneRemediereAsoc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    operatiuneRemediereAsociatList(): Observable<OperatiuneRemediereAsociatDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/OperatiuneRemediereAsociatList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereAsociatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereAsociatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereAsociatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereAsociatDto[]>;
        }));
    }

    protected processOperatiuneRemediereAsociatList(response: HttpResponseBase): Observable<OperatiuneRemediereAsociatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereAsociatDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereAsociatDto[]>(null as any);
    }

    /**
     * @param operRemedAsocId (optional) 
     * @return Success
     */
    deleteOperRemedAsoc(operRemedAsocId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/DeleteOperRemedAsoc?";
        if (operRemedAsocId === null)
            throw new Error("The parameter 'operRemedAsocId' cannot be null.");
        else if (operRemedAsocId !== undefined)
            url_ += "operRemedAsocId=" + encodeURIComponent("" + operRemedAsocId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOperRemedAsoc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOperRemedAsoc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOperRemedAsoc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    operatiuniRemediereHList(body: OperatiuniRemediereDto | undefined): Observable<OperatiuniRemediereDetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/OperatiuniRemediereHList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuniRemediereHList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuniRemediereHList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuniRemediereDetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuniRemediereDetDto[]>;
        }));
    }

    protected processOperatiuniRemediereHList(response: HttpResponseBase): Observable<OperatiuniRemediereDetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuniRemediereDetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuniRemediereDetDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveOperatiuniRemediere(body: OperatiuniRemediereHDetDto | undefined): Observable<OperatiuniRemediereDetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/SaveOperatiuniRemediere";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOperatiuniRemediere(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOperatiuniRemediere(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuniRemediereDetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuniRemediereDetDto[]>;
        }));
    }

    protected processSaveOperatiuniRemediere(response: HttpResponseBase): Observable<OperatiuniRemediereDetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuniRemediereDetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuniRemediereDetDto[]>(null as any);
    }

    /**
     * @return Success
     */
    operatiuniRemediereList(): Observable<OperatiuniRemediereDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/OperatiuniRemediereList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuniRemediereList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuniRemediereList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuniRemediereDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuniRemediereDto[]>;
        }));
    }

    protected processOperatiuniRemediereList(response: HttpResponseBase): Observable<OperatiuniRemediereDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuniRemediereDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuniRemediereDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipAvarieListDropDownSort(): Observable<TipAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/TipAvarieListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto[]>;
        }));
    }

    protected processTipAvarieListDropDownSort(response: HttpResponseBase): Observable<TipAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto[]>(null as any);
    }

    /**
     * @return Success
     */
    categorieElementListDropDownSort(): Observable<CategorieElementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/CategorieElementListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCategorieElementListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCategorieElementListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategorieElementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategorieElementDto[]>;
        }));
    }

    protected processCategorieElementListDropDownSort(response: HttpResponseBase): Observable<CategorieElementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CategorieElementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategorieElementDto[]>(null as any);
    }

    /**
     * @param categorieElementId (optional) 
     * @return Success
     */
    tipElementAvariatListDropDownSort(categorieElementId: number | null | undefined): Observable<TipElementAvariatDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/TipElementAvariatListDropDownSort?";
        if (categorieElementId !== undefined && categorieElementId !== null)
            url_ += "categorieElementId=" + encodeURIComponent("" + categorieElementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipElementAvariatListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipElementAvariatListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipElementAvariatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipElementAvariatDto[]>;
        }));
    }

    protected processTipElementAvariatListDropDownSort(response: HttpResponseBase): Observable<TipElementAvariatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipElementAvariatDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipElementAvariatDto[]>(null as any);
    }

    /**
     * @param categorieElementId (optional) 
     * @param elementAvariatId (optional) 
     * @return Success
     */
    elementConstructivListDropDownSort(categorieElementId: number | null | undefined, elementAvariatId: number | null | undefined): Observable<ElementConstructivDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/ElementConstructivListDropDownSort?";
        if (categorieElementId !== undefined && categorieElementId !== null)
            url_ += "categorieElementId=" + encodeURIComponent("" + categorieElementId) + "&";
        if (elementAvariatId !== undefined && elementAvariatId !== null)
            url_ += "elementAvariatId=" + encodeURIComponent("" + elementAvariatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElementConstructivListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElementConstructivListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementConstructivDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementConstructivDto[]>;
        }));
    }

    protected processElementConstructivListDropDownSort(response: HttpResponseBase): Observable<ElementConstructivDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ElementConstructivDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ElementConstructivDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipDimensionalListDropDownSort(): Observable<TipDimensionalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/TipDimensionalListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto[]>;
        }));
    }

    protected processTipDimensionalListDropDownSort(response: HttpResponseBase): Observable<TipDimensionalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipDimensionalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto[]>(null as any);
    }

    /**
     * @param operatiuneRemediereId (optional) 
     * @return Success
     */
    operatiuniRemediereDelete(operatiuneRemediereId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/OperatiuniRemediereDelete?";
        if (operatiuneRemediereId === null)
            throw new Error("The parameter 'operatiuneRemediereId' cannot be null.");
        else if (operatiuneRemediereId !== undefined)
            url_ += "operatiuneRemediereId=" + encodeURIComponent("" + operatiuneRemediereId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuniRemediereDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuniRemediereDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperatiuniRemediereDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filterOperatiuniRemediere(body: FilterOperatiuniRemediereInputDto | undefined): Observable<FilterOperatiuniRemediereOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/FilterOperatiuniRemediere";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterOperatiuniRemediere(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterOperatiuniRemediere(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterOperatiuniRemediereOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterOperatiuniRemediereOutputDto[]>;
        }));
    }

    protected processFilterOperatiuniRemediere(response: HttpResponseBase): Observable<FilterOperatiuniRemediereOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FilterOperatiuniRemediereOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FilterOperatiuniRemediereOutputDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filterOperatiuniRemediere2(body: FilterOperatiuniRemediereInput2Dto | undefined): Observable<FilterOperatiuniRemediereOutput2Dto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/FilterOperatiuniRemediere2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterOperatiuniRemediere2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterOperatiuniRemediere2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FilterOperatiuniRemediereOutput2Dto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FilterOperatiuniRemediereOutput2Dto[]>;
        }));
    }

    protected processFilterOperatiuniRemediere2(response: HttpResponseBase): Observable<FilterOperatiuniRemediereOutput2Dto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FilterOperatiuniRemediereOutput2Dto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FilterOperatiuniRemediereOutput2Dto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveOperatieRemediereArticol(body: OperatiuneRemediereArticolEditDto | undefined): Observable<OperatiuneRemediereArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/SaveOperatieRemediereArticol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOperatieRemediereArticol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOperatieRemediereArticol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereArticolDto[]>;
        }));
    }

    protected processSaveOperatieRemediereArticol(response: HttpResponseBase): Observable<OperatiuneRemediereArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereArticolDto[]>(null as any);
    }

    /**
     * @param operatieRemediereArticolId (optional) 
     * @param operatieRemediereId (optional) 
     * @return Success
     */
    deleteOperatieRemediereArticol(operatieRemediereArticolId: number | undefined, operatieRemediereId: number | undefined): Observable<OperatiuneRemediereArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/DeleteOperatieRemediereArticol?";
        if (operatieRemediereArticolId === null)
            throw new Error("The parameter 'operatieRemediereArticolId' cannot be null.");
        else if (operatieRemediereArticolId !== undefined)
            url_ += "operatieRemediereArticolId=" + encodeURIComponent("" + operatieRemediereArticolId) + "&";
        if (operatieRemediereId === null)
            throw new Error("The parameter 'operatieRemediereId' cannot be null.");
        else if (operatieRemediereId !== undefined)
            url_ += "operatieRemediereId=" + encodeURIComponent("" + operatieRemediereId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOperatieRemediereArticol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOperatieRemediereArticol(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereArticolDto[]>;
        }));
    }

    protected processDeleteOperatieRemediereArticol(response: HttpResponseBase): Observable<OperatiuneRemediereArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereArticolDto[]>(null as any);
    }

    /**
     * @param operatiuneRemediereId (optional) 
     * @return Success
     */
    getOperatiuniRemediereArticolList(operatiuneRemediereId: number | undefined): Observable<OperatiuneRemediereArticolDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/GetOperatiuniRemediereArticolList?";
        if (operatiuneRemediereId === null)
            throw new Error("The parameter 'operatiuneRemediereId' cannot be null.");
        else if (operatiuneRemediereId !== undefined)
            url_ += "operatiuneRemediereId=" + encodeURIComponent("" + operatiuneRemediereId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperatiuniRemediereArticolList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperatiuniRemediereArticolList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereArticolDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereArticolDto[]>;
        }));
    }

    protected processGetOperatiuniRemediereArticolList(response: HttpResponseBase): Observable<OperatiuneRemediereArticolDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereArticolDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereArticolDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOperatiuneRemediereArticolList(body: OperatiuneRemediereArticolDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OperatiuniRemediere/UpdateOperatiuneRemediereArticolList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOperatiuneRemediereArticolList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOperatiuneRemediereArticolList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOperatiuneRemediereArticolList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param cauzaAvarieList (optional) 
     * @param tipAvarieList (optional) 
     * @param categorieElementList (optional) 
     * @param tipElementAvariatList (optional) 
     * @param elementeConstructiveList (optional) 
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param sumaMin (optional) 
     * @param sumaMax (optional) 
     * @return Success
     */
    getRaportGenerat(cauzaAvarieList: number[] | null | undefined, tipAvarieList: number[] | null | undefined, categorieElementList: number[] | null | undefined, tipElementAvariatList: number[] | null | undefined, elementeConstructiveList: number[] | null | undefined, dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, sumaMin: number | null | undefined, sumaMax: number | null | undefined): Observable<RaportGeneratDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetRaportGenerat?";
        if (cauzaAvarieList !== undefined && cauzaAvarieList !== null)
            cauzaAvarieList && cauzaAvarieList.forEach(item => { url_ += "CauzaAvarieList=" + encodeURIComponent("" + item) + "&"; });
        if (tipAvarieList !== undefined && tipAvarieList !== null)
            tipAvarieList && tipAvarieList.forEach(item => { url_ += "TipAvarieList=" + encodeURIComponent("" + item) + "&"; });
        if (categorieElementList !== undefined && categorieElementList !== null)
            categorieElementList && categorieElementList.forEach(item => { url_ += "CategorieElementList=" + encodeURIComponent("" + item) + "&"; });
        if (tipElementAvariatList !== undefined && tipElementAvariatList !== null)
            tipElementAvariatList && tipElementAvariatList.forEach(item => { url_ += "TipElementAvariatList=" + encodeURIComponent("" + item) + "&"; });
        if (elementeConstructiveList !== undefined && elementeConstructiveList !== null)
            elementeConstructiveList && elementeConstructiveList.forEach(item => { url_ += "ElementeConstructiveList=" + encodeURIComponent("" + item) + "&"; });
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (sumaMin !== undefined && sumaMin !== null)
            url_ += "SumaMin=" + encodeURIComponent("" + sumaMin) + "&";
        if (sumaMax !== undefined && sumaMax !== null)
            url_ += "SumaMax=" + encodeURIComponent("" + sumaMax) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRaportGenerat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRaportGenerat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaportGeneratDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaportGeneratDto[]>;
        }));
    }

    protected processGetRaportGenerat(response: HttpResponseBase): Observable<RaportGeneratDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RaportGeneratDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaportGeneratDto[]>(null as any);
    }

    /**
     * @param cauzaAvarieList (optional) 
     * @param tipAvarieList (optional) 
     * @param categorieElementList (optional) 
     * @param tipElementAvariatList (optional) 
     * @param elementeConstructiveList (optional) 
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param sumaMin (optional) 
     * @param sumaMax (optional) 
     * @param tipSpatiuList (optional) 
     * @param judetId (optional) 
     * @param localitate (optional) 
     * @param asigurator (optional) 
     * @param utilizatorConstatare (optional) 
     * @return Success
     */
    getRaportGeneratFinal(cauzaAvarieList: number[] | null | undefined, tipAvarieList: number[] | null | undefined, categorieElementList: number[] | null | undefined, tipElementAvariatList: number[] | null | undefined, elementeConstructiveList: number[] | null | undefined, dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, sumaMin: number | null | undefined, sumaMax: number | null | undefined, tipSpatiuList: number[] | null | undefined, judetId: number | null | undefined, localitate: string | null | undefined, asigurator: string | null | undefined, utilizatorConstatare: string | null | undefined): Observable<RaportGeneratDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetRaportGeneratFinal?";
        if (cauzaAvarieList !== undefined && cauzaAvarieList !== null)
            cauzaAvarieList && cauzaAvarieList.forEach(item => { url_ += "CauzaAvarieList=" + encodeURIComponent("" + item) + "&"; });
        if (tipAvarieList !== undefined && tipAvarieList !== null)
            tipAvarieList && tipAvarieList.forEach(item => { url_ += "TipAvarieList=" + encodeURIComponent("" + item) + "&"; });
        if (categorieElementList !== undefined && categorieElementList !== null)
            categorieElementList && categorieElementList.forEach(item => { url_ += "CategorieElementList=" + encodeURIComponent("" + item) + "&"; });
        if (tipElementAvariatList !== undefined && tipElementAvariatList !== null)
            tipElementAvariatList && tipElementAvariatList.forEach(item => { url_ += "TipElementAvariatList=" + encodeURIComponent("" + item) + "&"; });
        if (elementeConstructiveList !== undefined && elementeConstructiveList !== null)
            elementeConstructiveList && elementeConstructiveList.forEach(item => { url_ += "ElementeConstructiveList=" + encodeURIComponent("" + item) + "&"; });
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "DataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "DataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (sumaMin !== undefined && sumaMin !== null)
            url_ += "SumaMin=" + encodeURIComponent("" + sumaMin) + "&";
        if (sumaMax !== undefined && sumaMax !== null)
            url_ += "SumaMax=" + encodeURIComponent("" + sumaMax) + "&";
        if (tipSpatiuList !== undefined && tipSpatiuList !== null)
            tipSpatiuList && tipSpatiuList.forEach(item => { url_ += "TipSpatiuList=" + encodeURIComponent("" + item) + "&"; });
        if (judetId !== undefined && judetId !== null)
            url_ += "JudetId=" + encodeURIComponent("" + judetId) + "&";
        if (localitate !== undefined && localitate !== null)
            url_ += "Localitate=" + encodeURIComponent("" + localitate) + "&";
        if (asigurator !== undefined && asigurator !== null)
            url_ += "Asigurator=" + encodeURIComponent("" + asigurator) + "&";
        if (utilizatorConstatare !== undefined && utilizatorConstatare !== null)
            url_ += "UtilizatorConstatare=" + encodeURIComponent("" + utilizatorConstatare) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRaportGeneratFinal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRaportGeneratFinal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaportGeneratDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaportGeneratDto[]>;
        }));
    }

    protected processGetRaportGeneratFinal(response: HttpResponseBase): Observable<RaportGeneratDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RaportGeneratDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaportGeneratDto[]>(null as any);
    }

    /**
     * @param cauzaAvarieList (optional) 
     * @return Success
     */
    getCauzaAvarieNumeList(cauzaAvarieList: number[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCauzaAvarieNumeList?";
        if (cauzaAvarieList !== undefined && cauzaAvarieList !== null)
            cauzaAvarieList && cauzaAvarieList.forEach(item => { url_ += "cauzaAvarieList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCauzaAvarieNumeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCauzaAvarieNumeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCauzaAvarieNumeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param tipAvarieList (optional) 
     * @return Success
     */
    getTipAvarieNumeList(tipAvarieList: number[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetTipAvarieNumeList?";
        if (tipAvarieList !== undefined && tipAvarieList !== null)
            tipAvarieList && tipAvarieList.forEach(item => { url_ += "tipAvarieList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipAvarieNumeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipAvarieNumeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTipAvarieNumeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param categorieElementList (optional) 
     * @return Success
     */
    getCategorieElementNumeList(categorieElementList: number[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetCategorieElementNumeList?";
        if (categorieElementList !== undefined && categorieElementList !== null)
            categorieElementList && categorieElementList.forEach(item => { url_ += "categorieElementList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorieElementNumeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorieElementNumeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCategorieElementNumeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param tipElementAvariatList (optional) 
     * @return Success
     */
    getTipElementAvariatNumeList(tipElementAvariatList: number[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetTipElementAvariatNumeList?";
        if (tipElementAvariatList !== undefined && tipElementAvariatList !== null)
            tipElementAvariatList && tipElementAvariatList.forEach(item => { url_ += "tipElementAvariatList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipElementAvariatNumeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipElementAvariatNumeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTipElementAvariatNumeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param elementConstructivList (optional) 
     * @return Success
     */
    getElementeConstructiveNumeList(elementConstructivList: number[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetElementeConstructiveNumeList?";
        if (elementConstructivList !== undefined && elementConstructivList !== null)
            elementConstructivList && elementConstructivList.forEach(item => { url_ += "elementConstructivList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElementeConstructiveNumeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElementeConstructiveNumeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetElementeConstructiveNumeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param tipSpatiuList (optional) 
     * @return Success
     */
    getTipSpatiuNumeList(tipSpatiuList: number[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetTipSpatiuNumeList?";
        if (tipSpatiuList !== undefined && tipSpatiuList !== null)
            tipSpatiuList && tipSpatiuList.forEach(item => { url_ += "tipSpatiuList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipSpatiuNumeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipSpatiuNumeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTipSpatiuNumeList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param constaVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatCalculTabel2(constaVersId: number | undefined): Observable<OperatiuneRemediereTabelCalculReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OperatiuneRemediereConstatCalculTabel2?";
        if (constaVersId === null)
            throw new Error("The parameter 'constaVersId' cannot be null.");
        else if (constaVersId !== undefined)
            url_ += "constaVersId=" + encodeURIComponent("" + constaVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatCalculTabel2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatCalculTabel2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereTabelCalculReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereTabelCalculReportDto[]>;
        }));
    }

    protected processOperatiuneRemediereConstatCalculTabel2(response: HttpResponseBase): Observable<OperatiuneRemediereTabelCalculReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereTabelCalculReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereTabelCalculReportDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatList(constatVersId: number | undefined): Observable<OperatiuneRemediereAfisareCameraReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OperatiuneRemediereConstatList?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereAfisareCameraReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereAfisareCameraReportDto[]>;
        }));
    }

    protected processOperatiuneRemediereConstatList(response: HttpResponseBase): Observable<OperatiuneRemediereAfisareCameraReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereAfisareCameraReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereAfisareCameraReportDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatNOUList(constatVersId: number | undefined): Observable<OperatiuneRemediereAfisareCameraReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OperatiuneRemediereConstatNOUList?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatNOUList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatNOUList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OperatiuneRemediereAfisareCameraReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OperatiuneRemediereAfisareCameraReportDto[]>;
        }));
    }

    protected processOperatiuneRemediereConstatNOUList(response: HttpResponseBase): Observable<OperatiuneRemediereAfisareCameraReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OperatiuneRemediereAfisareCameraReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OperatiuneRemediereAfisareCameraReportDto[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatList3(constatVersId: number | undefined): Observable<FlattenOperatiuneRemedieAfisareCameraReport[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OperatiuneRemediereConstatList3?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatList3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatList3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlattenOperatiuneRemedieAfisareCameraReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlattenOperatiuneRemedieAfisareCameraReport[]>;
        }));
    }

    protected processOperatiuneRemediereConstatList3(response: HttpResponseBase): Observable<FlattenOperatiuneRemedieAfisareCameraReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FlattenOperatiuneRemedieAfisareCameraReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlattenOperatiuneRemedieAfisareCameraReport[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    getDevizModel(constatVersId: number | undefined): Observable<DevizModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetDevizModel?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevizModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevizModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DevizModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DevizModelDto>;
        }));
    }

    protected processGetDevizModel(response: HttpResponseBase): Observable<DevizModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevizModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DevizModelDto>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    operatiuneRemediereConstatList2(constatVersId: number | undefined): Observable<FlattenOperatiuneRemedieAfisareCameraReport[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/OperatiuneRemediereConstatList2?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOperatiuneRemediereConstatList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperatiuneRemediereConstatList2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlattenOperatiuneRemedieAfisareCameraReport[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlattenOperatiuneRemedieAfisareCameraReport[]>;
        }));
    }

    protected processOperatiuneRemediereConstatList2(response: HttpResponseBase): Observable<FlattenOperatiuneRemedieAfisareCameraReport[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FlattenOperatiuneRemedieAfisareCameraReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlattenOperatiuneRemedieAfisareCameraReport[]>(null as any);
    }

    /**
     * @param constatVersId (optional) 
     * @return Success
     */
    getDevizCalculExceptiiList(constatVersId: number | undefined): Observable<DevizCalculExceptiiDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetDevizCalculExceptiiList?";
        if (constatVersId === null)
            throw new Error("The parameter 'constatVersId' cannot be null.");
        else if (constatVersId !== undefined)
            url_ += "constatVersId=" + encodeURIComponent("" + constatVersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevizCalculExceptiiList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevizCalculExceptiiList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DevizCalculExceptiiDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DevizCalculExceptiiDto[]>;
        }));
    }

    protected processGetDevizCalculExceptiiList(response: HttpResponseBase): Observable<DevizCalculExceptiiDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DevizCalculExceptiiDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DevizCalculExceptiiDto[]>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }
}

@Injectable()
export class TipAvarieServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tipAvarieAdaugare(body: TipAvarieDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/TipAvarieAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTipAvarieAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    tipAvarieList(): Observable<TipAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/TipAvarieList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto[]>;
        }));
    }

    protected processTipAvarieList(response: HttpResponseBase): Observable<TipAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto[]>(null as any);
    }

    /**
     * @param tipAvarieId (optional) 
     * @return Success
     */
    tipAvarieDelete(tipAvarieId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/TipAvarieDelete?";
        if (tipAvarieId === null)
            throw new Error("The parameter 'tipAvarieId' cannot be null.");
        else if (tipAvarieId !== undefined)
            url_ += "tipAvarieId=" + encodeURIComponent("" + tipAvarieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipAvarieDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipAvarieEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    tipAvarieEditare(tipAvarieEditId: number | undefined, body: TipAvarieDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/TipAvarieEditare?";
        if (tipAvarieEditId === null)
            throw new Error("The parameter 'tipAvarieEditId' cannot be null.");
        else if (tipAvarieEditId !== undefined)
            url_ += "tipAvarieEditId=" + encodeURIComponent("" + tipAvarieEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipAvarieEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipAvarieId (optional) 
     * @return Success
     */
    tipAvarieEditarePrecompletare(tipAvarieId: number | undefined): Observable<TipAvarieDto> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/TipAvarieEditarePrecompletare?";
        if (tipAvarieId === null)
            throw new Error("The parameter 'tipAvarieId' cannot be null.");
        else if (tipAvarieId !== undefined)
            url_ += "tipAvarieId=" + encodeURIComponent("" + tipAvarieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto>;
        }));
    }

    protected processTipAvarieEditarePrecompletare(response: HttpResponseBase): Observable<TipAvarieDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipAvarieDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto>(null as any);
    }

    /**
     * @param tipAvarieId (optional) 
     * @return Success
     */
    getTipAvarie(tipAvarieId: number | undefined): Observable<TipAvarieDto> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/GetTipAvarie?";
        if (tipAvarieId === null)
            throw new Error("The parameter 'tipAvarieId' cannot be null.");
        else if (tipAvarieId !== undefined)
            url_ += "tipAvarieId=" + encodeURIComponent("" + tipAvarieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipAvarie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipAvarie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto>;
        }));
    }

    protected processGetTipAvarie(response: HttpResponseBase): Observable<TipAvarieDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipAvarieDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<TipAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<TipAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<TipAvarieDto> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<TipAvarieDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipAvarieDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto>(null as any);
    }

    /**
     * @return Success
     */
    tipAvarieListDropDownSort(): Observable<TipAvarieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipAvarie/TipAvarieListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipAvarieListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipAvarieListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipAvarieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipAvarieDto[]>;
        }));
    }

    protected processTipAvarieListDropDownSort(response: HttpResponseBase): Observable<TipAvarieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipAvarieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipAvarieDto[]>(null as any);
    }
}

@Injectable()
export class TipDimensionalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tipDimensionalAdaugare(body: TipDimensionalDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/TipDimensionalAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTipDimensionalAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    tipDimensionalList(): Observable<TipDimensionalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/TipDimensionalList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto[]>;
        }));
    }

    protected processTipDimensionalList(response: HttpResponseBase): Observable<TipDimensionalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipDimensionalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto[]>(null as any);
    }

    /**
     * @param tipDimensionalId (optional) 
     * @return Success
     */
    tipDimensionalDelete(tipDimensionalId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/TipDimensionalDelete?";
        if (tipDimensionalId === null)
            throw new Error("The parameter 'tipDimensionalId' cannot be null.");
        else if (tipDimensionalId !== undefined)
            url_ += "tipDimensionalId=" + encodeURIComponent("" + tipDimensionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipDimensionalDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipDimensionalEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    tipDimensionalEditare(tipDimensionalEditId: number | undefined, body: TipDimensionalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/TipDimensionalEditare?";
        if (tipDimensionalEditId === null)
            throw new Error("The parameter 'tipDimensionalEditId' cannot be null.");
        else if (tipDimensionalEditId !== undefined)
            url_ += "tipDimensionalEditId=" + encodeURIComponent("" + tipDimensionalEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipDimensionalEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipDimensionalId (optional) 
     * @return Success
     */
    tipDimensionalEditarePrecompletare(tipDimensionalId: number | undefined): Observable<TipDimensionalDto> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/TipDimensionalEditarePrecompletare?";
        if (tipDimensionalId === null)
            throw new Error("The parameter 'tipDimensionalId' cannot be null.");
        else if (tipDimensionalId !== undefined)
            url_ += "tipDimensionalId=" + encodeURIComponent("" + tipDimensionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipDimensionalEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipDimensionalEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto>;
        }));
    }

    protected processTipDimensionalEditarePrecompletare(response: HttpResponseBase): Observable<TipDimensionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipDimensionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto>(null as any);
    }

    /**
     * @param tipDimensionalId (optional) 
     * @return Success
     */
    getTipDimensional(tipDimensionalId: number | undefined): Observable<TipDimensionalDto> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/GetTipDimensional?";
        if (tipDimensionalId === null)
            throw new Error("The parameter 'tipDimensionalId' cannot be null.");
        else if (tipDimensionalId !== undefined)
            url_ += "tipDimensionalId=" + encodeURIComponent("" + tipDimensionalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipDimensional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipDimensional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto>;
        }));
    }

    protected processGetTipDimensional(response: HttpResponseBase): Observable<TipDimensionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipDimensionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<TipDimensionalDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<TipDimensionalDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipDimensionalDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<TipDimensionalDto> {
        let url_ = this.baseUrl + "/api/services/app/TipDimensional/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipDimensionalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipDimensionalDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<TipDimensionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipDimensionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipDimensionalDto>(null as any);
    }
}

@Injectable()
export class TipElementAvariatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tipElementAvariatAdaugare(body: TipElementAvariatEditDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/TipElementAvariatAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipElementAvariatAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipElementAvariatAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTipElementAvariatAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    tipElementAvariatListDropDownSort(): Observable<TipElementAvariatDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/TipElementAvariatListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipElementAvariatListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipElementAvariatListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipElementAvariatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipElementAvariatDto[]>;
        }));
    }

    protected processTipElementAvariatListDropDownSort(response: HttpResponseBase): Observable<TipElementAvariatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipElementAvariatDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipElementAvariatDto[]>(null as any);
    }

    /**
     * @param tipElementAvariatId (optional) 
     * @return Success
     */
    tipElementAvariatDelete(tipElementAvariatId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/TipElementAvariatDelete?";
        if (tipElementAvariatId === null)
            throw new Error("The parameter 'tipElementAvariatId' cannot be null.");
        else if (tipElementAvariatId !== undefined)
            url_ += "TipElementAvariatId=" + encodeURIComponent("" + tipElementAvariatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipElementAvariatDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipElementAvariatDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipElementAvariatDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipElementAvariatEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    tipElementAvariatEditare(tipElementAvariatEditId: number | undefined, body: TipElementAvariatEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/TipElementAvariatEditare?";
        if (tipElementAvariatEditId === null)
            throw new Error("The parameter 'tipElementAvariatEditId' cannot be null.");
        else if (tipElementAvariatEditId !== undefined)
            url_ += "TipElementAvariatEditId=" + encodeURIComponent("" + tipElementAvariatEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipElementAvariatEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipElementAvariatEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipElementAvariatEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipElementAvariatId (optional) 
     * @return Success
     */
    tipElementAvariatEditarePrecompletare(tipElementAvariatId: number | undefined): Observable<TipElementAvariatEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/TipElementAvariatEditarePrecompletare?";
        if (tipElementAvariatId === null)
            throw new Error("The parameter 'tipElementAvariatId' cannot be null.");
        else if (tipElementAvariatId !== undefined)
            url_ += "TipElementAvariatId=" + encodeURIComponent("" + tipElementAvariatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipElementAvariatEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipElementAvariatEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipElementAvariatEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipElementAvariatEditDto>;
        }));
    }

    protected processTipElementAvariatEditarePrecompletare(response: HttpResponseBase): Observable<TipElementAvariatEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipElementAvariatEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipElementAvariatEditDto>(null as any);
    }

    /**
     * @param tipElementAvariatId (optional) 
     * @return Success
     */
    getTipElementAvariat(tipElementAvariatId: number | undefined): Observable<TipElementAvariatDto> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/GetTipElementAvariat?";
        if (tipElementAvariatId === null)
            throw new Error("The parameter 'tipElementAvariatId' cannot be null.");
        else if (tipElementAvariatId !== undefined)
            url_ += "TipElementAvariatId=" + encodeURIComponent("" + tipElementAvariatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipElementAvariat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipElementAvariat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipElementAvariatDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipElementAvariatDto>;
        }));
    }

    protected processGetTipElementAvariat(response: HttpResponseBase): Observable<TipElementAvariatDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipElementAvariatDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipElementAvariatDto>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<TipElementAvariatEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipElementAvariatEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipElementAvariatEditDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<TipElementAvariatEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipElementAvariatEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipElementAvariatEditDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @param categorieElementId (optional) 
     * @return Success
     */
    tipElementAvariatList(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined, categorieElementId: number | null | undefined): Observable<TipElementAvariatDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipElementAvariat/TipElementAvariatList?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        if (categorieElementId !== undefined && categorieElementId !== null)
            url_ += "categorieElementId=" + encodeURIComponent("" + categorieElementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipElementAvariatList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipElementAvariatList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipElementAvariatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipElementAvariatDto[]>;
        }));
    }

    protected processTipElementAvariatList(response: HttpResponseBase): Observable<TipElementAvariatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipElementAvariatDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipElementAvariatDto[]>(null as any);
    }
}

@Injectable()
export class TipSpatiuServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tipSpatiuAdaugare(body: TipSpatiuDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/TipSpatiuAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipSpatiuAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipSpatiuAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTipSpatiuAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    tipSpatiuList(): Observable<TipSpatiuDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/TipSpatiuList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipSpatiuList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipSpatiuList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuDto[]>;
        }));
    }

    protected processTipSpatiuList(response: HttpResponseBase): Observable<TipSpatiuDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipSpatiuDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuDto[]>(null as any);
    }

    /**
     * @param tipSpatiuId (optional) 
     * @return Success
     */
    tipSpatiuDelete(tipSpatiuId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/TipSpatiuDelete?";
        if (tipSpatiuId === null)
            throw new Error("The parameter 'tipSpatiuId' cannot be null.");
        else if (tipSpatiuId !== undefined)
            url_ += "tipSpatiuId=" + encodeURIComponent("" + tipSpatiuId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipSpatiuDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipSpatiuDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipSpatiuDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipSpatiuEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    tipSpatiuEditare(tipSpatiuEditId: number | undefined, body: TipSpatiuDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/TipSpatiuEditare?";
        if (tipSpatiuEditId === null)
            throw new Error("The parameter 'tipSpatiuEditId' cannot be null.");
        else if (tipSpatiuEditId !== undefined)
            url_ += "tipSpatiuEditId=" + encodeURIComponent("" + tipSpatiuEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipSpatiuEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipSpatiuEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipSpatiuEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipSpatiuId (optional) 
     * @return Success
     */
    tipSpatiuEditarePrecompletare(tipSpatiuId: number | undefined): Observable<TipSpatiuDto> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/TipSpatiuEditarePrecompletare?";
        if (tipSpatiuId === null)
            throw new Error("The parameter 'tipSpatiuId' cannot be null.");
        else if (tipSpatiuId !== undefined)
            url_ += "tipSpatiuId=" + encodeURIComponent("" + tipSpatiuId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipSpatiuEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipSpatiuEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuDto>;
        }));
    }

    protected processTipSpatiuEditarePrecompletare(response: HttpResponseBase): Observable<TipSpatiuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipSpatiuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuDto>(null as any);
    }

    /**
     * @param tipSpatiuId (optional) 
     * @return Success
     */
    getTipSpatiu(tipSpatiuId: number | undefined): Observable<TipSpatiuDto> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/GetTipSpatiu?";
        if (tipSpatiuId === null)
            throw new Error("The parameter 'tipSpatiuId' cannot be null.");
        else if (tipSpatiuId !== undefined)
            url_ += "tipSpatiuId=" + encodeURIComponent("" + tipSpatiuId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipSpatiu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipSpatiu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuDto>;
        }));
    }

    protected processGetTipSpatiu(response: HttpResponseBase): Observable<TipSpatiuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipSpatiuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<TipSpatiuDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<TipSpatiuDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipSpatiuDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<TipSpatiuDto> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<TipSpatiuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipSpatiuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuDto>(null as any);
    }

    /**
     * @return Success
     */
    tipSpatiuDropDownSort(): Observable<TipSpatiuDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipSpatiu/TipSpatiuDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipSpatiuDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipSpatiuDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipSpatiuDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipSpatiuDto[]>;
        }));
    }

    protected processTipSpatiuDropDownSort(response: HttpResponseBase): Observable<TipSpatiuDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipSpatiuDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipSpatiuDto[]>(null as any);
    }
}

@Injectable()
export class TipZonaAvariataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tipZonaAvariataAdaugare(body: TipZonaAvariataDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/TipZonaAvariataAdaugare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipZonaAvariataAdaugare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipZonaAvariataAdaugare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTipZonaAvariataAdaugare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    tipZonaAvariataList(): Observable<TipZonaAvariataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/TipZonaAvariataList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipZonaAvariataList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipZonaAvariataList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataDto[]>;
        }));
    }

    protected processTipZonaAvariataList(response: HttpResponseBase): Observable<TipZonaAvariataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipZonaAvariataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataDto[]>(null as any);
    }

    /**
     * @return Success
     */
    tipZonaAvariataListDropDownSort(): Observable<TipZonaAvariataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/TipZonaAvariataListDropDownSort";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipZonaAvariataListDropDownSort(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipZonaAvariataListDropDownSort(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataDto[]>;
        }));
    }

    protected processTipZonaAvariataListDropDownSort(response: HttpResponseBase): Observable<TipZonaAvariataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipZonaAvariataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataDto[]>(null as any);
    }

    /**
     * @param tipZonaAvariataId (optional) 
     * @return Success
     */
    tipZonaAvariataDelete(tipZonaAvariataId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/TipZonaAvariataDelete?";
        if (tipZonaAvariataId === null)
            throw new Error("The parameter 'tipZonaAvariataId' cannot be null.");
        else if (tipZonaAvariataId !== undefined)
            url_ += "tipZonaAvariataId=" + encodeURIComponent("" + tipZonaAvariataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipZonaAvariataDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipZonaAvariataDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipZonaAvariataDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipZonaAvariataEditId (optional) 
     * @param body (optional) 
     * @return Success
     */
    tipZonaAvariataEditare(tipZonaAvariataEditId: number | undefined, body: TipZonaAvariataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/TipZonaAvariataEditare?";
        if (tipZonaAvariataEditId === null)
            throw new Error("The parameter 'tipZonaAvariataEditId' cannot be null.");
        else if (tipZonaAvariataEditId !== undefined)
            url_ += "tipZonaAvariataEditId=" + encodeURIComponent("" + tipZonaAvariataEditId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipZonaAvariataEditare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipZonaAvariataEditare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTipZonaAvariataEditare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tipZonaAvariataId (optional) 
     * @return Success
     */
    tipZonaAvariataEditarePrecompletare(tipZonaAvariataId: number | undefined): Observable<TipZonaAvariataDto> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/TipZonaAvariataEditarePrecompletare?";
        if (tipZonaAvariataId === null)
            throw new Error("The parameter 'tipZonaAvariataId' cannot be null.");
        else if (tipZonaAvariataId !== undefined)
            url_ += "tipZonaAvariataId=" + encodeURIComponent("" + tipZonaAvariataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTipZonaAvariataEditarePrecompletare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTipZonaAvariataEditarePrecompletare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataDto>;
        }));
    }

    protected processTipZonaAvariataEditarePrecompletare(response: HttpResponseBase): Observable<TipZonaAvariataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipZonaAvariataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataDto>(null as any);
    }

    /**
     * @param tipZonaAvariataId (optional) 
     * @return Success
     */
    getTipZonaAvariata(tipZonaAvariataId: number | undefined): Observable<TipZonaAvariataDto> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/GetTipZonaAvariata?";
        if (tipZonaAvariataId === null)
            throw new Error("The parameter 'tipZonaAvariataId' cannot be null.");
        else if (tipZonaAvariataId !== undefined)
            url_ += "tipZonaAvariataId=" + encodeURIComponent("" + tipZonaAvariataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTipZonaAvariata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTipZonaAvariata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataDto>;
        }));
    }

    protected processGetTipZonaAvariata(response: HttpResponseBase): Observable<TipZonaAvariataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipZonaAvariataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataDto>(null as any);
    }

    /**
     * @param dataStart (optional) 
     * @param dataEnd (optional) 
     * @return Success
     */
    listaFiltruData(dataStart: moment.Moment | undefined, dataEnd: moment.Moment | undefined): Observable<TipZonaAvariataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/ListaFiltruData?";
        if (dataStart === null)
            throw new Error("The parameter 'dataStart' cannot be null.");
        else if (dataStart !== undefined)
            url_ += "dataStart=" + encodeURIComponent(dataStart ? "" + dataStart.toISOString() : "") + "&";
        if (dataEnd === null)
            throw new Error("The parameter 'dataEnd' cannot be null.");
        else if (dataEnd !== undefined)
            url_ += "dataEnd=" + encodeURIComponent(dataEnd ? "" + dataEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListaFiltruData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListaFiltruData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataDto[]>;
        }));
    }

    protected processListaFiltruData(response: HttpResponseBase): Observable<TipZonaAvariataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TipZonaAvariataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataDto[]>(null as any);
    }

    /**
     * @return Success
     */
    precompletareFiltru(): Observable<TipZonaAvariataDto> {
        let url_ = this.baseUrl + "/api/services/app/TipZonaAvariata/PrecompletareFiltru";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrecompletareFiltru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrecompletareFiltru(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TipZonaAvariataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TipZonaAvariataDto>;
        }));
    }

    protected processPrecompletareFiltru(response: HttpResponseBase): Observable<TipZonaAvariataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TipZonaAvariataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TipZonaAvariataDto>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    tokenAuthenticate(token: string | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/TokenAuthenticate?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processTokenAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export enum ArticolTip {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ArticolEditareDto implements IArticolEditareDto {
    idIntern: number;
    nume: string | undefined;
    articolTip: ArticolTip;
    tipDimensionalId: number | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;

    constructor(data?: IArticolEditareDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.articolTip = _data["articolTip"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticolEditareDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolEditareDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["articolTip"] = this.articolTip;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): ArticolEditareDto {
        const json = this.toJSON();
        let result = new ArticolEditareDto();
        result.init(json);
        return result;
    }
}

export interface IArticolEditareDto {
    idIntern: number;
    nume: string | undefined;
    articolTip: ArticolTip;
    tipDimensionalId: number | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
}

export class ArticolExportCSV implements IArticolExportCSV {
    idIntern: string | undefined;
    nume: string | undefined;
    tipArticol: string | undefined;
    pret: number | undefined;
    pretCalitInalta: number | undefined;
    pretCalitMedie: number | undefined;
    pretCalitNormala: number | undefined;

    constructor(data?: IArticolExportCSV) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.tipArticol = _data["tipArticol"];
            this.pret = _data["pret"];
            this.pretCalitInalta = _data["pretCalitInalta"];
            this.pretCalitMedie = _data["pretCalitMedie"];
            this.pretCalitNormala = _data["pretCalitNormala"];
        }
    }

    static fromJS(data: any): ArticolExportCSV {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolExportCSV();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["tipArticol"] = this.tipArticol;
        data["pret"] = this.pret;
        data["pretCalitInalta"] = this.pretCalitInalta;
        data["pretCalitMedie"] = this.pretCalitMedie;
        data["pretCalitNormala"] = this.pretCalitNormala;
        return data;
    }

    clone(): ArticolExportCSV {
        const json = this.toJSON();
        let result = new ArticolExportCSV();
        result.init(json);
        return result;
    }
}

export interface IArticolExportCSV {
    idIntern: string | undefined;
    nume: string | undefined;
    tipArticol: string | undefined;
    pret: number | undefined;
    pretCalitInalta: number | undefined;
    pretCalitMedie: number | undefined;
    pretCalitNormala: number | undefined;
}

export enum Stare {
    _0 = 0,
    _1 = 1,
}

export class ArticolDto implements IArticolDto {
    tenantId: number;
    id: number;
    idIntern: number;
    nume: string | undefined;
    articolTip: ArticolTip;
    articolTipString: string | undefined;
    tipDimensionalId: number | undefined;
    tipDimensional: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;

    constructor(data?: IArticolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.articolTip = _data["articolTip"];
            this.articolTipString = _data["articolTipString"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.tipDimensional = _data["tipDimensional"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["articolTip"] = this.articolTip;
        data["articolTipString"] = this.articolTipString;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["tipDimensional"] = this.tipDimensional;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): ArticolDto {
        const json = this.toJSON();
        let result = new ArticolDto();
        result.init(json);
        return result;
    }
}

export interface IArticolDto {
    tenantId: number;
    id: number;
    idIntern: number;
    nume: string | undefined;
    articolTip: ArticolTip;
    articolTipString: string | undefined;
    tipDimensionalId: number | undefined;
    tipDimensional: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
}

export class TipDimensionalDto implements ITipDimensionalDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    unitateMasura: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: ITipDimensionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.unitateMasura = _data["unitateMasura"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): TipDimensionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipDimensionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["unitateMasura"] = this.unitateMasura;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): TipDimensionalDto {
        const json = this.toJSON();
        let result = new TipDimensionalDto();
        result.init(json);
        return result;
    }
}

export interface ITipDimensionalDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    unitateMasura: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export class ArticolDevizDto implements IArticolDevizDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    articolDevizCategorieId: number | undefined;
    articolDevizCategorie: string | undefined;
    tipDimensionalId: number;
    tipDimensional: string | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    stare: Stare;
    orderView: number;

    constructor(data?: IArticolDevizDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.articolDevizCategorieId = _data["articolDevizCategorieId"];
            this.articolDevizCategorie = _data["articolDevizCategorie"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.tipDimensional = _data["tipDimensional"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.stare = _data["stare"];
            this.orderView = _data["orderView"];
        }
    }

    static fromJS(data: any): ArticolDevizDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolDevizDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["articolDevizCategorieId"] = this.articolDevizCategorieId;
        data["articolDevizCategorie"] = this.articolDevizCategorie;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["tipDimensional"] = this.tipDimensional;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["stare"] = this.stare;
        data["orderView"] = this.orderView;
        return data;
    }

    clone(): ArticolDevizDto {
        const json = this.toJSON();
        let result = new ArticolDevizDto();
        result.init(json);
        return result;
    }
}

export interface IArticolDevizDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    articolDevizCategorieId: number | undefined;
    articolDevizCategorie: string | undefined;
    tipDimensionalId: number;
    tipDimensional: string | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    stare: Stare;
    orderView: number;
}

export class ArticolDevizDetaliiDto implements IArticolDevizDetaliiDto {
    id: number;
    nume: string | undefined;
    tipDimensionalId: number;
    tipDimensional: string | undefined;
    articolTip: string | undefined;
    cantitate: number;
    articolDevizId: number;
    articolId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;

    constructor(data?: IArticolDevizDetaliiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.tipDimensional = _data["tipDimensional"];
            this.articolTip = _data["articolTip"];
            this.cantitate = _data["cantitate"];
            this.articolDevizId = _data["articolDevizId"];
            this.articolId = _data["articolId"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.orderView = _data["orderView"];
        }
    }

    static fromJS(data: any): ArticolDevizDetaliiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolDevizDetaliiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["tipDimensional"] = this.tipDimensional;
        data["articolTip"] = this.articolTip;
        data["cantitate"] = this.cantitate;
        data["articolDevizId"] = this.articolDevizId;
        data["articolId"] = this.articolId;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["orderView"] = this.orderView;
        return data;
    }

    clone(): ArticolDevizDetaliiDto {
        const json = this.toJSON();
        let result = new ArticolDevizDetaliiDto();
        result.init(json);
        return result;
    }
}

export interface IArticolDevizDetaliiDto {
    id: number;
    nume: string | undefined;
    tipDimensionalId: number;
    tipDimensional: string | undefined;
    articolTip: string | undefined;
    cantitate: number;
    articolDevizId: number;
    articolId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;
}

export class ArticolDevizDetaliiEditDto implements IArticolDevizDetaliiEditDto {
    nume: string | undefined;
    cantitate: number;
    articolDevizId: number;
    articolId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;

    constructor(data?: IArticolDevizDetaliiEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nume = _data["nume"];
            this.cantitate = _data["cantitate"];
            this.articolDevizId = _data["articolDevizId"];
            this.articolId = _data["articolId"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.orderView = _data["orderView"];
        }
    }

    static fromJS(data: any): ArticolDevizDetaliiEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolDevizDetaliiEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nume"] = this.nume;
        data["cantitate"] = this.cantitate;
        data["articolDevizId"] = this.articolDevizId;
        data["articolId"] = this.articolId;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["orderView"] = this.orderView;
        return data;
    }

    clone(): ArticolDevizDetaliiEditDto {
        const json = this.toJSON();
        let result = new ArticolDevizDetaliiEditDto();
        result.init(json);
        return result;
    }
}

export interface IArticolDevizDetaliiEditDto {
    nume: string | undefined;
    cantitate: number;
    articolDevizId: number;
    articolId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;
}

export class ArticolDevizCategorieDto implements IArticolDevizCategorieDto {
    id: number;
    nume: string | undefined;
    stare: Stare;
    tenantId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;

    constructor(data?: IArticolDevizCategorieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.tenantId = _data["tenantId"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticolDevizCategorieDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolDevizCategorieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["tenantId"] = this.tenantId;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): ArticolDevizCategorieDto {
        const json = this.toJSON();
        let result = new ArticolDevizCategorieDto();
        result.init(json);
        return result;
    }
}

export interface IArticolDevizCategorieDto {
    id: number;
    nume: string | undefined;
    stare: Stare;
    tenantId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
}

export class ArticolPretDto implements IArticolPretDto {
    tenantId: number;
    id: number;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    articolString: string | undefined;
    articolId: number;
    idIntern: number;
    pret: number | undefined;
    pretCalitInalta: number | undefined;
    pretCalitMedie: number | undefined;
    pretCalitNormala: number | undefined;

    constructor(data?: IArticolPretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.articolString = _data["articolString"];
            this.articolId = _data["articolId"];
            this.idIntern = _data["idIntern"];
            this.pret = _data["pret"];
            this.pretCalitInalta = _data["pretCalitInalta"];
            this.pretCalitMedie = _data["pretCalitMedie"];
            this.pretCalitNormala = _data["pretCalitNormala"];
        }
    }

    static fromJS(data: any): ArticolPretDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolPretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["articolString"] = this.articolString;
        data["articolId"] = this.articolId;
        data["idIntern"] = this.idIntern;
        data["pret"] = this.pret;
        data["pretCalitInalta"] = this.pretCalitInalta;
        data["pretCalitMedie"] = this.pretCalitMedie;
        data["pretCalitNormala"] = this.pretCalitNormala;
        return data;
    }

    clone(): ArticolPretDto {
        const json = this.toJSON();
        let result = new ArticolPretDto();
        result.init(json);
        return result;
    }
}

export interface IArticolPretDto {
    tenantId: number;
    id: number;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    articolString: string | undefined;
    articolId: number;
    idIntern: number;
    pret: number | undefined;
    pretCalitInalta: number | undefined;
    pretCalitMedie: number | undefined;
    pretCalitNormala: number | undefined;
}

export class BmkProcTipArticolDto implements IBmkProcTipArticolDto {
    tenantId: number;
    id: number;
    dataCalc: moment.Moment;
    nrDevizeGenerate: number;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    valoareDespagubita: number;
    valoareDiffZiPrec: number;

    constructor(data?: IBmkProcTipArticolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.dataCalc = _data["dataCalc"] ? moment(_data["dataCalc"].toString()) : <any>undefined;
            this.nrDevizeGenerate = _data["nrDevizeGenerate"];
            this.procMateriale = _data["procMateriale"];
            this.procManopera = _data["procManopera"];
            this.procUtilaje = _data["procUtilaje"];
            this.procTransport = _data["procTransport"];
            this.valoareDespagubita = _data["valoareDespagubita"];
            this.valoareDiffZiPrec = _data["valoareDiffZiPrec"];
        }
    }

    static fromJS(data: any): BmkProcTipArticolDto {
        data = typeof data === 'object' ? data : {};
        let result = new BmkProcTipArticolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["dataCalc"] = this.dataCalc ? this.dataCalc.toISOString() : <any>undefined;
        data["nrDevizeGenerate"] = this.nrDevizeGenerate;
        data["procMateriale"] = this.procMateriale;
        data["procManopera"] = this.procManopera;
        data["procUtilaje"] = this.procUtilaje;
        data["procTransport"] = this.procTransport;
        data["valoareDespagubita"] = this.valoareDespagubita;
        data["valoareDiffZiPrec"] = this.valoareDiffZiPrec;
        return data;
    }

    clone(): BmkProcTipArticolDto {
        const json = this.toJSON();
        let result = new BmkProcTipArticolDto();
        result.init(json);
        return result;
    }
}

export interface IBmkProcTipArticolDto {
    tenantId: number;
    id: number;
    dataCalc: moment.Moment;
    nrDevizeGenerate: number;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    valoareDespagubita: number;
    valoareDiffZiPrec: number;
}

export class BmkProcTipArticolAvEConsDto implements IBmkProcTipArticolAvEConsDto {
    tenantId: number;
    id: number;
    dataCalc: moment.Moment;
    tipAvarieId: number;
    tipAvarieString: string | undefined;
    elementConstructivId: number;
    elementConstructivString: string | undefined;
    nrDevizeGenerate: number;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    valoareDespagubita: number;
    valoareDiffZiPrec: number;

    constructor(data?: IBmkProcTipArticolAvEConsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.dataCalc = _data["dataCalc"] ? moment(_data["dataCalc"].toString()) : <any>undefined;
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarieString = _data["tipAvarieString"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.elementConstructivString = _data["elementConstructivString"];
            this.nrDevizeGenerate = _data["nrDevizeGenerate"];
            this.procMateriale = _data["procMateriale"];
            this.procManopera = _data["procManopera"];
            this.procUtilaje = _data["procUtilaje"];
            this.procTransport = _data["procTransport"];
            this.valoareDespagubita = _data["valoareDespagubita"];
            this.valoareDiffZiPrec = _data["valoareDiffZiPrec"];
        }
    }

    static fromJS(data: any): BmkProcTipArticolAvEConsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BmkProcTipArticolAvEConsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["dataCalc"] = this.dataCalc ? this.dataCalc.toISOString() : <any>undefined;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarieString"] = this.tipAvarieString;
        data["elementConstructivId"] = this.elementConstructivId;
        data["elementConstructivString"] = this.elementConstructivString;
        data["nrDevizeGenerate"] = this.nrDevizeGenerate;
        data["procMateriale"] = this.procMateriale;
        data["procManopera"] = this.procManopera;
        data["procUtilaje"] = this.procUtilaje;
        data["procTransport"] = this.procTransport;
        data["valoareDespagubita"] = this.valoareDespagubita;
        data["valoareDiffZiPrec"] = this.valoareDiffZiPrec;
        return data;
    }

    clone(): BmkProcTipArticolAvEConsDto {
        const json = this.toJSON();
        let result = new BmkProcTipArticolAvEConsDto();
        result.init(json);
        return result;
    }
}

export interface IBmkProcTipArticolAvEConsDto {
    tenantId: number;
    id: number;
    dataCalc: moment.Moment;
    tipAvarieId: number;
    tipAvarieString: string | undefined;
    elementConstructivId: number;
    elementConstructivString: string | undefined;
    nrDevizeGenerate: number;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    valoareDespagubita: number;
    valoareDiffZiPrec: number;
}

export class DataStartEndDto implements IDataStartEndDto {
    dataStart: moment.Moment;
    dataEnd: moment.Moment;

    constructor(data?: IDataStartEndDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DataStartEndDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataStartEndDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): DataStartEndDto {
        const json = this.toJSON();
        let result = new DataStartEndDto();
        result.init(json);
        return result;
    }
}

export interface IDataStartEndDto {
    dataStart: moment.Moment;
    dataEnd: moment.Moment;
}

export class AfisareDevizSiBenchmarkDto implements IAfisareDevizSiBenchmarkDto {
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    benchProcMateriale: number;
    benchProcManopera: number;
    benchProcUtilaje: number;
    benchProcTransport: number;
    benchCurentProcMateriale: number;
    benchCurentProcManopera: number;
    benchCurentProcUtilaje: number;
    benchCurentProcTransport: number;

    constructor(data?: IAfisareDevizSiBenchmarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            this.procMateriale = _data["procMateriale"];
            this.procManopera = _data["procManopera"];
            this.procUtilaje = _data["procUtilaje"];
            this.procTransport = _data["procTransport"];
            this.benchProcMateriale = _data["benchProcMateriale"];
            this.benchProcManopera = _data["benchProcManopera"];
            this.benchProcUtilaje = _data["benchProcUtilaje"];
            this.benchProcTransport = _data["benchProcTransport"];
            this.benchCurentProcMateriale = _data["benchCurentProcMateriale"];
            this.benchCurentProcManopera = _data["benchCurentProcManopera"];
            this.benchCurentProcUtilaje = _data["benchCurentProcUtilaje"];
            this.benchCurentProcTransport = _data["benchCurentProcTransport"];
        }
    }

    static fromJS(data: any): AfisareDevizSiBenchmarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new AfisareDevizSiBenchmarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        data["procMateriale"] = this.procMateriale;
        data["procManopera"] = this.procManopera;
        data["procUtilaje"] = this.procUtilaje;
        data["procTransport"] = this.procTransport;
        data["benchProcMateriale"] = this.benchProcMateriale;
        data["benchProcManopera"] = this.benchProcManopera;
        data["benchProcUtilaje"] = this.benchProcUtilaje;
        data["benchProcTransport"] = this.benchProcTransport;
        data["benchCurentProcMateriale"] = this.benchCurentProcMateriale;
        data["benchCurentProcManopera"] = this.benchCurentProcManopera;
        data["benchCurentProcUtilaje"] = this.benchCurentProcUtilaje;
        data["benchCurentProcTransport"] = this.benchCurentProcTransport;
        return data;
    }

    clone(): AfisareDevizSiBenchmarkDto {
        const json = this.toJSON();
        let result = new AfisareDevizSiBenchmarkDto();
        result.init(json);
        return result;
    }
}

export interface IAfisareDevizSiBenchmarkDto {
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    benchProcMateriale: number;
    benchProcManopera: number;
    benchProcUtilaje: number;
    benchProcTransport: number;
    benchCurentProcMateriale: number;
    benchCurentProcManopera: number;
    benchCurentProcUtilaje: number;
    benchCurentProcTransport: number;
}

export class AfisareDevizSiBenchmarkTipAvElemConstrDto implements IAfisareDevizSiBenchmarkTipAvElemConstrDto {
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    tipAvarieId: number;
    elementConstructivId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    benchProcMateriale: number;
    benchProcManopera: number;
    benchProcUtilaje: number;
    benchProcTransport: number;
    benchCurrentProcMateriale: number;
    benchCurrentProcManopera: number;
    benchCurrentProcUtilaje: number;
    benchCurrentProcTransport: number;

    constructor(data?: IAfisareDevizSiBenchmarkTipAvElemConstrDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            this.tipAvarieId = _data["tipAvarieId"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            this.procMateriale = _data["procMateriale"];
            this.procManopera = _data["procManopera"];
            this.procUtilaje = _data["procUtilaje"];
            this.procTransport = _data["procTransport"];
            this.benchProcMateriale = _data["benchProcMateriale"];
            this.benchProcManopera = _data["benchProcManopera"];
            this.benchProcUtilaje = _data["benchProcUtilaje"];
            this.benchProcTransport = _data["benchProcTransport"];
            this.benchCurrentProcMateriale = _data["benchCurrentProcMateriale"];
            this.benchCurrentProcManopera = _data["benchCurrentProcManopera"];
            this.benchCurrentProcUtilaje = _data["benchCurrentProcUtilaje"];
            this.benchCurrentProcTransport = _data["benchCurrentProcTransport"];
        }
    }

    static fromJS(data: any): AfisareDevizSiBenchmarkTipAvElemConstrDto {
        data = typeof data === 'object' ? data : {};
        let result = new AfisareDevizSiBenchmarkTipAvElemConstrDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        data["tipAvarieId"] = this.tipAvarieId;
        data["elementConstructivId"] = this.elementConstructivId;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["elementConstructivNume"] = this.elementConstructivNume;
        data["procMateriale"] = this.procMateriale;
        data["procManopera"] = this.procManopera;
        data["procUtilaje"] = this.procUtilaje;
        data["procTransport"] = this.procTransport;
        data["benchProcMateriale"] = this.benchProcMateriale;
        data["benchProcManopera"] = this.benchProcManopera;
        data["benchProcUtilaje"] = this.benchProcUtilaje;
        data["benchProcTransport"] = this.benchProcTransport;
        data["benchCurrentProcMateriale"] = this.benchCurrentProcMateriale;
        data["benchCurrentProcManopera"] = this.benchCurrentProcManopera;
        data["benchCurrentProcUtilaje"] = this.benchCurrentProcUtilaje;
        data["benchCurrentProcTransport"] = this.benchCurrentProcTransport;
        return data;
    }

    clone(): AfisareDevizSiBenchmarkTipAvElemConstrDto {
        const json = this.toJSON();
        let result = new AfisareDevizSiBenchmarkTipAvElemConstrDto();
        result.init(json);
        return result;
    }
}

export interface IAfisareDevizSiBenchmarkTipAvElemConstrDto {
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    tipAvarieId: number;
    elementConstructivId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    benchProcMateriale: number;
    benchProcManopera: number;
    benchProcUtilaje: number;
    benchProcTransport: number;
    benchCurrentProcMateriale: number;
    benchCurrentProcManopera: number;
    benchCurrentProcUtilaje: number;
    benchCurrentProcTransport: number;
}

export class BmkDeviatieLimitaDto implements IBmkDeviatieLimitaDto {
    tenantId: number;
    id: number;
    limitaMateriale: number;
    limitaManopera: number;
    limitaUtilaje: number;
    limitaTransport: number;
    edit: boolean;

    constructor(data?: IBmkDeviatieLimitaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.limitaMateriale = _data["limitaMateriale"];
            this.limitaManopera = _data["limitaManopera"];
            this.limitaUtilaje = _data["limitaUtilaje"];
            this.limitaTransport = _data["limitaTransport"];
            this.edit = _data["edit"];
        }
    }

    static fromJS(data: any): BmkDeviatieLimitaDto {
        data = typeof data === 'object' ? data : {};
        let result = new BmkDeviatieLimitaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["limitaMateriale"] = this.limitaMateriale;
        data["limitaManopera"] = this.limitaManopera;
        data["limitaUtilaje"] = this.limitaUtilaje;
        data["limitaTransport"] = this.limitaTransport;
        data["edit"] = this.edit;
        return data;
    }

    clone(): BmkDeviatieLimitaDto {
        const json = this.toJSON();
        let result = new BmkDeviatieLimitaDto();
        result.init(json);
        return result;
    }
}

export interface IBmkDeviatieLimitaDto {
    tenantId: number;
    id: number;
    limitaMateriale: number;
    limitaManopera: number;
    limitaUtilaje: number;
    limitaTransport: number;
    edit: boolean;
}

export class TipAvarie implements ITipAvarie {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    avarieProfunda: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITipAvarie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.avarieProfunda = _data["avarieProfunda"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TipAvarie {
        data = typeof data === 'object' ? data : {};
        let result = new TipAvarie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["avarieProfunda"] = this.avarieProfunda;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TipAvarie {
        const json = this.toJSON();
        let result = new TipAvarie();
        result.init(json);
        return result;
    }
}

export interface ITipAvarie {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    avarieProfunda: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CategorieElement implements ICategorieElement {
    tipuriElementeAvariate: TipElementAvariat[] | undefined;
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICategorieElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipuriElementeAvariate"])) {
                this.tipuriElementeAvariate = [] as any;
                for (let item of _data["tipuriElementeAvariate"])
                    this.tipuriElementeAvariate.push(TipElementAvariat.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CategorieElement {
        data = typeof data === 'object' ? data : {};
        let result = new CategorieElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipuriElementeAvariate)) {
            data["tipuriElementeAvariate"] = [];
            for (let item of this.tipuriElementeAvariate)
                data["tipuriElementeAvariate"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CategorieElement {
        const json = this.toJSON();
        let result = new CategorieElement();
        result.init(json);
        return result;
    }
}

export interface ICategorieElement {
    tipuriElementeAvariate: TipElementAvariat[] | undefined;
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TipElementAvariat implements ITipElementAvariat {
    categorieElementId: number;
    elementeConstructive: ElementConstructiv[] | undefined;
    tenantId: number;
    nume: string | undefined;
    categorieElement: CategorieElement;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITipElementAvariat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categorieElementId = _data["categorieElementId"];
            if (Array.isArray(_data["elementeConstructive"])) {
                this.elementeConstructive = [] as any;
                for (let item of _data["elementeConstructive"])
                    this.elementeConstructive.push(ElementConstructiv.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.categorieElement = _data["categorieElement"] ? CategorieElement.fromJS(_data["categorieElement"]) : <any>undefined;
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TipElementAvariat {
        data = typeof data === 'object' ? data : {};
        let result = new TipElementAvariat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categorieElementId"] = this.categorieElementId;
        if (Array.isArray(this.elementeConstructive)) {
            data["elementeConstructive"] = [];
            for (let item of this.elementeConstructive)
                data["elementeConstructive"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["categorieElement"] = this.categorieElement ? this.categorieElement.toJSON() : <any>undefined;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TipElementAvariat {
        const json = this.toJSON();
        let result = new TipElementAvariat();
        result.init(json);
        return result;
    }
}

export interface ITipElementAvariat {
    categorieElementId: number;
    elementeConstructive: ElementConstructiv[] | undefined;
    tenantId: number;
    nume: string | undefined;
    categorieElement: CategorieElement;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ElementConstructiv implements IElementConstructiv {
    tipElementAvariatId: number;
    tenantId: number;
    nume: string | undefined;
    grosimeAprox: number | undefined;
    tipElementAvariat: TipElementAvariat;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IElementConstructiv) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipElementAvariatId = _data["tipElementAvariatId"];
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.grosimeAprox = _data["grosimeAprox"];
            this.tipElementAvariat = _data["tipElementAvariat"] ? TipElementAvariat.fromJS(_data["tipElementAvariat"]) : <any>undefined;
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElementConstructiv {
        data = typeof data === 'object' ? data : {};
        let result = new ElementConstructiv();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipElementAvariatId"] = this.tipElementAvariatId;
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["grosimeAprox"] = this.grosimeAprox;
        data["tipElementAvariat"] = this.tipElementAvariat ? this.tipElementAvariat.toJSON() : <any>undefined;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ElementConstructiv {
        const json = this.toJSON();
        let result = new ElementConstructiv();
        result.init(json);
        return result;
    }
}

export interface IElementConstructiv {
    tipElementAvariatId: number;
    tenantId: number;
    nume: string | undefined;
    grosimeAprox: number | undefined;
    tipElementAvariat: TipElementAvariat;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class BmkProcTipArticolAvECons implements IBmkProcTipArticolAvECons {
    tenantId: number;
    dataCalc: moment.Moment;
    tipAvarieId: number;
    tipAvarie: TipAvarie;
    elementConstructivId: number;
    elementConstructiv: ElementConstructiv;
    nrDevizeGenerate: number;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    valoareDespagubita: number;
    valoareDiffZiPrec: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBmkProcTipArticolAvECons) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.dataCalc = _data["dataCalc"] ? moment(_data["dataCalc"].toString()) : <any>undefined;
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarie = _data["tipAvarie"] ? TipAvarie.fromJS(_data["tipAvarie"]) : <any>undefined;
            this.elementConstructivId = _data["elementConstructivId"];
            this.elementConstructiv = _data["elementConstructiv"] ? ElementConstructiv.fromJS(_data["elementConstructiv"]) : <any>undefined;
            this.nrDevizeGenerate = _data["nrDevizeGenerate"];
            this.procMateriale = _data["procMateriale"];
            this.procManopera = _data["procManopera"];
            this.procUtilaje = _data["procUtilaje"];
            this.procTransport = _data["procTransport"];
            this.valoareDespagubita = _data["valoareDespagubita"];
            this.valoareDiffZiPrec = _data["valoareDiffZiPrec"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BmkProcTipArticolAvECons {
        data = typeof data === 'object' ? data : {};
        let result = new BmkProcTipArticolAvECons();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["dataCalc"] = this.dataCalc ? this.dataCalc.toISOString() : <any>undefined;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarie"] = this.tipAvarie ? this.tipAvarie.toJSON() : <any>undefined;
        data["elementConstructivId"] = this.elementConstructivId;
        data["elementConstructiv"] = this.elementConstructiv ? this.elementConstructiv.toJSON() : <any>undefined;
        data["nrDevizeGenerate"] = this.nrDevizeGenerate;
        data["procMateriale"] = this.procMateriale;
        data["procManopera"] = this.procManopera;
        data["procUtilaje"] = this.procUtilaje;
        data["procTransport"] = this.procTransport;
        data["valoareDespagubita"] = this.valoareDespagubita;
        data["valoareDiffZiPrec"] = this.valoareDiffZiPrec;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): BmkProcTipArticolAvECons {
        const json = this.toJSON();
        let result = new BmkProcTipArticolAvECons();
        result.init(json);
        return result;
    }
}

export interface IBmkProcTipArticolAvECons {
    tenantId: number;
    dataCalc: moment.Moment;
    tipAvarieId: number;
    tipAvarie: TipAvarie;
    elementConstructivId: number;
    elementConstructiv: ElementConstructiv;
    nrDevizeGenerate: number;
    procMateriale: number;
    procManopera: number;
    procUtilaje: number;
    procTransport: number;
    valoareDespagubita: number;
    valoareDiffZiPrec: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TipAvarieElemConstructivDto implements ITipAvarieElemConstructivDto {
    id: number;
    tipAvarieId: number;
    elementConstructivId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;

    constructor(data?: ITipAvarieElemConstructivDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.elementConstructivNume = _data["elementConstructivNume"];
        }
    }

    static fromJS(data: any): TipAvarieElemConstructivDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipAvarieElemConstructivDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipAvarieId"] = this.tipAvarieId;
        data["elementConstructivId"] = this.elementConstructivId;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["elementConstructivNume"] = this.elementConstructivNume;
        return data;
    }

    clone(): TipAvarieElemConstructivDto {
        const json = this.toJSON();
        let result = new TipAvarieElemConstructivDto();
        result.init(json);
        return result;
    }
}

export interface ITipAvarieElemConstructivDto {
    id: number;
    tipAvarieId: number;
    elementConstructivId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
}

export class BmkAbatereDto implements IBmkAbatereDto {
    id: number;
    abatereConstatVersId: number;
    abatereConstatId: number;
    abatereSuprafataAvariata: number;
    abatereValoareDeviz: number;
    abatereAdresa: string | undefined;
    abatereNrConstatare: string | undefined;
    abatereDataConstatare: moment.Moment;
    verificat: boolean;
    permissionCheck: boolean;

    constructor(data?: IBmkAbatereDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.abatereConstatVersId = _data["abatereConstatVersId"];
            this.abatereConstatId = _data["abatereConstatId"];
            this.abatereSuprafataAvariata = _data["abatereSuprafataAvariata"];
            this.abatereValoareDeviz = _data["abatereValoareDeviz"];
            this.abatereAdresa = _data["abatereAdresa"];
            this.abatereNrConstatare = _data["abatereNrConstatare"];
            this.abatereDataConstatare = _data["abatereDataConstatare"] ? moment(_data["abatereDataConstatare"].toString()) : <any>undefined;
            this.verificat = _data["verificat"];
            this.permissionCheck = _data["permissionCheck"];
        }
    }

    static fromJS(data: any): BmkAbatereDto {
        data = typeof data === 'object' ? data : {};
        let result = new BmkAbatereDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["abatereConstatVersId"] = this.abatereConstatVersId;
        data["abatereConstatId"] = this.abatereConstatId;
        data["abatereSuprafataAvariata"] = this.abatereSuprafataAvariata;
        data["abatereValoareDeviz"] = this.abatereValoareDeviz;
        data["abatereAdresa"] = this.abatereAdresa;
        data["abatereNrConstatare"] = this.abatereNrConstatare;
        data["abatereDataConstatare"] = this.abatereDataConstatare ? this.abatereDataConstatare.toISOString() : <any>undefined;
        data["verificat"] = this.verificat;
        data["permissionCheck"] = this.permissionCheck;
        return data;
    }

    clone(): BmkAbatereDto {
        const json = this.toJSON();
        let result = new BmkAbatereDto();
        result.init(json);
        return result;
    }
}

export interface IBmkAbatereDto {
    id: number;
    abatereConstatVersId: number;
    abatereConstatId: number;
    abatereSuprafataAvariata: number;
    abatereValoareDeviz: number;
    abatereAdresa: string | undefined;
    abatereNrConstatare: string | undefined;
    abatereDataConstatare: moment.Moment;
    verificat: boolean;
    permissionCheck: boolean;
}

export class BmkAnalizatMasterDto implements IBmkAnalizatMasterDto {
    tenantId: number;
    constatId: number;
    analizatConstatVersId: number;
    tipAvarieId: number;
    tipAvarieNume: string | undefined;
    analizatAdresa: string | undefined;
    analizatNrConstatare: string | undefined;
    analizatDataConstatare: moment.Moment;
    analizatSuprafataAvariata: number;
    analizatValoareDeviz: number;
    bmkAbatereDtos: BmkAbatereDto[] | undefined;
    permissionCheck: boolean;

    constructor(data?: IBmkAnalizatMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.constatId = _data["constatId"];
            this.analizatConstatVersId = _data["analizatConstatVersId"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.analizatAdresa = _data["analizatAdresa"];
            this.analizatNrConstatare = _data["analizatNrConstatare"];
            this.analizatDataConstatare = _data["analizatDataConstatare"] ? moment(_data["analizatDataConstatare"].toString()) : <any>undefined;
            this.analizatSuprafataAvariata = _data["analizatSuprafataAvariata"];
            this.analizatValoareDeviz = _data["analizatValoareDeviz"];
            if (Array.isArray(_data["bmkAbatereDtos"])) {
                this.bmkAbatereDtos = [] as any;
                for (let item of _data["bmkAbatereDtos"])
                    this.bmkAbatereDtos.push(BmkAbatereDto.fromJS(item));
            }
            this.permissionCheck = _data["permissionCheck"];
        }
    }

    static fromJS(data: any): BmkAnalizatMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new BmkAnalizatMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["constatId"] = this.constatId;
        data["analizatConstatVersId"] = this.analizatConstatVersId;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["analizatAdresa"] = this.analizatAdresa;
        data["analizatNrConstatare"] = this.analizatNrConstatare;
        data["analizatDataConstatare"] = this.analizatDataConstatare ? this.analizatDataConstatare.toISOString() : <any>undefined;
        data["analizatSuprafataAvariata"] = this.analizatSuprafataAvariata;
        data["analizatValoareDeviz"] = this.analizatValoareDeviz;
        if (Array.isArray(this.bmkAbatereDtos)) {
            data["bmkAbatereDtos"] = [];
            for (let item of this.bmkAbatereDtos)
                data["bmkAbatereDtos"].push(item.toJSON());
        }
        data["permissionCheck"] = this.permissionCheck;
        return data;
    }

    clone(): BmkAnalizatMasterDto {
        const json = this.toJSON();
        let result = new BmkAnalizatMasterDto();
        result.init(json);
        return result;
    }
}

export interface IBmkAnalizatMasterDto {
    tenantId: number;
    constatId: number;
    analizatConstatVersId: number;
    tipAvarieId: number;
    tipAvarieNume: string | undefined;
    analizatAdresa: string | undefined;
    analizatNrConstatare: string | undefined;
    analizatDataConstatare: moment.Moment;
    analizatSuprafataAvariata: number;
    analizatValoareDeviz: number;
    bmkAbatereDtos: BmkAbatereDto[] | undefined;
    permissionCheck: boolean;
}

export class BmkAnalizaAbatereLimitaDto implements IBmkAnalizaAbatereLimitaDto {
    id: number;
    procVarSuprafata: number;
    procVarValoare: number;
    edit: boolean;

    constructor(data?: IBmkAnalizaAbatereLimitaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.procVarSuprafata = _data["procVarSuprafata"];
            this.procVarValoare = _data["procVarValoare"];
            this.edit = _data["edit"];
        }
    }

    static fromJS(data: any): BmkAnalizaAbatereLimitaDto {
        data = typeof data === 'object' ? data : {};
        let result = new BmkAnalizaAbatereLimitaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["procVarSuprafata"] = this.procVarSuprafata;
        data["procVarValoare"] = this.procVarValoare;
        data["edit"] = this.edit;
        return data;
    }

    clone(): BmkAnalizaAbatereLimitaDto {
        const json = this.toJSON();
        let result = new BmkAnalizaAbatereLimitaDto();
        result.init(json);
        return result;
    }
}

export interface IBmkAnalizaAbatereLimitaDto {
    id: number;
    procVarSuprafata: number;
    procVarValoare: number;
    edit: boolean;
}

export class CategorieElementEditDto implements ICategorieElementEditDto {
    id: number;
    nume: string | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;

    constructor(data?: ICategorieElementEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CategorieElementEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorieElementEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): CategorieElementEditDto {
        const json = this.toJSON();
        let result = new CategorieElementEditDto();
        result.init(json);
        return result;
    }
}

export interface ICategorieElementEditDto {
    id: number;
    nume: string | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
}

export class CategorieElementDto implements ICategorieElementDto {
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: ICategorieElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): CategorieElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorieElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): CategorieElementDto {
        const json = this.toJSON();
        let result = new CategorieElementDto();
        result.init(json);
        return result;
    }
}

export interface ICategorieElementDto {
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export class CauzaAvarieDto implements ICauzaAvarieDto {
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: ICauzaAvarieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): CauzaAvarieDto {
        data = typeof data === 'object' ? data : {};
        let result = new CauzaAvarieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): CauzaAvarieDto {
        const json = this.toJSON();
        let result = new CauzaAvarieDto();
        result.init(json);
        return result;
    }
}

export interface ICauzaAvarieDto {
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ConstatListDto implements IConstatListDto {
    id: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    adaugatManual: boolean;

    constructor(data?: IConstatListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            this.nrContract = _data["nrContract"];
            this.dataContract = _data["dataContract"] ? moment(_data["dataContract"].toString()) : <any>undefined;
            this.adaugatManual = _data["adaugatManual"];
        }
    }

    static fromJS(data: any): ConstatListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        data["nrContract"] = this.nrContract;
        data["dataContract"] = this.dataContract ? this.dataContract.toISOString() : <any>undefined;
        data["adaugatManual"] = this.adaugatManual;
        return data;
    }

    clone(): ConstatListDto {
        const json = this.toJSON();
        let result = new ConstatListDto();
        result.init(json);
        return result;
    }
}

export interface IConstatListDto {
    id: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    adaugatManual: boolean;
}

export class ConstatVersListDto implements IConstatVersListDto {
    id: number;
    validat: boolean;
    creationTime: moment.Moment;

    constructor(data?: IConstatVersListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validat = _data["validat"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConstatVersListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatVersListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validat"] = this.validat;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ConstatVersListDto {
        const json = this.toJSON();
        let result = new ConstatVersListDto();
        result.init(json);
        return result;
    }
}

export interface IConstatVersListDto {
    id: number;
    validat: boolean;
    creationTime: moment.Moment;
}

export class ConstatViewDto implements IConstatViewDto {
    constatVersId: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    adresa: string | undefined;
    localitate: string | undefined;
    judet: string | undefined;
    tipSpatiu: string | undefined;
    adaugatManual: boolean;

    constructor(data?: IConstatViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constatVersId = _data["constatVersId"];
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            this.nrContract = _data["nrContract"];
            this.dataContract = _data["dataContract"] ? moment(_data["dataContract"].toString()) : <any>undefined;
            this.adresa = _data["adresa"];
            this.localitate = _data["localitate"];
            this.judet = _data["judet"];
            this.tipSpatiu = _data["tipSpatiu"];
            this.adaugatManual = _data["adaugatManual"];
        }
    }

    static fromJS(data: any): ConstatViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constatVersId"] = this.constatVersId;
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        data["nrContract"] = this.nrContract;
        data["dataContract"] = this.dataContract ? this.dataContract.toISOString() : <any>undefined;
        data["adresa"] = this.adresa;
        data["localitate"] = this.localitate;
        data["judet"] = this.judet;
        data["tipSpatiu"] = this.tipSpatiu;
        data["adaugatManual"] = this.adaugatManual;
        return data;
    }

    clone(): ConstatViewDto {
        const json = this.toJSON();
        let result = new ConstatViewDto();
        result.init(json);
        return result;
    }
}

export interface IConstatViewDto {
    constatVersId: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    adresa: string | undefined;
    localitate: string | undefined;
    judet: string | undefined;
    tipSpatiu: string | undefined;
    adaugatManual: boolean;
}

export class ConstatViewCameraPereteFinisajDto implements IConstatViewCameraPereteFinisajDto {
    elementConstructiv: string | undefined;

    constructor(data?: IConstatViewCameraPereteFinisajDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementConstructiv = _data["elementConstructiv"];
        }
    }

    static fromJS(data: any): ConstatViewCameraPereteFinisajDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatViewCameraPereteFinisajDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementConstructiv"] = this.elementConstructiv;
        return data;
    }

    clone(): ConstatViewCameraPereteFinisajDto {
        const json = this.toJSON();
        let result = new ConstatViewCameraPereteFinisajDto();
        result.init(json);
        return result;
    }
}

export interface IConstatViewCameraPereteFinisajDto {
    elementConstructiv: string | undefined;
}

export class ConstatViewCameraPereteDto implements IConstatViewCameraPereteDto {
    id: number;
    showDetalii: boolean;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    finisaje: ConstatViewCameraPereteFinisajDto[] | undefined;

    constructor(data?: IConstatViewCameraPereteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showDetalii = _data["showDetalii"];
            this.nrPerete = _data["nrPerete"];
            this.lungime = _data["lungime"];
            this.inaltime = _data["inaltime"];
            if (Array.isArray(_data["finisaje"])) {
                this.finisaje = [] as any;
                for (let item of _data["finisaje"])
                    this.finisaje.push(ConstatViewCameraPereteFinisajDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatViewCameraPereteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatViewCameraPereteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showDetalii"] = this.showDetalii;
        data["nrPerete"] = this.nrPerete;
        data["lungime"] = this.lungime;
        data["inaltime"] = this.inaltime;
        if (Array.isArray(this.finisaje)) {
            data["finisaje"] = [];
            for (let item of this.finisaje)
                data["finisaje"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatViewCameraPereteDto {
        const json = this.toJSON();
        let result = new ConstatViewCameraPereteDto();
        result.init(json);
        return result;
    }
}

export interface IConstatViewCameraPereteDto {
    id: number;
    showDetalii: boolean;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    finisaje: ConstatViewCameraPereteFinisajDto[] | undefined;
}

export class ConstatViewCameraDaunaPeretiDto implements IConstatViewCameraDaunaPeretiDto {
    id: number;
    nrPerete: number;
    lungimeAvariata: number;
    latimeAvariata: number;

    constructor(data?: IConstatViewCameraDaunaPeretiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nrPerete = _data["nrPerete"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
        }
    }

    static fromJS(data: any): ConstatViewCameraDaunaPeretiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatViewCameraDaunaPeretiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nrPerete"] = this.nrPerete;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        return data;
    }

    clone(): ConstatViewCameraDaunaPeretiDto {
        const json = this.toJSON();
        let result = new ConstatViewCameraDaunaPeretiDto();
        result.init(json);
        return result;
    }
}

export interface IConstatViewCameraDaunaPeretiDto {
    id: number;
    nrPerete: number;
    lungimeAvariata: number;
    latimeAvariata: number;
}

export class ConstatViewCameraDaunaDto implements IConstatViewCameraDaunaDto {
    id: number;
    showDetalii: boolean;
    cauzaAvarie: string | undefined;
    tipAvarie: string | undefined;
    elementConstructiv: string | undefined;
    tipDimensional: string | undefined;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatViewCameraDaunaPeretiDto[] | undefined;

    constructor(data?: IConstatViewCameraDaunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showDetalii = _data["showDetalii"];
            this.cauzaAvarie = _data["cauzaAvarie"];
            this.tipAvarie = _data["tipAvarie"];
            this.elementConstructiv = _data["elementConstructiv"];
            this.tipDimensional = _data["tipDimensional"];
            this.lungimeTotala = _data["lungimeTotala"];
            this.latimeTotala = _data["latimeTotala"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
            if (Array.isArray(_data["daunaPereti"])) {
                this.daunaPereti = [] as any;
                for (let item of _data["daunaPereti"])
                    this.daunaPereti.push(ConstatViewCameraDaunaPeretiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatViewCameraDaunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatViewCameraDaunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showDetalii"] = this.showDetalii;
        data["cauzaAvarie"] = this.cauzaAvarie;
        data["tipAvarie"] = this.tipAvarie;
        data["elementConstructiv"] = this.elementConstructiv;
        data["tipDimensional"] = this.tipDimensional;
        data["lungimeTotala"] = this.lungimeTotala;
        data["latimeTotala"] = this.latimeTotala;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        if (Array.isArray(this.daunaPereti)) {
            data["daunaPereti"] = [];
            for (let item of this.daunaPereti)
                data["daunaPereti"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatViewCameraDaunaDto {
        const json = this.toJSON();
        let result = new ConstatViewCameraDaunaDto();
        result.init(json);
        return result;
    }
}

export interface IConstatViewCameraDaunaDto {
    id: number;
    showDetalii: boolean;
    cauzaAvarie: string | undefined;
    tipAvarie: string | undefined;
    elementConstructiv: string | undefined;
    tipDimensional: string | undefined;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatViewCameraDaunaPeretiDto[] | undefined;
}

export class ConstatViewCameraDto implements IConstatViewCameraDto {
    id: number;
    showDetaliiPereti: boolean;
    showDetaliiDaune: boolean;
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariata: string | undefined;
    pereti: ConstatViewCameraPereteDto[] | undefined;
    daune: ConstatViewCameraDaunaDto[] | undefined;

    constructor(data?: IConstatViewCameraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.showDetaliiPereti = _data["showDetaliiPereti"];
            this.showDetaliiDaune = _data["showDetaliiDaune"];
            this.nrCamera = _data["nrCamera"];
            this.numeCamera = _data["numeCamera"];
            this.lungime = _data["lungime"];
            this.latime = _data["latime"];
            this.inaltime = _data["inaltime"];
            this.tipZonaAvariata = _data["tipZonaAvariata"];
            if (Array.isArray(_data["pereti"])) {
                this.pereti = [] as any;
                for (let item of _data["pereti"])
                    this.pereti.push(ConstatViewCameraPereteDto.fromJS(item));
            }
            if (Array.isArray(_data["daune"])) {
                this.daune = [] as any;
                for (let item of _data["daune"])
                    this.daune.push(ConstatViewCameraDaunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatViewCameraDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatViewCameraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["showDetaliiPereti"] = this.showDetaliiPereti;
        data["showDetaliiDaune"] = this.showDetaliiDaune;
        data["nrCamera"] = this.nrCamera;
        data["numeCamera"] = this.numeCamera;
        data["lungime"] = this.lungime;
        data["latime"] = this.latime;
        data["inaltime"] = this.inaltime;
        data["tipZonaAvariata"] = this.tipZonaAvariata;
        if (Array.isArray(this.pereti)) {
            data["pereti"] = [];
            for (let item of this.pereti)
                data["pereti"].push(item.toJSON());
        }
        if (Array.isArray(this.daune)) {
            data["daune"] = [];
            for (let item of this.daune)
                data["daune"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatViewCameraDto {
        const json = this.toJSON();
        let result = new ConstatViewCameraDto();
        result.init(json);
        return result;
    }
}

export interface IConstatViewCameraDto {
    id: number;
    showDetaliiPereti: boolean;
    showDetaliiDaune: boolean;
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariata: string | undefined;
    pereti: ConstatViewCameraPereteDto[] | undefined;
    daune: ConstatViewCameraDaunaDto[] | undefined;
}

export class TipSpatiuDto implements ITipSpatiuDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: ITipSpatiuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): TipSpatiuDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipSpatiuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): TipSpatiuDto {
        const json = this.toJSON();
        let result = new TipSpatiuDto();
        result.init(json);
        return result;
    }
}

export interface ITipSpatiuDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export enum TipConstatare {
    _0 = 0,
    _1 = 1,
}

export class ConstatAddCameraPereteFinisajDto implements IConstatAddCameraPereteFinisajDto {
    id: number;
    constatCameraPereteId: number;
    elementConstructivId: number;

    constructor(data?: IConstatAddCameraPereteFinisajDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.constatCameraPereteId = _data["constatCameraPereteId"];
            this.elementConstructivId = _data["elementConstructivId"];
        }
    }

    static fromJS(data: any): ConstatAddCameraPereteFinisajDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraPereteFinisajDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["constatCameraPereteId"] = this.constatCameraPereteId;
        data["elementConstructivId"] = this.elementConstructivId;
        return data;
    }

    clone(): ConstatAddCameraPereteFinisajDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraPereteFinisajDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraPereteFinisajDto {
    id: number;
    constatCameraPereteId: number;
    elementConstructivId: number;
}

export class ConstatAddCameraPereteDto implements IConstatAddCameraPereteDto {
    id: number;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    stare: Stare;
    finisaje: ConstatAddCameraPereteFinisajDto[] | undefined;

    constructor(data?: IConstatAddCameraPereteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nrPerete = _data["nrPerete"];
            this.lungime = _data["lungime"];
            this.inaltime = _data["inaltime"];
            this.stare = _data["stare"];
            if (Array.isArray(_data["finisaje"])) {
                this.finisaje = [] as any;
                for (let item of _data["finisaje"])
                    this.finisaje.push(ConstatAddCameraPereteFinisajDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddCameraPereteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraPereteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nrPerete"] = this.nrPerete;
        data["lungime"] = this.lungime;
        data["inaltime"] = this.inaltime;
        data["stare"] = this.stare;
        if (Array.isArray(this.finisaje)) {
            data["finisaje"] = [];
            for (let item of this.finisaje)
                data["finisaje"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddCameraPereteDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraPereteDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraPereteDto {
    id: number;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    stare: Stare;
    finisaje: ConstatAddCameraPereteFinisajDto[] | undefined;
}

export class ConstatAddCameraDaunaPeretiDto implements IConstatAddCameraDaunaPeretiDto {
    nrPerete: number;
    lungimeAvariata: number;
    latimeAvariata: number;

    constructor(data?: IConstatAddCameraDaunaPeretiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrPerete = _data["nrPerete"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
        }
    }

    static fromJS(data: any): ConstatAddCameraDaunaPeretiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraDaunaPeretiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrPerete"] = this.nrPerete;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        return data;
    }

    clone(): ConstatAddCameraDaunaPeretiDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraDaunaPeretiDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraDaunaPeretiDto {
    nrPerete: number;
    lungimeAvariata: number;
    latimeAvariata: number;
}

export class ConstatAddCameraDaunaDto implements IConstatAddCameraDaunaDto {
    cauzaAvarieId: number;
    cauzaAvarie: string | undefined;
    tipAvarieId: number;
    tipAvarie: string | undefined;
    elementConstructivId: number;
    elementConstructiv: string | undefined;
    tipDimensionalId: number;
    tipDimensional: string | undefined;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatAddCameraDaunaPeretiDto[] | undefined;

    constructor(data?: IConstatAddCameraDaunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cauzaAvarieId = _data["cauzaAvarieId"];
            this.cauzaAvarie = _data["cauzaAvarie"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarie = _data["tipAvarie"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.elementConstructiv = _data["elementConstructiv"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.tipDimensional = _data["tipDimensional"];
            this.lungimeTotala = _data["lungimeTotala"];
            this.latimeTotala = _data["latimeTotala"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
            if (Array.isArray(_data["daunaPereti"])) {
                this.daunaPereti = [] as any;
                for (let item of _data["daunaPereti"])
                    this.daunaPereti.push(ConstatAddCameraDaunaPeretiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddCameraDaunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraDaunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cauzaAvarieId"] = this.cauzaAvarieId;
        data["cauzaAvarie"] = this.cauzaAvarie;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarie"] = this.tipAvarie;
        data["elementConstructivId"] = this.elementConstructivId;
        data["elementConstructiv"] = this.elementConstructiv;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["tipDimensional"] = this.tipDimensional;
        data["lungimeTotala"] = this.lungimeTotala;
        data["latimeTotala"] = this.latimeTotala;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        if (Array.isArray(this.daunaPereti)) {
            data["daunaPereti"] = [];
            for (let item of this.daunaPereti)
                data["daunaPereti"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddCameraDaunaDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraDaunaDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraDaunaDto {
    cauzaAvarieId: number;
    cauzaAvarie: string | undefined;
    tipAvarieId: number;
    tipAvarie: string | undefined;
    elementConstructivId: number;
    elementConstructiv: string | undefined;
    tipDimensionalId: number;
    tipDimensional: string | undefined;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatAddCameraDaunaPeretiDto[] | undefined;
}

export class ConstatAddCameraDto implements IConstatAddCameraDto {
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariataId: number;
    tipZonaAvariata: string | undefined;
    pereti: ConstatAddCameraPereteDto[] | undefined;
    daune: ConstatAddCameraDaunaDto[] | undefined;

    constructor(data?: IConstatAddCameraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrCamera = _data["nrCamera"];
            this.numeCamera = _data["numeCamera"];
            this.lungime = _data["lungime"];
            this.latime = _data["latime"];
            this.inaltime = _data["inaltime"];
            this.tipZonaAvariataId = _data["tipZonaAvariataId"];
            this.tipZonaAvariata = _data["tipZonaAvariata"];
            if (Array.isArray(_data["pereti"])) {
                this.pereti = [] as any;
                for (let item of _data["pereti"])
                    this.pereti.push(ConstatAddCameraPereteDto.fromJS(item));
            }
            if (Array.isArray(_data["daune"])) {
                this.daune = [] as any;
                for (let item of _data["daune"])
                    this.daune.push(ConstatAddCameraDaunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddCameraDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrCamera"] = this.nrCamera;
        data["numeCamera"] = this.numeCamera;
        data["lungime"] = this.lungime;
        data["latime"] = this.latime;
        data["inaltime"] = this.inaltime;
        data["tipZonaAvariataId"] = this.tipZonaAvariataId;
        data["tipZonaAvariata"] = this.tipZonaAvariata;
        if (Array.isArray(this.pereti)) {
            data["pereti"] = [];
            for (let item of this.pereti)
                data["pereti"].push(item.toJSON());
        }
        if (Array.isArray(this.daune)) {
            data["daune"] = [];
            for (let item of this.daune)
                data["daune"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddCameraDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraDto {
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariataId: number;
    tipZonaAvariata: string | undefined;
    pereti: ConstatAddCameraPereteDto[] | undefined;
    daune: ConstatAddCameraDaunaDto[] | undefined;
}

export class ConstatAddDto implements IConstatAddDto {
    id: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    adresa: string | undefined;
    localitate: string | undefined;
    judetId: number;
    tipSpatiuId: number;
    numarIncaperi: number;
    asigurator: string | undefined;
    utilizatorConstatare: string | undefined;
    tipConstatare: TipConstatare;
    constatCamere: ConstatAddCameraDto[] | undefined;

    constructor(data?: IConstatAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            this.nrContract = _data["nrContract"];
            this.dataContract = _data["dataContract"] ? moment(_data["dataContract"].toString()) : <any>undefined;
            this.adresa = _data["adresa"];
            this.localitate = _data["localitate"];
            this.judetId = _data["judetId"];
            this.tipSpatiuId = _data["tipSpatiuId"];
            this.numarIncaperi = _data["numarIncaperi"];
            this.asigurator = _data["asigurator"];
            this.utilizatorConstatare = _data["utilizatorConstatare"];
            this.tipConstatare = _data["tipConstatare"];
            if (Array.isArray(_data["constatCamere"])) {
                this.constatCamere = [] as any;
                for (let item of _data["constatCamere"])
                    this.constatCamere.push(ConstatAddCameraDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        data["nrContract"] = this.nrContract;
        data["dataContract"] = this.dataContract ? this.dataContract.toISOString() : <any>undefined;
        data["adresa"] = this.adresa;
        data["localitate"] = this.localitate;
        data["judetId"] = this.judetId;
        data["tipSpatiuId"] = this.tipSpatiuId;
        data["numarIncaperi"] = this.numarIncaperi;
        data["asigurator"] = this.asigurator;
        data["utilizatorConstatare"] = this.utilizatorConstatare;
        data["tipConstatare"] = this.tipConstatare;
        if (Array.isArray(this.constatCamere)) {
            data["constatCamere"] = [];
            for (let item of this.constatCamere)
                data["constatCamere"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddDto {
        const json = this.toJSON();
        let result = new ConstatAddDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddDto {
    id: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    adresa: string | undefined;
    localitate: string | undefined;
    judetId: number;
    tipSpatiuId: number;
    numarIncaperi: number;
    asigurator: string | undefined;
    utilizatorConstatare: string | undefined;
    tipConstatare: TipConstatare;
    constatCamere: ConstatAddCameraDto[] | undefined;
}

export class TipZonaAvariataDto implements ITipZonaAvariataDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: ITipZonaAvariataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): TipZonaAvariataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipZonaAvariataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): TipZonaAvariataDto {
        const json = this.toJSON();
        let result = new TipZonaAvariataDto();
        result.init(json);
        return result;
    }
}

export interface ITipZonaAvariataDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export class TipAvarieDto implements ITipAvarieDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    avarieProfunda: boolean;

    constructor(data?: ITipAvarieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.avarieProfunda = _data["avarieProfunda"];
        }
    }

    static fromJS(data: any): TipAvarieDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipAvarieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["avarieProfunda"] = this.avarieProfunda;
        return data;
    }

    clone(): TipAvarieDto {
        const json = this.toJSON();
        let result = new TipAvarieDto();
        result.init(json);
        return result;
    }
}

export interface ITipAvarieDto {
    tenantId: number;
    id: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    avarieProfunda: boolean;
}

export class ElementConstructivDto implements IElementConstructivDto {
    id: number;
    tipAvarieId: number;
    nume: string | undefined;
    tipElementAvariat: string | undefined;
    grosimeAprox: number | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: IElementConstructivDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.nume = _data["nume"];
            this.tipElementAvariat = _data["tipElementAvariat"];
            this.grosimeAprox = _data["grosimeAprox"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): ElementConstructivDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementConstructivDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipAvarieId"] = this.tipAvarieId;
        data["nume"] = this.nume;
        data["tipElementAvariat"] = this.tipElementAvariat;
        data["grosimeAprox"] = this.grosimeAprox;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): ElementConstructivDto {
        const json = this.toJSON();
        let result = new ElementConstructivDto();
        result.init(json);
        return result;
    }
}

export interface IElementConstructivDto {
    id: number;
    tipAvarieId: number;
    nume: string | undefined;
    tipElementAvariat: string | undefined;
    grosimeAprox: number | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export class JudetDto implements IJudetDto {
    id: number;
    denumire: string | undefined;

    constructor(data?: IJudetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.denumire = _data["denumire"];
        }
    }

    static fromJS(data: any): JudetDto {
        data = typeof data === 'object' ? data : {};
        let result = new JudetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["denumire"] = this.denumire;
        return data;
    }

    clone(): JudetDto {
        const json = this.toJSON();
        let result = new JudetDto();
        result.init(json);
        return result;
    }
}

export interface IJudetDto {
    id: number;
    denumire: string | undefined;
}

export enum CalitateElemConstructiv {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ConstatAddCameraDaunaV2Dto implements IConstatAddCameraDaunaV2Dto {
    id: number;
    cauzaAvarieId: number;
    tipAvarieId: number;
    elementConstructivId: number;
    calitateElemConstructiv: CalitateElemConstructiv;
    tipDimensionalId: number;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    stare: Stare;
    constatCameraId: number;

    constructor(data?: IConstatAddCameraDaunaV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cauzaAvarieId = _data["cauzaAvarieId"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.calitateElemConstructiv = _data["calitateElemConstructiv"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.lungimeTotala = _data["lungimeTotala"];
            this.latimeTotala = _data["latimeTotala"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
            this.stare = _data["stare"];
            this.constatCameraId = _data["constatCameraId"];
        }
    }

    static fromJS(data: any): ConstatAddCameraDaunaV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraDaunaV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cauzaAvarieId"] = this.cauzaAvarieId;
        data["tipAvarieId"] = this.tipAvarieId;
        data["elementConstructivId"] = this.elementConstructivId;
        data["calitateElemConstructiv"] = this.calitateElemConstructiv;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["lungimeTotala"] = this.lungimeTotala;
        data["latimeTotala"] = this.latimeTotala;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        data["stare"] = this.stare;
        data["constatCameraId"] = this.constatCameraId;
        return data;
    }

    clone(): ConstatAddCameraDaunaV2Dto {
        const json = this.toJSON();
        let result = new ConstatAddCameraDaunaV2Dto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraDaunaV2Dto {
    id: number;
    cauzaAvarieId: number;
    tipAvarieId: number;
    elementConstructivId: number;
    calitateElemConstructiv: CalitateElemConstructiv;
    tipDimensionalId: number;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    stare: Stare;
    constatCameraId: number;
}

export class ConstatAddCameraV2Dto implements IConstatAddCameraV2Dto {
    id: number;
    tenantId: number;
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariataId: number;
    constatVersId: number;
    stare: Stare;
    showPereti: boolean;
    pereti: ConstatAddCameraPereteDto[] | undefined;

    constructor(data?: IConstatAddCameraV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.nrCamera = _data["nrCamera"];
            this.numeCamera = _data["numeCamera"];
            this.lungime = _data["lungime"];
            this.latime = _data["latime"];
            this.inaltime = _data["inaltime"];
            this.tipZonaAvariataId = _data["tipZonaAvariataId"];
            this.constatVersId = _data["constatVersId"];
            this.stare = _data["stare"];
            this.showPereti = _data["showPereti"];
            if (Array.isArray(_data["pereti"])) {
                this.pereti = [] as any;
                for (let item of _data["pereti"])
                    this.pereti.push(ConstatAddCameraPereteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddCameraV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["nrCamera"] = this.nrCamera;
        data["numeCamera"] = this.numeCamera;
        data["lungime"] = this.lungime;
        data["latime"] = this.latime;
        data["inaltime"] = this.inaltime;
        data["tipZonaAvariataId"] = this.tipZonaAvariataId;
        data["constatVersId"] = this.constatVersId;
        data["stare"] = this.stare;
        data["showPereti"] = this.showPereti;
        if (Array.isArray(this.pereti)) {
            data["pereti"] = [];
            for (let item of this.pereti)
                data["pereti"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddCameraV2Dto {
        const json = this.toJSON();
        let result = new ConstatAddCameraV2Dto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraV2Dto {
    id: number;
    tenantId: number;
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariataId: number;
    constatVersId: number;
    stare: Stare;
    showPereti: boolean;
    pereti: ConstatAddCameraPereteDto[] | undefined;
}

export class ConstatCameraDaunaPeretiDto implements IConstatCameraDaunaPeretiDto {
    nrPerete: number;

    constructor(data?: IConstatCameraDaunaPeretiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrPerete = _data["nrPerete"];
        }
    }

    static fromJS(data: any): ConstatCameraDaunaPeretiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatCameraDaunaPeretiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrPerete"] = this.nrPerete;
        return data;
    }

    clone(): ConstatCameraDaunaPeretiDto {
        const json = this.toJSON();
        let result = new ConstatCameraDaunaPeretiDto();
        result.init(json);
        return result;
    }
}

export interface IConstatCameraDaunaPeretiDto {
    nrPerete: number;
}

export class ConstatAddCameraPereteLinkDaunaDto implements IConstatAddCameraPereteLinkDaunaDto {
    id: number;
    constatCameraDaunaId: number;
    pereteId: number;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    checkBox: boolean;
    lungimeAvariata: number;
    latimeAvariata: number;

    constructor(data?: IConstatAddCameraPereteLinkDaunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.constatCameraDaunaId = _data["constatCameraDaunaId"];
            this.pereteId = _data["pereteId"];
            this.nrPerete = _data["nrPerete"];
            this.lungime = _data["lungime"];
            this.inaltime = _data["inaltime"];
            this.checkBox = _data["checkBox"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
        }
    }

    static fromJS(data: any): ConstatAddCameraPereteLinkDaunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraPereteLinkDaunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["constatCameraDaunaId"] = this.constatCameraDaunaId;
        data["pereteId"] = this.pereteId;
        data["nrPerete"] = this.nrPerete;
        data["lungime"] = this.lungime;
        data["inaltime"] = this.inaltime;
        data["checkBox"] = this.checkBox;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        return data;
    }

    clone(): ConstatAddCameraPereteLinkDaunaDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraPereteLinkDaunaDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraPereteLinkDaunaDto {
    id: number;
    constatCameraDaunaId: number;
    pereteId: number;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    checkBox: boolean;
    lungimeAvariata: number;
    latimeAvariata: number;
}

export class OperatiuneRemediereAfisareArticolDto implements IOperatiuneRemediereAfisareArticolDto {
    numeArticol: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;

    constructor(data?: IOperatiuneRemediereAfisareArticolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeArticol = _data["numeArticol"];
            this.tipDimensional = _data["tipDimensional"];
            this.cantitate = _data["cantitate"];
            this.orderView = _data["orderView"];
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareArticolDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareArticolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeArticol"] = this.numeArticol;
        data["tipDimensional"] = this.tipDimensional;
        data["cantitate"] = this.cantitate;
        data["orderView"] = this.orderView;
        return data;
    }

    clone(): OperatiuneRemediereAfisareArticolDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareArticolDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareArticolDto {
    numeArticol: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;
}

export class OperatiuneRemediereAfisareArticolDevizDto implements IOperatiuneRemediereAfisareArticolDevizDto {
    articolDevizDetaliiId: number;
    numeArticolDeviz: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolList: OperatiuneRemediereAfisareArticolDto[] | undefined;

    constructor(data?: IOperatiuneRemediereAfisareArticolDevizDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articolDevizDetaliiId = _data["articolDevizDetaliiId"];
            this.numeArticolDeviz = _data["numeArticolDeviz"];
            this.tipDimensional = _data["tipDimensional"];
            this.cantitate = _data["cantitate"];
            this.orderView = _data["orderView"];
            if (Array.isArray(_data["operatiuneRemediereArticolList"])) {
                this.operatiuneRemediereArticolList = [] as any;
                for (let item of _data["operatiuneRemediereArticolList"])
                    this.operatiuneRemediereArticolList.push(OperatiuneRemediereAfisareArticolDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareArticolDevizDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareArticolDevizDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articolDevizDetaliiId"] = this.articolDevizDetaliiId;
        data["numeArticolDeviz"] = this.numeArticolDeviz;
        data["tipDimensional"] = this.tipDimensional;
        data["cantitate"] = this.cantitate;
        data["orderView"] = this.orderView;
        if (Array.isArray(this.operatiuneRemediereArticolList)) {
            data["operatiuneRemediereArticolList"] = [];
            for (let item of this.operatiuneRemediereArticolList)
                data["operatiuneRemediereArticolList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereAfisareArticolDevizDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareArticolDevizDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareArticolDevizDto {
    articolDevizDetaliiId: number;
    numeArticolDeviz: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolList: OperatiuneRemediereAfisareArticolDto[] | undefined;
}

export class OperatiuneRemediereDto implements IOperatiuneRemediereDto {
    operatieDeRemediereId: number;
    numeCamera: string | undefined;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatieDeRemediere: string | undefined;
    unitateDeMasura: string | undefined;
    coefSuplim: number;
    descriereSuboperatii: string | undefined;
    calculCantitati: string | undefined;
    calculCantitatiVal: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolDevizList: OperatiuneRemediereAfisareArticolDevizDto[] | undefined;

    constructor(data?: IOperatiuneRemediereDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatieDeRemediereId = _data["operatieDeRemediereId"];
            this.numeCamera = _data["numeCamera"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            this.operatieDeRemediere = _data["operatieDeRemediere"];
            this.unitateDeMasura = _data["unitateDeMasura"];
            this.coefSuplim = _data["coefSuplim"];
            this.descriereSuboperatii = _data["descriereSuboperatii"];
            this.calculCantitati = _data["calculCantitati"];
            this.calculCantitatiVal = _data["calculCantitatiVal"];
            this.cantitate = _data["cantitate"];
            this.orderView = _data["orderView"];
            if (Array.isArray(_data["operatiuneRemediereArticolDevizList"])) {
                this.operatiuneRemediereArticolDevizList = [] as any;
                for (let item of _data["operatiuneRemediereArticolDevizList"])
                    this.operatiuneRemediereArticolDevizList.push(OperatiuneRemediereAfisareArticolDevizDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operatieDeRemediereId"] = this.operatieDeRemediereId;
        data["numeCamera"] = this.numeCamera;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["elementConstructivNume"] = this.elementConstructivNume;
        data["operatieDeRemediere"] = this.operatieDeRemediere;
        data["unitateDeMasura"] = this.unitateDeMasura;
        data["coefSuplim"] = this.coefSuplim;
        data["descriereSuboperatii"] = this.descriereSuboperatii;
        data["calculCantitati"] = this.calculCantitati;
        data["calculCantitatiVal"] = this.calculCantitatiVal;
        data["cantitate"] = this.cantitate;
        data["orderView"] = this.orderView;
        if (Array.isArray(this.operatiuneRemediereArticolDevizList)) {
            data["operatiuneRemediereArticolDevizList"] = [];
            for (let item of this.operatiuneRemediereArticolDevizList)
                data["operatiuneRemediereArticolDevizList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereDto {
    operatieDeRemediereId: number;
    numeCamera: string | undefined;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatieDeRemediere: string | undefined;
    unitateDeMasura: string | undefined;
    coefSuplim: number;
    descriereSuboperatii: string | undefined;
    calculCantitati: string | undefined;
    calculCantitatiVal: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolDevizList: OperatiuneRemediereAfisareArticolDevizDto[] | undefined;
}

export class OperatiuneRemediereAfisareDaunaDto implements IOperatiuneRemediereAfisareDaunaDto {
    daunaId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatiuneRemediereList: OperatiuneRemediereDto[] | undefined;

    constructor(data?: IOperatiuneRemediereAfisareDaunaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daunaId = _data["daunaId"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            if (Array.isArray(_data["operatiuneRemediereList"])) {
                this.operatiuneRemediereList = [] as any;
                for (let item of _data["operatiuneRemediereList"])
                    this.operatiuneRemediereList.push(OperatiuneRemediereDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareDaunaDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareDaunaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daunaId"] = this.daunaId;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["elementConstructivNume"] = this.elementConstructivNume;
        if (Array.isArray(this.operatiuneRemediereList)) {
            data["operatiuneRemediereList"] = [];
            for (let item of this.operatiuneRemediereList)
                data["operatiuneRemediereList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereAfisareDaunaDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareDaunaDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareDaunaDto {
    daunaId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatiuneRemediereList: OperatiuneRemediereDto[] | undefined;
}

export class OperatiuneRemediereAfisareCameraDto implements IOperatiuneRemediereAfisareCameraDto {
    numeCamera: string | undefined;
    cameraId: number;
    operatiuneRemediereAfisareDaunaList: OperatiuneRemediereAfisareDaunaDto[] | undefined;

    constructor(data?: IOperatiuneRemediereAfisareCameraDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeCamera = _data["numeCamera"];
            this.cameraId = _data["cameraId"];
            if (Array.isArray(_data["operatiuneRemediereAfisareDaunaList"])) {
                this.operatiuneRemediereAfisareDaunaList = [] as any;
                for (let item of _data["operatiuneRemediereAfisareDaunaList"])
                    this.operatiuneRemediereAfisareDaunaList.push(OperatiuneRemediereAfisareDaunaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareCameraDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareCameraDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeCamera"] = this.numeCamera;
        data["cameraId"] = this.cameraId;
        if (Array.isArray(this.operatiuneRemediereAfisareDaunaList)) {
            data["operatiuneRemediereAfisareDaunaList"] = [];
            for (let item of this.operatiuneRemediereAfisareDaunaList)
                data["operatiuneRemediereAfisareDaunaList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereAfisareCameraDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareCameraDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareCameraDto {
    numeCamera: string | undefined;
    cameraId: number;
    operatiuneRemediereAfisareDaunaList: OperatiuneRemediereAfisareDaunaDto[] | undefined;
}

export class OperatiuneRemediereTabelCalculDto implements IOperatiuneRemediereTabelCalculDto {
    numeArticolDeviz: string | undefined;
    articolTip: ArticolTip;
    cantitate: number;
    pretUnit: number;
    valoare: number;

    constructor(data?: IOperatiuneRemediereTabelCalculDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeArticolDeviz = _data["numeArticolDeviz"];
            this.articolTip = _data["articolTip"];
            this.cantitate = _data["cantitate"];
            this.pretUnit = _data["pretUnit"];
            this.valoare = _data["valoare"];
        }
    }

    static fromJS(data: any): OperatiuneRemediereTabelCalculDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereTabelCalculDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeArticolDeviz"] = this.numeArticolDeviz;
        data["articolTip"] = this.articolTip;
        data["cantitate"] = this.cantitate;
        data["pretUnit"] = this.pretUnit;
        data["valoare"] = this.valoare;
        return data;
    }

    clone(): OperatiuneRemediereTabelCalculDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereTabelCalculDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereTabelCalculDto {
    numeArticolDeviz: string | undefined;
    articolTip: ArticolTip;
    cantitate: number;
    pretUnit: number;
    valoare: number;
}

export class OperatiuneRemediereTabelCalculGrupeDto implements IOperatiuneRemediereTabelCalculGrupeDto {
    materiale: OperatiuneRemediereTabelCalculDto[] | undefined;
    manopera: OperatiuneRemediereTabelCalculDto[] | undefined;
    utilaje: OperatiuneRemediereTabelCalculDto[] | undefined;
    transport: OperatiuneRemediereTabelCalculDto[] | undefined;

    constructor(data?: IOperatiuneRemediereTabelCalculGrupeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["materiale"])) {
                this.materiale = [] as any;
                for (let item of _data["materiale"])
                    this.materiale.push(OperatiuneRemediereTabelCalculDto.fromJS(item));
            }
            if (Array.isArray(_data["manopera"])) {
                this.manopera = [] as any;
                for (let item of _data["manopera"])
                    this.manopera.push(OperatiuneRemediereTabelCalculDto.fromJS(item));
            }
            if (Array.isArray(_data["utilaje"])) {
                this.utilaje = [] as any;
                for (let item of _data["utilaje"])
                    this.utilaje.push(OperatiuneRemediereTabelCalculDto.fromJS(item));
            }
            if (Array.isArray(_data["transport"])) {
                this.transport = [] as any;
                for (let item of _data["transport"])
                    this.transport.push(OperatiuneRemediereTabelCalculDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereTabelCalculGrupeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereTabelCalculGrupeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.materiale)) {
            data["materiale"] = [];
            for (let item of this.materiale)
                data["materiale"].push(item.toJSON());
        }
        if (Array.isArray(this.manopera)) {
            data["manopera"] = [];
            for (let item of this.manopera)
                data["manopera"].push(item.toJSON());
        }
        if (Array.isArray(this.utilaje)) {
            data["utilaje"] = [];
            for (let item of this.utilaje)
                data["utilaje"].push(item.toJSON());
        }
        if (Array.isArray(this.transport)) {
            data["transport"] = [];
            for (let item of this.transport)
                data["transport"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereTabelCalculGrupeDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereTabelCalculGrupeDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereTabelCalculGrupeDto {
    materiale: OperatiuneRemediereTabelCalculDto[] | undefined;
    manopera: OperatiuneRemediereTabelCalculDto[] | undefined;
    utilaje: OperatiuneRemediereTabelCalculDto[] | undefined;
    transport: OperatiuneRemediereTabelCalculDto[] | undefined;
}

export class RaportGeneratDto implements IRaportGeneratDto {
    id: number;
    adresa: string | undefined;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    totalMateriale: number;
    totalManopera: number;
    totalUtilaj: number;
    totalTransport: number;
    cantitate: number;
    pretUnit: number;
    totalDeviz: number;

    constructor(data?: IRaportGeneratDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.adresa = _data["adresa"];
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            this.nrContract = _data["nrContract"];
            this.dataContract = _data["dataContract"] ? moment(_data["dataContract"].toString()) : <any>undefined;
            this.totalMateriale = _data["totalMateriale"];
            this.totalManopera = _data["totalManopera"];
            this.totalUtilaj = _data["totalUtilaj"];
            this.totalTransport = _data["totalTransport"];
            this.cantitate = _data["cantitate"];
            this.pretUnit = _data["pretUnit"];
            this.totalDeviz = _data["totalDeviz"];
        }
    }

    static fromJS(data: any): RaportGeneratDto {
        data = typeof data === 'object' ? data : {};
        let result = new RaportGeneratDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["adresa"] = this.adresa;
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        data["nrContract"] = this.nrContract;
        data["dataContract"] = this.dataContract ? this.dataContract.toISOString() : <any>undefined;
        data["totalMateriale"] = this.totalMateriale;
        data["totalManopera"] = this.totalManopera;
        data["totalUtilaj"] = this.totalUtilaj;
        data["totalTransport"] = this.totalTransport;
        data["cantitate"] = this.cantitate;
        data["pretUnit"] = this.pretUnit;
        data["totalDeviz"] = this.totalDeviz;
        return data;
    }

    clone(): RaportGeneratDto {
        const json = this.toJSON();
        let result = new RaportGeneratDto();
        result.init(json);
        return result;
    }
}

export interface IRaportGeneratDto {
    id: number;
    adresa: string | undefined;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    totalMateriale: number;
    totalManopera: number;
    totalUtilaj: number;
    totalTransport: number;
    cantitate: number;
    pretUnit: number;
    totalDeviz: number;
}

export class ElementConstructivEditDto implements IElementConstructivEditDto {
    nume: string | undefined;
    tipElementAvariatId: number;
    grosimeAprox: number | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;

    constructor(data?: IElementConstructivEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nume = _data["nume"];
            this.tipElementAvariatId = _data["tipElementAvariatId"];
            this.grosimeAprox = _data["grosimeAprox"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ElementConstructivEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementConstructivEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nume"] = this.nume;
        data["tipElementAvariatId"] = this.tipElementAvariatId;
        data["grosimeAprox"] = this.grosimeAprox;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): ElementConstructivEditDto {
        const json = this.toJSON();
        let result = new ElementConstructivEditDto();
        result.init(json);
        return result;
    }
}

export interface IElementConstructivEditDto {
    nume: string | undefined;
    tipElementAvariatId: number;
    grosimeAprox: number | undefined;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
}

export class ElementConstructivForJoinDto implements IElementConstructivForJoinDto {
    id: number;
    tipAvarieId: number;
    nume: string | undefined;
    tipElementAvariat: string | undefined;
    grosimeAprox: number | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    categorieElement: string | undefined;

    constructor(data?: IElementConstructivForJoinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.nume = _data["nume"];
            this.tipElementAvariat = _data["tipElementAvariat"];
            this.grosimeAprox = _data["grosimeAprox"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.categorieElement = _data["categorieElement"];
        }
    }

    static fromJS(data: any): ElementConstructivForJoinDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementConstructivForJoinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipAvarieId"] = this.tipAvarieId;
        data["nume"] = this.nume;
        data["tipElementAvariat"] = this.tipElementAvariat;
        data["grosimeAprox"] = this.grosimeAprox;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["categorieElement"] = this.categorieElement;
        return data;
    }

    clone(): ElementConstructivForJoinDto {
        const json = this.toJSON();
        let result = new ElementConstructivForJoinDto();
        result.init(json);
        return result;
    }
}

export interface IElementConstructivForJoinDto {
    id: number;
    tipAvarieId: number;
    nume: string | undefined;
    tipElementAvariat: string | undefined;
    grosimeAprox: number | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    categorieElement: string | undefined;
}

export class ElementConstructivRaportDto implements IElementConstructivRaportDto {
    id: number;
    tipAvarieId: number;
    elementConstructiv: string | undefined;
    tipElementAvariat: string | undefined;
    categorieElement: string | undefined;
    grosimeAprox: number | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: IElementConstructivRaportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.elementConstructiv = _data["elementConstructiv"];
            this.tipElementAvariat = _data["tipElementAvariat"];
            this.categorieElement = _data["categorieElement"];
            this.grosimeAprox = _data["grosimeAprox"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): ElementConstructivRaportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementConstructivRaportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipAvarieId"] = this.tipAvarieId;
        data["elementConstructiv"] = this.elementConstructiv;
        data["tipElementAvariat"] = this.tipElementAvariat;
        data["categorieElement"] = this.categorieElement;
        data["grosimeAprox"] = this.grosimeAprox;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): ElementConstructivRaportDto {
        const json = this.toJSON();
        let result = new ElementConstructivRaportDto();
        result.init(json);
        return result;
    }
}

export interface IElementConstructivRaportDto {
    id: number;
    tipAvarieId: number;
    elementConstructiv: string | undefined;
    tipElementAvariat: string | undefined;
    categorieElement: string | undefined;
    grosimeAprox: number | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export enum Raport {
    _0 = 0,
}

export class RaportDto implements IRaportDto {
    raport: Raport;

    constructor(data?: IRaportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.raport = _data["raport"];
        }
    }

    static fromJS(data: any): RaportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RaportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["raport"] = this.raport;
        return data;
    }

    clone(): RaportDto {
        const json = this.toJSON();
        let result = new RaportDto();
        result.init(json);
        return result;
    }
}

export interface IRaportDto {
    raport: Raport;
}

export class EnumTypeDto implements IEnumTypeDto {
    id: number;
    name: string | undefined;
    nameDisplay: string | undefined;

    constructor(data?: IEnumTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameDisplay = _data["nameDisplay"];
        }
    }

    static fromJS(data: any): EnumTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnumTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameDisplay"] = this.nameDisplay;
        return data;
    }

    clone(): EnumTypeDto {
        const json = this.toJSON();
        let result = new EnumTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEnumTypeDto {
    id: number;
    name: string | undefined;
    nameDisplay: string | undefined;
}

export class FurnizorPretDto implements IFurnizorPretDto {
    id: number;
    nume: string | undefined;
    stare: Stare;

    constructor(data?: IFurnizorPretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
        }
    }

    static fromJS(data: any): FurnizorPretDto {
        data = typeof data === 'object' ? data : {};
        let result = new FurnizorPretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        return data;
    }

    clone(): FurnizorPretDto {
        const json = this.toJSON();
        let result = new FurnizorPretDto();
        result.init(json);
        return result;
    }
}

export interface IFurnizorPretDto {
    id: number;
    nume: string | undefined;
    stare: Stare;
}

export class ArticolFurnizorPretDto implements IArticolFurnizorPretDto {
    id: number | undefined;
    articolNume: string | undefined;
    articolFurnizorId: string | undefined;
    furnizorPretId: number | undefined;
    articolId: number;
    articolInternId: number;
    tenantId: number;
    articolTip: string | undefined;

    constructor(data?: IArticolFurnizorPretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.articolNume = _data["articolNume"];
            this.articolFurnizorId = _data["articolFurnizorId"];
            this.furnizorPretId = _data["furnizorPretId"];
            this.articolId = _data["articolId"];
            this.articolInternId = _data["articolInternId"];
            this.tenantId = _data["tenantId"];
            this.articolTip = _data["articolTip"];
        }
    }

    static fromJS(data: any): ArticolFurnizorPretDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolFurnizorPretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["articolNume"] = this.articolNume;
        data["articolFurnizorId"] = this.articolFurnizorId;
        data["furnizorPretId"] = this.furnizorPretId;
        data["articolId"] = this.articolId;
        data["articolInternId"] = this.articolInternId;
        data["tenantId"] = this.tenantId;
        data["articolTip"] = this.articolTip;
        return data;
    }

    clone(): ArticolFurnizorPretDto {
        const json = this.toJSON();
        let result = new ArticolFurnizorPretDto();
        result.init(json);
        return result;
    }
}

export interface IArticolFurnizorPretDto {
    id: number | undefined;
    articolNume: string | undefined;
    articolFurnizorId: string | undefined;
    furnizorPretId: number | undefined;
    articolId: number;
    articolInternId: number;
    tenantId: number;
    articolTip: string | undefined;
}

export class ArticolPretFisiereDto implements IArticolPretFisiereDto {
    id: number;
    dataValab: moment.Moment;
    furnizorPretId: number;
    tenantId: number;

    constructor(data?: IArticolPretFisiereDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataValab = _data["dataValab"] ? moment(_data["dataValab"].toString()) : <any>undefined;
            this.furnizorPretId = _data["furnizorPretId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ArticolPretFisiereDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticolPretFisiereDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataValab"] = this.dataValab ? this.dataValab.toISOString() : <any>undefined;
        data["furnizorPretId"] = this.furnizorPretId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): ArticolPretFisiereDto {
        const json = this.toJSON();
        let result = new ArticolPretFisiereDto();
        result.init(json);
        return result;
    }
}

export interface IArticolPretFisiereDto {
    id: number;
    dataValab: moment.Moment;
    furnizorPretId: number;
    tenantId: number;
}

export class TipSpatiuAPIDto implements ITipSpatiuAPIDto {
    nume: string | undefined;
    idIntern: number;
    dataStart: string | undefined;
    dataEnd: string | undefined;

    constructor(data?: ITipSpatiuAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nume = _data["nume"];
            this.idIntern = _data["idIntern"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
        }
    }

    static fromJS(data: any): TipSpatiuAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipSpatiuAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nume"] = this.nume;
        data["idIntern"] = this.idIntern;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        return data;
    }

    clone(): TipSpatiuAPIDto {
        const json = this.toJSON();
        let result = new TipSpatiuAPIDto();
        result.init(json);
        return result;
    }
}

export interface ITipSpatiuAPIDto {
    nume: string | undefined;
    idIntern: number;
    dataStart: string | undefined;
    dataEnd: string | undefined;
}

export class CauzaAvarieAPIDto implements ICauzaAvarieAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;

    constructor(data?: ICauzaAvarieAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
        }
    }

    static fromJS(data: any): CauzaAvarieAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new CauzaAvarieAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        return data;
    }

    clone(): CauzaAvarieAPIDto {
        const json = this.toJSON();
        let result = new CauzaAvarieAPIDto();
        result.init(json);
        return result;
    }
}

export interface ICauzaAvarieAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
}

export class TipAvarieAPIDto implements ITipAvarieAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;

    constructor(data?: ITipAvarieAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
        }
    }

    static fromJS(data: any): TipAvarieAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipAvarieAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        return data;
    }

    clone(): TipAvarieAPIDto {
        const json = this.toJSON();
        let result = new TipAvarieAPIDto();
        result.init(json);
        return result;
    }
}

export interface ITipAvarieAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
}

export class TipZonaAvariataAPIDto implements ITipZonaAvariataAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;

    constructor(data?: ITipZonaAvariataAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
        }
    }

    static fromJS(data: any): TipZonaAvariataAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipZonaAvariataAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        return data;
    }

    clone(): TipZonaAvariataAPIDto {
        const json = this.toJSON();
        let result = new TipZonaAvariataAPIDto();
        result.init(json);
        return result;
    }
}

export interface ITipZonaAvariataAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
}

export class CategorieElementAPIDto implements ICategorieElementAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;

    constructor(data?: ICategorieElementAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
        }
    }

    static fromJS(data: any): CategorieElementAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategorieElementAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        return data;
    }

    clone(): CategorieElementAPIDto {
        const json = this.toJSON();
        let result = new CategorieElementAPIDto();
        result.init(json);
        return result;
    }
}

export interface ICategorieElementAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
}

export class TipElementAvariatAPIDto implements ITipElementAvariatAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
    categorieElementId: number;

    constructor(data?: ITipElementAvariatAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
            this.categorieElementId = _data["categorieElementId"];
        }
    }

    static fromJS(data: any): TipElementAvariatAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipElementAvariatAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        data["categorieElementId"] = this.categorieElementId;
        return data;
    }

    clone(): TipElementAvariatAPIDto {
        const json = this.toJSON();
        let result = new TipElementAvariatAPIDto();
        result.init(json);
        return result;
    }
}

export interface ITipElementAvariatAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
    categorieElementId: number;
}

export class ElementConstructivAPIDto implements IElementConstructivAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
    tipElementAvariatId: number;

    constructor(data?: IElementConstructivAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
            this.tipElementAvariatId = _data["tipElementAvariatId"];
        }
    }

    static fromJS(data: any): ElementConstructivAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementConstructivAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        data["tipElementAvariatId"] = this.tipElementAvariatId;
        return data;
    }

    clone(): ElementConstructivAPIDto {
        const json = this.toJSON();
        let result = new ElementConstructivAPIDto();
        result.init(json);
        return result;
    }
}

export interface IElementConstructivAPIDto {
    idIntern: number;
    nume: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
    tipElementAvariatId: number;
}

export class TipDimensionalAPIDto implements ITipDimensionalAPIDto {
    idIntern: number;
    nume: string | undefined;
    unitateMasura: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;

    constructor(data?: ITipDimensionalAPIDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idIntern = _data["idIntern"];
            this.nume = _data["nume"];
            this.unitateMasura = _data["unitateMasura"];
            this.dataStart = _data["dataStart"];
            this.dataEnd = _data["dataEnd"];
        }
    }

    static fromJS(data: any): TipDimensionalAPIDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipDimensionalAPIDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idIntern"] = this.idIntern;
        data["nume"] = this.nume;
        data["unitateMasura"] = this.unitateMasura;
        data["dataStart"] = this.dataStart;
        data["dataEnd"] = this.dataEnd;
        return data;
    }

    clone(): TipDimensionalAPIDto {
        const json = this.toJSON();
        let result = new TipDimensionalAPIDto();
        result.init(json);
        return result;
    }
}

export interface ITipDimensionalAPIDto {
    idIntern: number;
    nume: string | undefined;
    unitateMasura: string | undefined;
    dataStart: string | undefined;
    dataEnd: string | undefined;
}

export class ConstatAddCameraPereteFinisajWaterfallDto implements IConstatAddCameraPereteFinisajWaterfallDto {
    elementConstructivIdIntern: number;

    constructor(data?: IConstatAddCameraPereteFinisajWaterfallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementConstructivIdIntern = _data["elementConstructivIdIntern"];
        }
    }

    static fromJS(data: any): ConstatAddCameraPereteFinisajWaterfallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraPereteFinisajWaterfallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementConstructivIdIntern"] = this.elementConstructivIdIntern;
        return data;
    }

    clone(): ConstatAddCameraPereteFinisajWaterfallDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraPereteFinisajWaterfallDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraPereteFinisajWaterfallDto {
    elementConstructivIdIntern: number;
}

export class ConstatAddCameraPereteWaterfallDto implements IConstatAddCameraPereteWaterfallDto {
    nrPerete: number;
    lungime: number;
    inaltime: number;
    finisajeWaterfall: ConstatAddCameraPereteFinisajWaterfallDto[] | undefined;

    constructor(data?: IConstatAddCameraPereteWaterfallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrPerete = _data["nrPerete"];
            this.lungime = _data["lungime"];
            this.inaltime = _data["inaltime"];
            if (Array.isArray(_data["finisajeWaterfall"])) {
                this.finisajeWaterfall = [] as any;
                for (let item of _data["finisajeWaterfall"])
                    this.finisajeWaterfall.push(ConstatAddCameraPereteFinisajWaterfallDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddCameraPereteWaterfallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraPereteWaterfallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrPerete"] = this.nrPerete;
        data["lungime"] = this.lungime;
        data["inaltime"] = this.inaltime;
        if (Array.isArray(this.finisajeWaterfall)) {
            data["finisajeWaterfall"] = [];
            for (let item of this.finisajeWaterfall)
                data["finisajeWaterfall"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddCameraPereteWaterfallDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraPereteWaterfallDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraPereteWaterfallDto {
    nrPerete: number;
    lungime: number;
    inaltime: number;
    finisajeWaterfall: ConstatAddCameraPereteFinisajWaterfallDto[] | undefined;
}

export class ConstatAddCameraDaunaPeretiWaterfallDto implements IConstatAddCameraDaunaPeretiWaterfallDto {
    nrPerete: number;
    lungimeAvariata: number;
    latimeAvariata: number;

    constructor(data?: IConstatAddCameraDaunaPeretiWaterfallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrPerete = _data["nrPerete"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
        }
    }

    static fromJS(data: any): ConstatAddCameraDaunaPeretiWaterfallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraDaunaPeretiWaterfallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrPerete"] = this.nrPerete;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        return data;
    }

    clone(): ConstatAddCameraDaunaPeretiWaterfallDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraDaunaPeretiWaterfallDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraDaunaPeretiWaterfallDto {
    nrPerete: number;
    lungimeAvariata: number;
    latimeAvariata: number;
}

export class ConstatAddCameraDaunaWaterfallDto implements IConstatAddCameraDaunaWaterfallDto {
    cauzaAvarieIdIntern: number;
    tipAvarieIdIntern: number;
    elementConstructivIdIntern: number;
    tipDimensionalIdIntern: number;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatAddCameraDaunaPeretiWaterfallDto[] | undefined;

    constructor(data?: IConstatAddCameraDaunaWaterfallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cauzaAvarieIdIntern = _data["cauzaAvarieIdIntern"];
            this.tipAvarieIdIntern = _data["tipAvarieIdIntern"];
            this.elementConstructivIdIntern = _data["elementConstructivIdIntern"];
            this.tipDimensionalIdIntern = _data["tipDimensionalIdIntern"];
            this.lungimeTotala = _data["lungimeTotala"];
            this.latimeTotala = _data["latimeTotala"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
            if (Array.isArray(_data["daunaPereti"])) {
                this.daunaPereti = [] as any;
                for (let item of _data["daunaPereti"])
                    this.daunaPereti.push(ConstatAddCameraDaunaPeretiWaterfallDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddCameraDaunaWaterfallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraDaunaWaterfallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cauzaAvarieIdIntern"] = this.cauzaAvarieIdIntern;
        data["tipAvarieIdIntern"] = this.tipAvarieIdIntern;
        data["elementConstructivIdIntern"] = this.elementConstructivIdIntern;
        data["tipDimensionalIdIntern"] = this.tipDimensionalIdIntern;
        data["lungimeTotala"] = this.lungimeTotala;
        data["latimeTotala"] = this.latimeTotala;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        if (Array.isArray(this.daunaPereti)) {
            data["daunaPereti"] = [];
            for (let item of this.daunaPereti)
                data["daunaPereti"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddCameraDaunaWaterfallDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraDaunaWaterfallDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraDaunaWaterfallDto {
    cauzaAvarieIdIntern: number;
    tipAvarieIdIntern: number;
    elementConstructivIdIntern: number;
    tipDimensionalIdIntern: number;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatAddCameraDaunaPeretiWaterfallDto[] | undefined;
}

export class ConstatAddCameraWaterfallDto implements IConstatAddCameraWaterfallDto {
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariataIdIntern: number;
    peretiWaterfall: ConstatAddCameraPereteWaterfallDto[] | undefined;
    dauneWaterfall: ConstatAddCameraDaunaWaterfallDto[] | undefined;

    constructor(data?: IConstatAddCameraWaterfallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrCamera = _data["nrCamera"];
            this.numeCamera = _data["numeCamera"];
            this.lungime = _data["lungime"];
            this.latime = _data["latime"];
            this.inaltime = _data["inaltime"];
            this.tipZonaAvariataIdIntern = _data["tipZonaAvariataIdIntern"];
            if (Array.isArray(_data["peretiWaterfall"])) {
                this.peretiWaterfall = [] as any;
                for (let item of _data["peretiWaterfall"])
                    this.peretiWaterfall.push(ConstatAddCameraPereteWaterfallDto.fromJS(item));
            }
            if (Array.isArray(_data["dauneWaterfall"])) {
                this.dauneWaterfall = [] as any;
                for (let item of _data["dauneWaterfall"])
                    this.dauneWaterfall.push(ConstatAddCameraDaunaWaterfallDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddCameraWaterfallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddCameraWaterfallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrCamera"] = this.nrCamera;
        data["numeCamera"] = this.numeCamera;
        data["lungime"] = this.lungime;
        data["latime"] = this.latime;
        data["inaltime"] = this.inaltime;
        data["tipZonaAvariataIdIntern"] = this.tipZonaAvariataIdIntern;
        if (Array.isArray(this.peretiWaterfall)) {
            data["peretiWaterfall"] = [];
            for (let item of this.peretiWaterfall)
                data["peretiWaterfall"].push(item.toJSON());
        }
        if (Array.isArray(this.dauneWaterfall)) {
            data["dauneWaterfall"] = [];
            for (let item of this.dauneWaterfall)
                data["dauneWaterfall"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddCameraWaterfallDto {
        const json = this.toJSON();
        let result = new ConstatAddCameraWaterfallDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddCameraWaterfallDto {
    nrCamera: string | undefined;
    numeCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    tipZonaAvariataIdIntern: number;
    peretiWaterfall: ConstatAddCameraPereteWaterfallDto[] | undefined;
    dauneWaterfall: ConstatAddCameraDaunaWaterfallDto[] | undefined;
}

export class ConstatAddWaterfallDto implements IConstatAddWaterfallDto {
    nrConstatare: string | undefined;
    dataConstatare: string | undefined;
    nrContract: string | undefined;
    dataContract: string | undefined;
    asigurator: string | undefined;
    utilizatorConstatare: string | undefined;
    numarIncaperi: number;
    tipConstatare: TipConstatare;
    adresa: string | undefined;
    localitate: string | undefined;
    judet: string | undefined;
    tipSpatiuIdIntern: number;
    constatCamereWaterfall: ConstatAddCameraWaterfallDto[] | undefined;

    constructor(data?: IConstatAddWaterfallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"];
            this.nrContract = _data["nrContract"];
            this.dataContract = _data["dataContract"];
            this.asigurator = _data["asigurator"];
            this.utilizatorConstatare = _data["utilizatorConstatare"];
            this.numarIncaperi = _data["numarIncaperi"];
            this.tipConstatare = _data["tipConstatare"];
            this.adresa = _data["adresa"];
            this.localitate = _data["localitate"];
            this.judet = _data["judet"];
            this.tipSpatiuIdIntern = _data["tipSpatiuIdIntern"];
            if (Array.isArray(_data["constatCamereWaterfall"])) {
                this.constatCamereWaterfall = [] as any;
                for (let item of _data["constatCamereWaterfall"])
                    this.constatCamereWaterfall.push(ConstatAddCameraWaterfallDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConstatAddWaterfallDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatAddWaterfallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare;
        data["nrContract"] = this.nrContract;
        data["dataContract"] = this.dataContract;
        data["asigurator"] = this.asigurator;
        data["utilizatorConstatare"] = this.utilizatorConstatare;
        data["numarIncaperi"] = this.numarIncaperi;
        data["tipConstatare"] = this.tipConstatare;
        data["adresa"] = this.adresa;
        data["localitate"] = this.localitate;
        data["judet"] = this.judet;
        data["tipSpatiuIdIntern"] = this.tipSpatiuIdIntern;
        if (Array.isArray(this.constatCamereWaterfall)) {
            data["constatCamereWaterfall"] = [];
            for (let item of this.constatCamereWaterfall)
                data["constatCamereWaterfall"].push(item.toJSON());
        }
        return data;
    }

    clone(): ConstatAddWaterfallDto {
        const json = this.toJSON();
        let result = new ConstatAddWaterfallDto();
        result.init(json);
        return result;
    }
}

export interface IConstatAddWaterfallDto {
    nrConstatare: string | undefined;
    dataConstatare: string | undefined;
    nrContract: string | undefined;
    dataContract: string | undefined;
    asigurator: string | undefined;
    utilizatorConstatare: string | undefined;
    numarIncaperi: number;
    tipConstatare: TipConstatare;
    adresa: string | undefined;
    localitate: string | undefined;
    judet: string | undefined;
    tipSpatiuIdIntern: number;
    constatCamereWaterfall: ConstatAddCameraWaterfallDto[] | undefined;
}

export class DevizCalculExceptiiDto implements IDevizCalculExceptiiDto {
    elementConstructivIdIntern: number | undefined;
    elementConstructiv: string | undefined;
    tipAvarieIdIntern: number | undefined;
    tipAvarie: string | undefined;

    constructor(data?: IDevizCalculExceptiiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementConstructivIdIntern = _data["elementConstructivIdIntern"];
            this.elementConstructiv = _data["elementConstructiv"];
            this.tipAvarieIdIntern = _data["tipAvarieIdIntern"];
            this.tipAvarie = _data["tipAvarie"];
        }
    }

    static fromJS(data: any): DevizCalculExceptiiDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevizCalculExceptiiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementConstructivIdIntern"] = this.elementConstructivIdIntern;
        data["elementConstructiv"] = this.elementConstructiv;
        data["tipAvarieIdIntern"] = this.tipAvarieIdIntern;
        data["tipAvarie"] = this.tipAvarie;
        return data;
    }

    clone(): DevizCalculExceptiiDto {
        const json = this.toJSON();
        let result = new DevizCalculExceptiiDto();
        result.init(json);
        return result;
    }
}

export interface IDevizCalculExceptiiDto {
    elementConstructivIdIntern: number | undefined;
    elementConstructiv: string | undefined;
    tipAvarieIdIntern: number | undefined;
    tipAvarie: string | undefined;
}

export class ResultMessageIdDto implements IResultMessageIdDto {
    statusCode: number;
    message: string | undefined;
    id: number | undefined;
    valoareDeviz: number | undefined;
    devizCalculExceptii: DevizCalculExceptiiDto[] | undefined;

    constructor(data?: IResultMessageIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.id = _data["id"];
            this.valoareDeviz = _data["valoareDeviz"];
            if (Array.isArray(_data["devizCalculExceptii"])) {
                this.devizCalculExceptii = [] as any;
                for (let item of _data["devizCalculExceptii"])
                    this.devizCalculExceptii.push(DevizCalculExceptiiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultMessageIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessageIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["id"] = this.id;
        data["valoareDeviz"] = this.valoareDeviz;
        if (Array.isArray(this.devizCalculExceptii)) {
            data["devizCalculExceptii"] = [];
            for (let item of this.devizCalculExceptii)
                data["devizCalculExceptii"].push(item.toJSON());
        }
        return data;
    }

    clone(): ResultMessageIdDto {
        const json = this.toJSON();
        let result = new ResultMessageIdDto();
        result.init(json);
        return result;
    }
}

export interface IResultMessageIdDto {
    statusCode: number;
    message: string | undefined;
    id: number | undefined;
    valoareDeviz: number | undefined;
    devizCalculExceptii: DevizCalculExceptiiDto[] | undefined;
}

export class Judet implements IJudet {
    tenantId: number;
    denumire: string | undefined;
    abreviere: string | undefined;
    stare: Stare;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IJudet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.denumire = _data["denumire"];
            this.abreviere = _data["abreviere"];
            this.stare = _data["stare"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Judet {
        data = typeof data === 'object' ? data : {};
        let result = new Judet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["denumire"] = this.denumire;
        data["abreviere"] = this.abreviere;
        data["stare"] = this.stare;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Judet {
        const json = this.toJSON();
        let result = new Judet();
        result.init(json);
        return result;
    }
}

export interface IJudet {
    tenantId: number;
    denumire: string | undefined;
    abreviere: string | undefined;
    stare: Stare;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TipSpatiu implements ITipSpatiu {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITipSpatiu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TipSpatiu {
        data = typeof data === 'object' ? data : {};
        let result = new TipSpatiu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TipSpatiu {
        const json = this.toJSON();
        let result = new TipSpatiu();
        result.init(json);
        return result;
    }
}

export interface ITipSpatiu {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ConstatUnitLocat implements IConstatUnitLocat {
    constatVersId: number;
    constatVers: ConstatVers;
    tenantId: number;
    stare: Stare;
    adresa: string | undefined;
    localitate: string | undefined;
    judetId: number;
    judet: Judet;
    tipSpatiuId: number;
    tipSpatiu: TipSpatiu;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstatUnitLocat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constatVersId = _data["constatVersId"];
            this.constatVers = _data["constatVers"] ? ConstatVers.fromJS(_data["constatVers"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.stare = _data["stare"];
            this.adresa = _data["adresa"];
            this.localitate = _data["localitate"];
            this.judetId = _data["judetId"];
            this.judet = _data["judet"] ? Judet.fromJS(_data["judet"]) : <any>undefined;
            this.tipSpatiuId = _data["tipSpatiuId"];
            this.tipSpatiu = _data["tipSpatiu"] ? TipSpatiu.fromJS(_data["tipSpatiu"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConstatUnitLocat {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatUnitLocat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constatVersId"] = this.constatVersId;
        data["constatVers"] = this.constatVers ? this.constatVers.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["stare"] = this.stare;
        data["adresa"] = this.adresa;
        data["localitate"] = this.localitate;
        data["judetId"] = this.judetId;
        data["judet"] = this.judet ? this.judet.toJSON() : <any>undefined;
        data["tipSpatiuId"] = this.tipSpatiuId;
        data["tipSpatiu"] = this.tipSpatiu ? this.tipSpatiu.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConstatUnitLocat {
        const json = this.toJSON();
        let result = new ConstatUnitLocat();
        result.init(json);
        return result;
    }
}

export interface IConstatUnitLocat {
    constatVersId: number;
    constatVers: ConstatVers;
    tenantId: number;
    stare: Stare;
    adresa: string | undefined;
    localitate: string | undefined;
    judetId: number;
    judet: Judet;
    tipSpatiuId: number;
    tipSpatiu: TipSpatiu;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TipZonaAvariata implements ITipZonaAvariata {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITipZonaAvariata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TipZonaAvariata {
        data = typeof data === 'object' ? data : {};
        let result = new TipZonaAvariata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TipZonaAvariata {
        const json = this.toJSON();
        let result = new TipZonaAvariata();
        result.init(json);
        return result;
    }
}

export interface ITipZonaAvariata {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ConstatCameraPereteFinisaj implements IConstatCameraPereteFinisaj {
    tenantId: number;
    stare: Stare;
    constatCameraPereteId: number;
    constatCameraPerete: ConstatCameraPerete;
    elementConstructivId: number;
    elementConstructiv: ElementConstructiv;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstatCameraPereteFinisaj) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.stare = _data["stare"];
            this.constatCameraPereteId = _data["constatCameraPereteId"];
            this.constatCameraPerete = _data["constatCameraPerete"] ? ConstatCameraPerete.fromJS(_data["constatCameraPerete"]) : <any>undefined;
            this.elementConstructivId = _data["elementConstructivId"];
            this.elementConstructiv = _data["elementConstructiv"] ? ElementConstructiv.fromJS(_data["elementConstructiv"]) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConstatCameraPereteFinisaj {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatCameraPereteFinisaj();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["stare"] = this.stare;
        data["constatCameraPereteId"] = this.constatCameraPereteId;
        data["constatCameraPerete"] = this.constatCameraPerete ? this.constatCameraPerete.toJSON() : <any>undefined;
        data["elementConstructivId"] = this.elementConstructivId;
        data["elementConstructiv"] = this.elementConstructiv ? this.elementConstructiv.toJSON() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConstatCameraPereteFinisaj {
        const json = this.toJSON();
        let result = new ConstatCameraPereteFinisaj();
        result.init(json);
        return result;
    }
}

export interface IConstatCameraPereteFinisaj {
    tenantId: number;
    stare: Stare;
    constatCameraPereteId: number;
    constatCameraPerete: ConstatCameraPerete;
    elementConstructivId: number;
    elementConstructiv: ElementConstructiv;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ConstatCameraPerete implements IConstatCameraPerete {
    constatCameraId: number;
    constatCamere: ConstatCamera;
    tenantId: number;
    stare: Stare;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    finisaje: ConstatCameraPereteFinisaj[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstatCameraPerete) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constatCameraId = _data["constatCameraId"];
            this.constatCamere = _data["constatCamere"] ? ConstatCamera.fromJS(_data["constatCamere"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.stare = _data["stare"];
            this.nrPerete = _data["nrPerete"];
            this.lungime = _data["lungime"];
            this.inaltime = _data["inaltime"];
            if (Array.isArray(_data["finisaje"])) {
                this.finisaje = [] as any;
                for (let item of _data["finisaje"])
                    this.finisaje.push(ConstatCameraPereteFinisaj.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConstatCameraPerete {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatCameraPerete();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constatCameraId"] = this.constatCameraId;
        data["constatCamere"] = this.constatCamere ? this.constatCamere.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["stare"] = this.stare;
        data["nrPerete"] = this.nrPerete;
        data["lungime"] = this.lungime;
        data["inaltime"] = this.inaltime;
        if (Array.isArray(this.finisaje)) {
            data["finisaje"] = [];
            for (let item of this.finisaje)
                data["finisaje"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConstatCameraPerete {
        const json = this.toJSON();
        let result = new ConstatCameraPerete();
        result.init(json);
        return result;
    }
}

export interface IConstatCameraPerete {
    constatCameraId: number;
    constatCamere: ConstatCamera;
    tenantId: number;
    stare: Stare;
    nrPerete: number;
    lungime: number;
    inaltime: number;
    finisaje: ConstatCameraPereteFinisaj[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CauzaAvarie implements ICauzaAvarie {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ICauzaAvarie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CauzaAvarie {
        data = typeof data === 'object' ? data : {};
        let result = new CauzaAvarie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): CauzaAvarie {
        const json = this.toJSON();
        let result = new CauzaAvarie();
        result.init(json);
        return result;
    }
}

export interface ICauzaAvarie {
    tenantId: number;
    nume: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class TipDimensional implements ITipDimensional {
    tenantId: number;
    nume: string | undefined;
    unitateMasura: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: ITipDimensional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nume = _data["nume"];
            this.unitateMasura = _data["unitateMasura"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TipDimensional {
        data = typeof data === 'object' ? data : {};
        let result = new TipDimensional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nume"] = this.nume;
        data["unitateMasura"] = this.unitateMasura;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): TipDimensional {
        const json = this.toJSON();
        let result = new TipDimensional();
        result.init(json);
        return result;
    }
}

export interface ITipDimensional {
    tenantId: number;
    nume: string | undefined;
    unitateMasura: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ConstatCameraDaunaPereti implements IConstatCameraDaunaPereti {
    constatCameraDaunaId: number;
    constatCameraDauna: ConstatCameraDauna;
    constatCameraPereteId: number;
    constatCameraPerete: ConstatCameraPerete;
    stare: Stare;
    tenantId: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstatCameraDaunaPereti) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constatCameraDaunaId = _data["constatCameraDaunaId"];
            this.constatCameraDauna = _data["constatCameraDauna"] ? ConstatCameraDauna.fromJS(_data["constatCameraDauna"]) : <any>undefined;
            this.constatCameraPereteId = _data["constatCameraPereteId"];
            this.constatCameraPerete = _data["constatCameraPerete"] ? ConstatCameraPerete.fromJS(_data["constatCameraPerete"]) : <any>undefined;
            this.stare = _data["stare"];
            this.tenantId = _data["tenantId"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConstatCameraDaunaPereti {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatCameraDaunaPereti();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constatCameraDaunaId"] = this.constatCameraDaunaId;
        data["constatCameraDauna"] = this.constatCameraDauna ? this.constatCameraDauna.toJSON() : <any>undefined;
        data["constatCameraPereteId"] = this.constatCameraPereteId;
        data["constatCameraPerete"] = this.constatCameraPerete ? this.constatCameraPerete.toJSON() : <any>undefined;
        data["stare"] = this.stare;
        data["tenantId"] = this.tenantId;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConstatCameraDaunaPereti {
        const json = this.toJSON();
        let result = new ConstatCameraDaunaPereti();
        result.init(json);
        return result;
    }
}

export interface IConstatCameraDaunaPereti {
    constatCameraDaunaId: number;
    constatCameraDauna: ConstatCameraDauna;
    constatCameraPereteId: number;
    constatCameraPerete: ConstatCameraPerete;
    stare: Stare;
    tenantId: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ConstatCameraDauna implements IConstatCameraDauna {
    constatCameraId: number;
    constatCamera: ConstatCamera;
    cauzaAvarieId: number;
    cauzaAvarie: CauzaAvarie;
    tipAvarieId: number;
    tipAvarie: TipAvarie;
    elementConstructivId: number;
    elementConstructiv: ElementConstructiv;
    calitateElemConstructiv: CalitateElemConstructiv;
    tipDimensionalId: number;
    tipDimensional: TipDimensional;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatCameraDaunaPereti[] | undefined;
    stare: Stare;
    tenantId: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstatCameraDauna) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constatCameraId = _data["constatCameraId"];
            this.constatCamera = _data["constatCamera"] ? ConstatCamera.fromJS(_data["constatCamera"]) : <any>undefined;
            this.cauzaAvarieId = _data["cauzaAvarieId"];
            this.cauzaAvarie = _data["cauzaAvarie"] ? CauzaAvarie.fromJS(_data["cauzaAvarie"]) : <any>undefined;
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarie = _data["tipAvarie"] ? TipAvarie.fromJS(_data["tipAvarie"]) : <any>undefined;
            this.elementConstructivId = _data["elementConstructivId"];
            this.elementConstructiv = _data["elementConstructiv"] ? ElementConstructiv.fromJS(_data["elementConstructiv"]) : <any>undefined;
            this.calitateElemConstructiv = _data["calitateElemConstructiv"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.tipDimensional = _data["tipDimensional"] ? TipDimensional.fromJS(_data["tipDimensional"]) : <any>undefined;
            this.lungimeTotala = _data["lungimeTotala"];
            this.latimeTotala = _data["latimeTotala"];
            this.lungimeAvariata = _data["lungimeAvariata"];
            this.latimeAvariata = _data["latimeAvariata"];
            if (Array.isArray(_data["daunaPereti"])) {
                this.daunaPereti = [] as any;
                for (let item of _data["daunaPereti"])
                    this.daunaPereti.push(ConstatCameraDaunaPereti.fromJS(item));
            }
            this.stare = _data["stare"];
            this.tenantId = _data["tenantId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConstatCameraDauna {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatCameraDauna();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constatCameraId"] = this.constatCameraId;
        data["constatCamera"] = this.constatCamera ? this.constatCamera.toJSON() : <any>undefined;
        data["cauzaAvarieId"] = this.cauzaAvarieId;
        data["cauzaAvarie"] = this.cauzaAvarie ? this.cauzaAvarie.toJSON() : <any>undefined;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarie"] = this.tipAvarie ? this.tipAvarie.toJSON() : <any>undefined;
        data["elementConstructivId"] = this.elementConstructivId;
        data["elementConstructiv"] = this.elementConstructiv ? this.elementConstructiv.toJSON() : <any>undefined;
        data["calitateElemConstructiv"] = this.calitateElemConstructiv;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["tipDimensional"] = this.tipDimensional ? this.tipDimensional.toJSON() : <any>undefined;
        data["lungimeTotala"] = this.lungimeTotala;
        data["latimeTotala"] = this.latimeTotala;
        data["lungimeAvariata"] = this.lungimeAvariata;
        data["latimeAvariata"] = this.latimeAvariata;
        if (Array.isArray(this.daunaPereti)) {
            data["daunaPereti"] = [];
            for (let item of this.daunaPereti)
                data["daunaPereti"].push(item.toJSON());
        }
        data["stare"] = this.stare;
        data["tenantId"] = this.tenantId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConstatCameraDauna {
        const json = this.toJSON();
        let result = new ConstatCameraDauna();
        result.init(json);
        return result;
    }
}

export interface IConstatCameraDauna {
    constatCameraId: number;
    constatCamera: ConstatCamera;
    cauzaAvarieId: number;
    cauzaAvarie: CauzaAvarie;
    tipAvarieId: number;
    tipAvarie: TipAvarie;
    elementConstructivId: number;
    elementConstructiv: ElementConstructiv;
    calitateElemConstructiv: CalitateElemConstructiv;
    tipDimensionalId: number;
    tipDimensional: TipDimensional;
    lungimeTotala: number;
    latimeTotala: number;
    lungimeAvariata: number;
    latimeAvariata: number;
    daunaPereti: ConstatCameraDaunaPereti[] | undefined;
    stare: Stare;
    tenantId: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ConstatCamera implements IConstatCamera {
    constatVersId: number;
    constatVers: ConstatVers;
    tipZonaAvariataId: number;
    tipZonaAvariata: TipZonaAvariata;
    numeCamera: string | undefined;
    tenantId: number;
    stare: Stare;
    nrCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    pereti: ConstatCameraPerete[] | undefined;
    daune: ConstatCameraDauna[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstatCamera) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constatVersId = _data["constatVersId"];
            this.constatVers = _data["constatVers"] ? ConstatVers.fromJS(_data["constatVers"]) : <any>undefined;
            this.tipZonaAvariataId = _data["tipZonaAvariataId"];
            this.tipZonaAvariata = _data["tipZonaAvariata"] ? TipZonaAvariata.fromJS(_data["tipZonaAvariata"]) : <any>undefined;
            this.numeCamera = _data["numeCamera"];
            this.tenantId = _data["tenantId"];
            this.stare = _data["stare"];
            this.nrCamera = _data["nrCamera"];
            this.lungime = _data["lungime"];
            this.latime = _data["latime"];
            this.inaltime = _data["inaltime"];
            if (Array.isArray(_data["pereti"])) {
                this.pereti = [] as any;
                for (let item of _data["pereti"])
                    this.pereti.push(ConstatCameraPerete.fromJS(item));
            }
            if (Array.isArray(_data["daune"])) {
                this.daune = [] as any;
                for (let item of _data["daune"])
                    this.daune.push(ConstatCameraDauna.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConstatCamera {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatCamera();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constatVersId"] = this.constatVersId;
        data["constatVers"] = this.constatVers ? this.constatVers.toJSON() : <any>undefined;
        data["tipZonaAvariataId"] = this.tipZonaAvariataId;
        data["tipZonaAvariata"] = this.tipZonaAvariata ? this.tipZonaAvariata.toJSON() : <any>undefined;
        data["numeCamera"] = this.numeCamera;
        data["tenantId"] = this.tenantId;
        data["stare"] = this.stare;
        data["nrCamera"] = this.nrCamera;
        data["lungime"] = this.lungime;
        data["latime"] = this.latime;
        data["inaltime"] = this.inaltime;
        if (Array.isArray(this.pereti)) {
            data["pereti"] = [];
            for (let item of this.pereti)
                data["pereti"].push(item.toJSON());
        }
        if (Array.isArray(this.daune)) {
            data["daune"] = [];
            for (let item of this.daune)
                data["daune"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConstatCamera {
        const json = this.toJSON();
        let result = new ConstatCamera();
        result.init(json);
        return result;
    }
}

export interface IConstatCamera {
    constatVersId: number;
    constatVers: ConstatVers;
    tipZonaAvariataId: number;
    tipZonaAvariata: TipZonaAvariata;
    numeCamera: string | undefined;
    tenantId: number;
    stare: Stare;
    nrCamera: string | undefined;
    lungime: number;
    latime: number;
    inaltime: number;
    pereti: ConstatCameraPerete[] | undefined;
    daune: ConstatCameraDauna[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class BmkAnalizaAbatere implements IBmkAnalizaAbatere {
    tenantId: number;
    analizatConstatVersId: number;
    analizatConstatVers: ConstatVers;
    tipAvarieId: number;
    tipAvarie: TipAvarie;
    analizatSuprafataAvariata: number;
    analizatValoareDeviz: number;
    abatereConstatVersId: number;
    abatereConstatVers: ConstatVers;
    abatereSuprafataAvariata: number;
    abatereValoareDeviz: number;
    verificat: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IBmkAnalizaAbatere) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.analizatConstatVersId = _data["analizatConstatVersId"];
            this.analizatConstatVers = _data["analizatConstatVers"] ? ConstatVers.fromJS(_data["analizatConstatVers"]) : <any>undefined;
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarie = _data["tipAvarie"] ? TipAvarie.fromJS(_data["tipAvarie"]) : <any>undefined;
            this.analizatSuprafataAvariata = _data["analizatSuprafataAvariata"];
            this.analizatValoareDeviz = _data["analizatValoareDeviz"];
            this.abatereConstatVersId = _data["abatereConstatVersId"];
            this.abatereConstatVers = _data["abatereConstatVers"] ? ConstatVers.fromJS(_data["abatereConstatVers"]) : <any>undefined;
            this.abatereSuprafataAvariata = _data["abatereSuprafataAvariata"];
            this.abatereValoareDeviz = _data["abatereValoareDeviz"];
            this.verificat = _data["verificat"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BmkAnalizaAbatere {
        data = typeof data === 'object' ? data : {};
        let result = new BmkAnalizaAbatere();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["analizatConstatVersId"] = this.analizatConstatVersId;
        data["analizatConstatVers"] = this.analizatConstatVers ? this.analizatConstatVers.toJSON() : <any>undefined;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarie"] = this.tipAvarie ? this.tipAvarie.toJSON() : <any>undefined;
        data["analizatSuprafataAvariata"] = this.analizatSuprafataAvariata;
        data["analizatValoareDeviz"] = this.analizatValoareDeviz;
        data["abatereConstatVersId"] = this.abatereConstatVersId;
        data["abatereConstatVers"] = this.abatereConstatVers ? this.abatereConstatVers.toJSON() : <any>undefined;
        data["abatereSuprafataAvariata"] = this.abatereSuprafataAvariata;
        data["abatereValoareDeviz"] = this.abatereValoareDeviz;
        data["verificat"] = this.verificat;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): BmkAnalizaAbatere {
        const json = this.toJSON();
        let result = new BmkAnalizaAbatere();
        result.init(json);
        return result;
    }
}

export interface IBmkAnalizaAbatere {
    tenantId: number;
    analizatConstatVersId: number;
    analizatConstatVers: ConstatVers;
    tipAvarieId: number;
    tipAvarie: TipAvarie;
    analizatSuprafataAvariata: number;
    analizatValoareDeviz: number;
    abatereConstatVersId: number;
    abatereConstatVers: ConstatVers;
    abatereSuprafataAvariata: number;
    abatereValoareDeviz: number;
    verificat: boolean;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ConstatVers implements IConstatVers {
    constatId: number;
    tenantId: number;
    constat: Constat;
    stare: Stare;
    validat: boolean;
    constatUnitLocat: ConstatUnitLocat;
    constatCamere: ConstatCamera[] | undefined;
    bmkAnalizaAbatereAnalizate: BmkAnalizaAbatere[] | undefined;
    bmkAnalizaAbatereAbatere: BmkAnalizaAbatere[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstatVers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.constatId = _data["constatId"];
            this.tenantId = _data["tenantId"];
            this.constat = _data["constat"] ? Constat.fromJS(_data["constat"]) : <any>undefined;
            this.stare = _data["stare"];
            this.validat = _data["validat"];
            this.constatUnitLocat = _data["constatUnitLocat"] ? ConstatUnitLocat.fromJS(_data["constatUnitLocat"]) : <any>undefined;
            if (Array.isArray(_data["constatCamere"])) {
                this.constatCamere = [] as any;
                for (let item of _data["constatCamere"])
                    this.constatCamere.push(ConstatCamera.fromJS(item));
            }
            if (Array.isArray(_data["bmkAnalizaAbatereAnalizate"])) {
                this.bmkAnalizaAbatereAnalizate = [] as any;
                for (let item of _data["bmkAnalizaAbatereAnalizate"])
                    this.bmkAnalizaAbatereAnalizate.push(BmkAnalizaAbatere.fromJS(item));
            }
            if (Array.isArray(_data["bmkAnalizaAbatereAbatere"])) {
                this.bmkAnalizaAbatereAbatere = [] as any;
                for (let item of _data["bmkAnalizaAbatereAbatere"])
                    this.bmkAnalizaAbatereAbatere.push(BmkAnalizaAbatere.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConstatVers {
        data = typeof data === 'object' ? data : {};
        let result = new ConstatVers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["constatId"] = this.constatId;
        data["tenantId"] = this.tenantId;
        data["constat"] = this.constat ? this.constat.toJSON() : <any>undefined;
        data["stare"] = this.stare;
        data["validat"] = this.validat;
        data["constatUnitLocat"] = this.constatUnitLocat ? this.constatUnitLocat.toJSON() : <any>undefined;
        if (Array.isArray(this.constatCamere)) {
            data["constatCamere"] = [];
            for (let item of this.constatCamere)
                data["constatCamere"].push(item.toJSON());
        }
        if (Array.isArray(this.bmkAnalizaAbatereAnalizate)) {
            data["bmkAnalizaAbatereAnalizate"] = [];
            for (let item of this.bmkAnalizaAbatereAnalizate)
                data["bmkAnalizaAbatereAnalizate"].push(item.toJSON());
        }
        if (Array.isArray(this.bmkAnalizaAbatereAbatere)) {
            data["bmkAnalizaAbatereAbatere"] = [];
            for (let item of this.bmkAnalizaAbatereAbatere)
                data["bmkAnalizaAbatereAbatere"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): ConstatVers {
        const json = this.toJSON();
        let result = new ConstatVers();
        result.init(json);
        return result;
    }
}

export interface IConstatVers {
    constatId: number;
    tenantId: number;
    constat: Constat;
    stare: Stare;
    validat: boolean;
    constatUnitLocat: ConstatUnitLocat;
    constatCamere: ConstatCamera[] | undefined;
    bmkAnalizaAbatereAnalizate: BmkAnalizaAbatere[] | undefined;
    bmkAnalizaAbatereAbatere: BmkAnalizaAbatere[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Constat implements IConstat {
    tenantId: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    stare: Stare;
    adaugatManual: boolean;
    numarIncaperi: number;
    asigurator: string | undefined;
    utilizatorConstatare: string | undefined;
    tipConstatare: TipConstatare;
    constatareVers: ConstatVers[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IConstat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            this.nrContract = _data["nrContract"];
            this.dataContract = _data["dataContract"] ? moment(_data["dataContract"].toString()) : <any>undefined;
            this.stare = _data["stare"];
            this.adaugatManual = _data["adaugatManual"];
            this.numarIncaperi = _data["numarIncaperi"];
            this.asigurator = _data["asigurator"];
            this.utilizatorConstatare = _data["utilizatorConstatare"];
            this.tipConstatare = _data["tipConstatare"];
            if (Array.isArray(_data["constatareVers"])) {
                this.constatareVers = [] as any;
                for (let item of _data["constatareVers"])
                    this.constatareVers.push(ConstatVers.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Constat {
        data = typeof data === 'object' ? data : {};
        let result = new Constat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        data["nrContract"] = this.nrContract;
        data["dataContract"] = this.dataContract ? this.dataContract.toISOString() : <any>undefined;
        data["stare"] = this.stare;
        data["adaugatManual"] = this.adaugatManual;
        data["numarIncaperi"] = this.numarIncaperi;
        data["asigurator"] = this.asigurator;
        data["utilizatorConstatare"] = this.utilizatorConstatare;
        data["tipConstatare"] = this.tipConstatare;
        if (Array.isArray(this.constatareVers)) {
            data["constatareVers"] = [];
            for (let item of this.constatareVers)
                data["constatareVers"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): Constat {
        const json = this.toJSON();
        let result = new Constat();
        result.init(json);
        return result;
    }
}

export interface IConstat {
    tenantId: number;
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    nrContract: string | undefined;
    dataContract: moment.Moment;
    stare: Stare;
    adaugatManual: boolean;
    numarIncaperi: number;
    asigurator: string | undefined;
    utilizatorConstatare: string | undefined;
    tipConstatare: TipConstatare;
    constatareVers: ConstatVers[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class FilterOperatiuneRemediereAsociataDto implements IFilterOperatiuneRemediereAsociataDto {
    elementConstructivId: number | undefined;
    tipAvarieId: number | undefined;
    tipAvarieAsocId: number | undefined;

    constructor(data?: IFilterOperatiuneRemediereAsociataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementConstructivId = _data["elementConstructivId"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarieAsocId = _data["tipAvarieAsocId"];
        }
    }

    static fromJS(data: any): FilterOperatiuneRemediereAsociataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOperatiuneRemediereAsociataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementConstructivId"] = this.elementConstructivId;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarieAsocId"] = this.tipAvarieAsocId;
        return data;
    }

    clone(): FilterOperatiuneRemediereAsociataDto {
        const json = this.toJSON();
        let result = new FilterOperatiuneRemediereAsociataDto();
        result.init(json);
        return result;
    }
}

export interface IFilterOperatiuneRemediereAsociataDto {
    elementConstructivId: number | undefined;
    tipAvarieId: number | undefined;
    tipAvarieAsocId: number | undefined;
}

export class OperatiuneRemediereAsociatDto implements IOperatiuneRemediereAsociatDto {
    id: number;
    elementConstructivId: number | undefined;
    tipAvarieId: number | undefined;
    tipAvarieAsociatId: number | undefined;
    elementConstructivNume: string | undefined;
    tipAvarieNume: string | undefined;
    tipAvarieAsociatNume: string | undefined;
    stare: Stare;

    constructor(data?: IOperatiuneRemediereAsociatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarieAsociatId = _data["tipAvarieAsociatId"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.tipAvarieAsociatNume = _data["tipAvarieAsociatNume"];
            this.stare = _data["stare"];
        }
    }

    static fromJS(data: any): OperatiuneRemediereAsociatDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAsociatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["elementConstructivId"] = this.elementConstructivId;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarieAsociatId"] = this.tipAvarieAsociatId;
        data["elementConstructivNume"] = this.elementConstructivNume;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["tipAvarieAsociatNume"] = this.tipAvarieAsociatNume;
        data["stare"] = this.stare;
        return data;
    }

    clone(): OperatiuneRemediereAsociatDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAsociatDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAsociatDto {
    id: number;
    elementConstructivId: number | undefined;
    tipAvarieId: number | undefined;
    tipAvarieAsociatId: number | undefined;
    elementConstructivNume: string | undefined;
    tipAvarieNume: string | undefined;
    tipAvarieAsociatNume: string | undefined;
    stare: Stare;
}

export class OperatiuniRemediereDetDto implements IOperatiuniRemediereDetDto {
    id: number;
    tipDimensionalId: number | undefined;
    unitateMasura: string | undefined;
    operatieDeRemediere: string | undefined;
    calculCantitati: string | undefined;
    descriereSuboperatii: string | undefined;
    coefSuplim: number;
    valabAllPereti: boolean;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    tenantId: number;
    orderView: number;
    operRefacere: boolean;

    constructor(data?: IOperatiuniRemediereDetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tipDimensionalId = _data["tipDimensionalId"];
            this.unitateMasura = _data["unitateMasura"];
            this.operatieDeRemediere = _data["operatieDeRemediere"];
            this.calculCantitati = _data["calculCantitati"];
            this.descriereSuboperatii = _data["descriereSuboperatii"];
            this.coefSuplim = _data["coefSuplim"];
            this.valabAllPereti = _data["valabAllPereti"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.orderView = _data["orderView"];
            this.operRefacere = _data["operRefacere"];
        }
    }

    static fromJS(data: any): OperatiuniRemediereDetDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuniRemediereDetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tipDimensionalId"] = this.tipDimensionalId;
        data["unitateMasura"] = this.unitateMasura;
        data["operatieDeRemediere"] = this.operatieDeRemediere;
        data["calculCantitati"] = this.calculCantitati;
        data["descriereSuboperatii"] = this.descriereSuboperatii;
        data["coefSuplim"] = this.coefSuplim;
        data["valabAllPereti"] = this.valabAllPereti;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["orderView"] = this.orderView;
        data["operRefacere"] = this.operRefacere;
        return data;
    }

    clone(): OperatiuniRemediereDetDto {
        const json = this.toJSON();
        let result = new OperatiuniRemediereDetDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuniRemediereDetDto {
    id: number;
    tipDimensionalId: number | undefined;
    unitateMasura: string | undefined;
    operatieDeRemediere: string | undefined;
    calculCantitati: string | undefined;
    descriereSuboperatii: string | undefined;
    coefSuplim: number;
    valabAllPereti: boolean;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    tenantId: number;
    orderView: number;
    operRefacere: boolean;
}

export class OperatiuniRemediereDto implements IOperatiuniRemediereDto {
    tenantId: number;
    tipZonaAvariataId: number | undefined;
    tipZonaAvariata: string | undefined;
    categorieElementId: number | undefined;
    categorieElement: string | undefined;
    elementAvariatId: number | undefined;
    elementAvariat: string | undefined;
    elementConstructivId: number | undefined;
    elementConstructiv: string | undefined;
    tipAvarieId: number | undefined;
    tipAvarie: string | undefined;
    operatiuniRemediereDet: OperatiuniRemediereDetDto[] | undefined;
    orderView: number;
    constatCameraDaunaId: number | undefined;
    constatCameraId: number;

    constructor(data?: IOperatiuniRemediereDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tipZonaAvariataId = _data["tipZonaAvariataId"];
            this.tipZonaAvariata = _data["tipZonaAvariata"];
            this.categorieElementId = _data["categorieElementId"];
            this.categorieElement = _data["categorieElement"];
            this.elementAvariatId = _data["elementAvariatId"];
            this.elementAvariat = _data["elementAvariat"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.elementConstructiv = _data["elementConstructiv"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipAvarie = _data["tipAvarie"];
            if (Array.isArray(_data["operatiuniRemediereDet"])) {
                this.operatiuniRemediereDet = [] as any;
                for (let item of _data["operatiuniRemediereDet"])
                    this.operatiuniRemediereDet.push(OperatiuniRemediereDetDto.fromJS(item));
            }
            this.orderView = _data["orderView"];
            this.constatCameraDaunaId = _data["constatCameraDaunaId"];
            this.constatCameraId = _data["constatCameraId"];
        }
    }

    static fromJS(data: any): OperatiuniRemediereDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuniRemediereDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tipZonaAvariataId"] = this.tipZonaAvariataId;
        data["tipZonaAvariata"] = this.tipZonaAvariata;
        data["categorieElementId"] = this.categorieElementId;
        data["categorieElement"] = this.categorieElement;
        data["elementAvariatId"] = this.elementAvariatId;
        data["elementAvariat"] = this.elementAvariat;
        data["elementConstructivId"] = this.elementConstructivId;
        data["elementConstructiv"] = this.elementConstructiv;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipAvarie"] = this.tipAvarie;
        if (Array.isArray(this.operatiuniRemediereDet)) {
            data["operatiuniRemediereDet"] = [];
            for (let item of this.operatiuniRemediereDet)
                data["operatiuniRemediereDet"].push(item.toJSON());
        }
        data["orderView"] = this.orderView;
        data["constatCameraDaunaId"] = this.constatCameraDaunaId;
        data["constatCameraId"] = this.constatCameraId;
        return data;
    }

    clone(): OperatiuniRemediereDto {
        const json = this.toJSON();
        let result = new OperatiuniRemediereDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuniRemediereDto {
    tenantId: number;
    tipZonaAvariataId: number | undefined;
    tipZonaAvariata: string | undefined;
    categorieElementId: number | undefined;
    categorieElement: string | undefined;
    elementAvariatId: number | undefined;
    elementAvariat: string | undefined;
    elementConstructivId: number | undefined;
    elementConstructiv: string | undefined;
    tipAvarieId: number | undefined;
    tipAvarie: string | undefined;
    operatiuniRemediereDet: OperatiuniRemediereDetDto[] | undefined;
    orderView: number;
    constatCameraDaunaId: number | undefined;
    constatCameraId: number;
}

export class OperatiuniRemediereHDetDto implements IOperatiuniRemediereHDetDto {
    headerFiltru: OperatiuniRemediereDto;
    operatiuni: OperatiuniRemediereDetDto[] | undefined;

    constructor(data?: IOperatiuniRemediereHDetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headerFiltru = _data["headerFiltru"] ? OperatiuniRemediereDto.fromJS(_data["headerFiltru"]) : <any>undefined;
            if (Array.isArray(_data["operatiuni"])) {
                this.operatiuni = [] as any;
                for (let item of _data["operatiuni"])
                    this.operatiuni.push(OperatiuniRemediereDetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuniRemediereHDetDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuniRemediereHDetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerFiltru"] = this.headerFiltru ? this.headerFiltru.toJSON() : <any>undefined;
        if (Array.isArray(this.operatiuni)) {
            data["operatiuni"] = [];
            for (let item of this.operatiuni)
                data["operatiuni"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuniRemediereHDetDto {
        const json = this.toJSON();
        let result = new OperatiuniRemediereHDetDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuniRemediereHDetDto {
    headerFiltru: OperatiuniRemediereDto;
    operatiuni: OperatiuniRemediereDetDto[] | undefined;
}

export class TipElementAvariatDto implements ITipElementAvariatDto {
    id: number;
    nume: string | undefined;
    categorieElement: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;

    constructor(data?: ITipElementAvariatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.categorieElement = _data["categorieElement"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.idIntern = _data["idIntern"];
        }
    }

    static fromJS(data: any): TipElementAvariatDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipElementAvariatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["categorieElement"] = this.categorieElement;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["idIntern"] = this.idIntern;
        return data;
    }

    clone(): TipElementAvariatDto {
        const json = this.toJSON();
        let result = new TipElementAvariatDto();
        result.init(json);
        return result;
    }
}

export interface ITipElementAvariatDto {
    id: number;
    nume: string | undefined;
    categorieElement: string | undefined;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    idIntern: number;
}

export class FilterOperatiuniRemediereInputDto implements IFilterOperatiuniRemediereInputDto {
    tipAvarieList: TipAvarieDto[] | undefined;
    tipZonaAvariataList: TipZonaAvariataDto[] | undefined;
    elementConstructivList: ElementConstructivDto[] | undefined;

    constructor(data?: IFilterOperatiuniRemediereInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tipAvarieList"])) {
                this.tipAvarieList = [] as any;
                for (let item of _data["tipAvarieList"])
                    this.tipAvarieList.push(TipAvarieDto.fromJS(item));
            }
            if (Array.isArray(_data["tipZonaAvariataList"])) {
                this.tipZonaAvariataList = [] as any;
                for (let item of _data["tipZonaAvariataList"])
                    this.tipZonaAvariataList.push(TipZonaAvariataDto.fromJS(item));
            }
            if (Array.isArray(_data["elementConstructivList"])) {
                this.elementConstructivList = [] as any;
                for (let item of _data["elementConstructivList"])
                    this.elementConstructivList.push(ElementConstructivDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterOperatiuniRemediereInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOperatiuniRemediereInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tipAvarieList)) {
            data["tipAvarieList"] = [];
            for (let item of this.tipAvarieList)
                data["tipAvarieList"].push(item.toJSON());
        }
        if (Array.isArray(this.tipZonaAvariataList)) {
            data["tipZonaAvariataList"] = [];
            for (let item of this.tipZonaAvariataList)
                data["tipZonaAvariataList"].push(item.toJSON());
        }
        if (Array.isArray(this.elementConstructivList)) {
            data["elementConstructivList"] = [];
            for (let item of this.elementConstructivList)
                data["elementConstructivList"].push(item.toJSON());
        }
        return data;
    }

    clone(): FilterOperatiuniRemediereInputDto {
        const json = this.toJSON();
        let result = new FilterOperatiuniRemediereInputDto();
        result.init(json);
        return result;
    }
}

export interface IFilterOperatiuniRemediereInputDto {
    tipAvarieList: TipAvarieDto[] | undefined;
    tipZonaAvariataList: TipZonaAvariataDto[] | undefined;
    elementConstructivList: ElementConstructivDto[] | undefined;
}

export class FilterOperatiuniRemediereOutputDto implements IFilterOperatiuniRemediereOutputDto {
    tipAvarie: TipAvarieDto;
    tipZonaAvariata: TipZonaAvariataDto;
    elementConstructiv: ElementConstructivDto;
    operatiuniRemediereDetList: OperatiuniRemediereDetDto[] | undefined;
    expand: boolean;

    constructor(data?: IFilterOperatiuniRemediereOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipAvarie = _data["tipAvarie"] ? TipAvarieDto.fromJS(_data["tipAvarie"]) : <any>undefined;
            this.tipZonaAvariata = _data["tipZonaAvariata"] ? TipZonaAvariataDto.fromJS(_data["tipZonaAvariata"]) : <any>undefined;
            this.elementConstructiv = _data["elementConstructiv"] ? ElementConstructivDto.fromJS(_data["elementConstructiv"]) : <any>undefined;
            if (Array.isArray(_data["operatiuniRemediereDetList"])) {
                this.operatiuniRemediereDetList = [] as any;
                for (let item of _data["operatiuniRemediereDetList"])
                    this.operatiuniRemediereDetList.push(OperatiuniRemediereDetDto.fromJS(item));
            }
            this.expand = _data["expand"];
        }
    }

    static fromJS(data: any): FilterOperatiuniRemediereOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOperatiuniRemediereOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipAvarie"] = this.tipAvarie ? this.tipAvarie.toJSON() : <any>undefined;
        data["tipZonaAvariata"] = this.tipZonaAvariata ? this.tipZonaAvariata.toJSON() : <any>undefined;
        data["elementConstructiv"] = this.elementConstructiv ? this.elementConstructiv.toJSON() : <any>undefined;
        if (Array.isArray(this.operatiuniRemediereDetList)) {
            data["operatiuniRemediereDetList"] = [];
            for (let item of this.operatiuniRemediereDetList)
                data["operatiuniRemediereDetList"].push(item.toJSON());
        }
        data["expand"] = this.expand;
        return data;
    }

    clone(): FilterOperatiuniRemediereOutputDto {
        const json = this.toJSON();
        let result = new FilterOperatiuniRemediereOutputDto();
        result.init(json);
        return result;
    }
}

export interface IFilterOperatiuniRemediereOutputDto {
    tipAvarie: TipAvarieDto;
    tipZonaAvariata: TipZonaAvariataDto;
    elementConstructiv: ElementConstructivDto;
    operatiuniRemediereDetList: OperatiuniRemediereDetDto[] | undefined;
    expand: boolean;
}

export class FilterOperatiuniRemediereInput2Dto implements IFilterOperatiuniRemediereInput2Dto {
    tipAvarieId: number | undefined;
    tipZonaAvariataId: number | undefined;
    elementConstructivId: number | undefined;

    constructor(data?: IFilterOperatiuniRemediereInput2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipZonaAvariataId = _data["tipZonaAvariataId"];
            this.elementConstructivId = _data["elementConstructivId"];
        }
    }

    static fromJS(data: any): FilterOperatiuniRemediereInput2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOperatiuniRemediereInput2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipZonaAvariataId"] = this.tipZonaAvariataId;
        data["elementConstructivId"] = this.elementConstructivId;
        return data;
    }

    clone(): FilterOperatiuniRemediereInput2Dto {
        const json = this.toJSON();
        let result = new FilterOperatiuniRemediereInput2Dto();
        result.init(json);
        return result;
    }
}

export interface IFilterOperatiuniRemediereInput2Dto {
    tipAvarieId: number | undefined;
    tipZonaAvariataId: number | undefined;
    elementConstructivId: number | undefined;
}

export class FilterOperatiuniRemediereOutput2Dto implements IFilterOperatiuniRemediereOutput2Dto {
    tipAvarieNume: string | undefined;
    tipAvarieId: number | undefined;
    tipZonaAvariataNume: string | undefined;
    tipZonaAvariataId: number | undefined;
    elementConstructivNume: string | undefined;
    elementConstructivId: number | undefined;
    categorieElementId: number | undefined;
    categorieElementNume: string | undefined;
    elementAvariatId: number | undefined;
    elementAvariatNume: string | undefined;
    operatiuniRemediereDetList: OperatiuniRemediereDetDto[] | undefined;
    expand: boolean;

    constructor(data?: IFilterOperatiuniRemediereOutput2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.tipAvarieId = _data["tipAvarieId"];
            this.tipZonaAvariataNume = _data["tipZonaAvariataNume"];
            this.tipZonaAvariataId = _data["tipZonaAvariataId"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            this.elementConstructivId = _data["elementConstructivId"];
            this.categorieElementId = _data["categorieElementId"];
            this.categorieElementNume = _data["categorieElementNume"];
            this.elementAvariatId = _data["elementAvariatId"];
            this.elementAvariatNume = _data["elementAvariatNume"];
            if (Array.isArray(_data["operatiuniRemediereDetList"])) {
                this.operatiuniRemediereDetList = [] as any;
                for (let item of _data["operatiuniRemediereDetList"])
                    this.operatiuniRemediereDetList.push(OperatiuniRemediereDetDto.fromJS(item));
            }
            this.expand = _data["expand"];
        }
    }

    static fromJS(data: any): FilterOperatiuniRemediereOutput2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOperatiuniRemediereOutput2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["tipAvarieId"] = this.tipAvarieId;
        data["tipZonaAvariataNume"] = this.tipZonaAvariataNume;
        data["tipZonaAvariataId"] = this.tipZonaAvariataId;
        data["elementConstructivNume"] = this.elementConstructivNume;
        data["elementConstructivId"] = this.elementConstructivId;
        data["categorieElementId"] = this.categorieElementId;
        data["categorieElementNume"] = this.categorieElementNume;
        data["elementAvariatId"] = this.elementAvariatId;
        data["elementAvariatNume"] = this.elementAvariatNume;
        if (Array.isArray(this.operatiuniRemediereDetList)) {
            data["operatiuniRemediereDetList"] = [];
            for (let item of this.operatiuniRemediereDetList)
                data["operatiuniRemediereDetList"].push(item.toJSON());
        }
        data["expand"] = this.expand;
        return data;
    }

    clone(): FilterOperatiuniRemediereOutput2Dto {
        const json = this.toJSON();
        let result = new FilterOperatiuniRemediereOutput2Dto();
        result.init(json);
        return result;
    }
}

export interface IFilterOperatiuniRemediereOutput2Dto {
    tipAvarieNume: string | undefined;
    tipAvarieId: number | undefined;
    tipZonaAvariataNume: string | undefined;
    tipZonaAvariataId: number | undefined;
    elementConstructivNume: string | undefined;
    elementConstructivId: number | undefined;
    categorieElementId: number | undefined;
    categorieElementNume: string | undefined;
    elementAvariatId: number | undefined;
    elementAvariatNume: string | undefined;
    operatiuniRemediereDetList: OperatiuniRemediereDetDto[] | undefined;
    expand: boolean;
}

export class OperatiuneRemediereArticolEditDto implements IOperatiuneRemediereArticolEditDto {
    id: number;
    operatiuneRemediereId: number;
    articolDevizId: number;
    cantitatePerUnit: number;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;

    constructor(data?: IOperatiuneRemediereArticolEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operatiuneRemediereId = _data["operatiuneRemediereId"];
            this.articolDevizId = _data["articolDevizId"];
            this.cantitatePerUnit = _data["cantitatePerUnit"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.orderView = _data["orderView"];
        }
    }

    static fromJS(data: any): OperatiuneRemediereArticolEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereArticolEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operatiuneRemediereId"] = this.operatiuneRemediereId;
        data["articolDevizId"] = this.articolDevizId;
        data["cantitatePerUnit"] = this.cantitatePerUnit;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["orderView"] = this.orderView;
        return data;
    }

    clone(): OperatiuneRemediereArticolEditDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereArticolEditDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereArticolEditDto {
    id: number;
    operatiuneRemediereId: number;
    articolDevizId: number;
    cantitatePerUnit: number;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;
}

export class OperatiuneRemediereArticolDto implements IOperatiuneRemediereArticolDto {
    id: number;
    operatiuneRemediereId: number;
    articolDevizId: number;
    nume: string | undefined;
    tipDimensional: string | undefined;
    articolDevizCategorie: string | undefined;
    cantitatePerUnit: number;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;

    constructor(data?: IOperatiuneRemediereArticolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operatiuneRemediereId = _data["operatiuneRemediereId"];
            this.articolDevizId = _data["articolDevizId"];
            this.nume = _data["nume"];
            this.tipDimensional = _data["tipDimensional"];
            this.articolDevizCategorie = _data["articolDevizCategorie"];
            this.cantitatePerUnit = _data["cantitatePerUnit"];
            this.stare = _data["stare"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
            this.orderView = _data["orderView"];
        }
    }

    static fromJS(data: any): OperatiuneRemediereArticolDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereArticolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operatiuneRemediereId"] = this.operatiuneRemediereId;
        data["articolDevizId"] = this.articolDevizId;
        data["nume"] = this.nume;
        data["tipDimensional"] = this.tipDimensional;
        data["articolDevizCategorie"] = this.articolDevizCategorie;
        data["cantitatePerUnit"] = this.cantitatePerUnit;
        data["stare"] = this.stare;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        data["orderView"] = this.orderView;
        return data;
    }

    clone(): OperatiuneRemediereArticolDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereArticolDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereArticolDto {
    id: number;
    operatiuneRemediereId: number;
    articolDevizId: number;
    nume: string | undefined;
    tipDimensional: string | undefined;
    articolDevizCategorie: string | undefined;
    cantitatePerUnit: number;
    stare: Stare;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
    orderView: number;
}

export class OperatiuneRemediereTabelCalculReportDto implements IOperatiuneRemediereTabelCalculReportDto {
    numeArticolDeviz: string | undefined;
    articolTip: ArticolTip;
    cantitate: number;
    pretUnit: number;
    valoare: number;

    constructor(data?: IOperatiuneRemediereTabelCalculReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeArticolDeviz = _data["numeArticolDeviz"];
            this.articolTip = _data["articolTip"];
            this.cantitate = _data["cantitate"];
            this.pretUnit = _data["pretUnit"];
            this.valoare = _data["valoare"];
        }
    }

    static fromJS(data: any): OperatiuneRemediereTabelCalculReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereTabelCalculReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeArticolDeviz"] = this.numeArticolDeviz;
        data["articolTip"] = this.articolTip;
        data["cantitate"] = this.cantitate;
        data["pretUnit"] = this.pretUnit;
        data["valoare"] = this.valoare;
        return data;
    }

    clone(): OperatiuneRemediereTabelCalculReportDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereTabelCalculReportDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereTabelCalculReportDto {
    numeArticolDeviz: string | undefined;
    articolTip: ArticolTip;
    cantitate: number;
    pretUnit: number;
    valoare: number;
}

export class OperatiuneRemediereAfisareArticolReportDto implements IOperatiuneRemediereAfisareArticolReportDto {
    numeArticol: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;

    constructor(data?: IOperatiuneRemediereAfisareArticolReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeArticol = _data["numeArticol"];
            this.tipDimensional = _data["tipDimensional"];
            this.cantitate = _data["cantitate"];
            this.orderView = _data["orderView"];
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareArticolReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareArticolReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeArticol"] = this.numeArticol;
        data["tipDimensional"] = this.tipDimensional;
        data["cantitate"] = this.cantitate;
        data["orderView"] = this.orderView;
        return data;
    }

    clone(): OperatiuneRemediereAfisareArticolReportDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareArticolReportDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareArticolReportDto {
    numeArticol: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;
}

export class OperatiuneRemediereAfisareArticolDevizReportDto implements IOperatiuneRemediereAfisareArticolDevizReportDto {
    numeArticolDeviz: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolList: OperatiuneRemediereAfisareArticolReportDto[] | undefined;

    constructor(data?: IOperatiuneRemediereAfisareArticolDevizReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeArticolDeviz = _data["numeArticolDeviz"];
            this.tipDimensional = _data["tipDimensional"];
            this.cantitate = _data["cantitate"];
            this.orderView = _data["orderView"];
            if (Array.isArray(_data["operatiuneRemediereArticolList"])) {
                this.operatiuneRemediereArticolList = [] as any;
                for (let item of _data["operatiuneRemediereArticolList"])
                    this.operatiuneRemediereArticolList.push(OperatiuneRemediereAfisareArticolReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareArticolDevizReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareArticolDevizReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeArticolDeviz"] = this.numeArticolDeviz;
        data["tipDimensional"] = this.tipDimensional;
        data["cantitate"] = this.cantitate;
        data["orderView"] = this.orderView;
        if (Array.isArray(this.operatiuneRemediereArticolList)) {
            data["operatiuneRemediereArticolList"] = [];
            for (let item of this.operatiuneRemediereArticolList)
                data["operatiuneRemediereArticolList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereAfisareArticolDevizReportDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareArticolDevizReportDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareArticolDevizReportDto {
    numeArticolDeviz: string | undefined;
    tipDimensional: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolList: OperatiuneRemediereAfisareArticolReportDto[] | undefined;
}

export class OperatiuneRemediereReportDto implements IOperatiuneRemediereReportDto {
    numeCamera: string | undefined;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatieDeRemediere: string | undefined;
    unitateDeMasura: string | undefined;
    coefSuplim: number;
    descriereSuboperatii: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolDevizList: OperatiuneRemediereAfisareArticolDevizReportDto[] | undefined;

    constructor(data?: IOperatiuneRemediereReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeCamera = _data["numeCamera"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            this.operatieDeRemediere = _data["operatieDeRemediere"];
            this.unitateDeMasura = _data["unitateDeMasura"];
            this.coefSuplim = _data["coefSuplim"];
            this.descriereSuboperatii = _data["descriereSuboperatii"];
            this.cantitate = _data["cantitate"];
            this.orderView = _data["orderView"];
            if (Array.isArray(_data["operatiuneRemediereArticolDevizList"])) {
                this.operatiuneRemediereArticolDevizList = [] as any;
                for (let item of _data["operatiuneRemediereArticolDevizList"])
                    this.operatiuneRemediereArticolDevizList.push(OperatiuneRemediereAfisareArticolDevizReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeCamera"] = this.numeCamera;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["elementConstructivNume"] = this.elementConstructivNume;
        data["operatieDeRemediere"] = this.operatieDeRemediere;
        data["unitateDeMasura"] = this.unitateDeMasura;
        data["coefSuplim"] = this.coefSuplim;
        data["descriereSuboperatii"] = this.descriereSuboperatii;
        data["cantitate"] = this.cantitate;
        data["orderView"] = this.orderView;
        if (Array.isArray(this.operatiuneRemediereArticolDevizList)) {
            data["operatiuneRemediereArticolDevizList"] = [];
            for (let item of this.operatiuneRemediereArticolDevizList)
                data["operatiuneRemediereArticolDevizList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereReportDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereReportDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereReportDto {
    numeCamera: string | undefined;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatieDeRemediere: string | undefined;
    unitateDeMasura: string | undefined;
    coefSuplim: number;
    descriereSuboperatii: string | undefined;
    cantitate: number;
    orderView: number;
    operatiuneRemediereArticolDevizList: OperatiuneRemediereAfisareArticolDevizReportDto[] | undefined;
}

export class OperatiuneRemediereAfisareDaunaReportDto implements IOperatiuneRemediereAfisareDaunaReportDto {
    daunaId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatiuneRemediereList: OperatiuneRemediereReportDto[] | undefined;

    constructor(data?: IOperatiuneRemediereAfisareDaunaReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daunaId = _data["daunaId"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            if (Array.isArray(_data["operatiuneRemediereList"])) {
                this.operatiuneRemediereList = [] as any;
                for (let item of _data["operatiuneRemediereList"])
                    this.operatiuneRemediereList.push(OperatiuneRemediereReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareDaunaReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareDaunaReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daunaId"] = this.daunaId;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["elementConstructivNume"] = this.elementConstructivNume;
        if (Array.isArray(this.operatiuneRemediereList)) {
            data["operatiuneRemediereList"] = [];
            for (let item of this.operatiuneRemediereList)
                data["operatiuneRemediereList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereAfisareDaunaReportDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareDaunaReportDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareDaunaReportDto {
    daunaId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    operatiuneRemediereList: OperatiuneRemediereReportDto[] | undefined;
}

export class OperatiuneRemediereAfisareCameraReportDto implements IOperatiuneRemediereAfisareCameraReportDto {
    numeCamera: string | undefined;
    cameraId: number;
    operatiuneRemediereAfisareDaunaList: OperatiuneRemediereAfisareDaunaReportDto[] | undefined;

    constructor(data?: IOperatiuneRemediereAfisareCameraReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numeCamera = _data["numeCamera"];
            this.cameraId = _data["cameraId"];
            if (Array.isArray(_data["operatiuneRemediereAfisareDaunaList"])) {
                this.operatiuneRemediereAfisareDaunaList = [] as any;
                for (let item of _data["operatiuneRemediereAfisareDaunaList"])
                    this.operatiuneRemediereAfisareDaunaList.push(OperatiuneRemediereAfisareDaunaReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatiuneRemediereAfisareCameraReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatiuneRemediereAfisareCameraReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numeCamera"] = this.numeCamera;
        data["cameraId"] = this.cameraId;
        if (Array.isArray(this.operatiuneRemediereAfisareDaunaList)) {
            data["operatiuneRemediereAfisareDaunaList"] = [];
            for (let item of this.operatiuneRemediereAfisareDaunaList)
                data["operatiuneRemediereAfisareDaunaList"].push(item.toJSON());
        }
        return data;
    }

    clone(): OperatiuneRemediereAfisareCameraReportDto {
        const json = this.toJSON();
        let result = new OperatiuneRemediereAfisareCameraReportDto();
        result.init(json);
        return result;
    }
}

export interface IOperatiuneRemediereAfisareCameraReportDto {
    numeCamera: string | undefined;
    cameraId: number;
    operatiuneRemediereAfisareDaunaList: OperatiuneRemediereAfisareDaunaReportDto[] | undefined;
}

export class FlattenOperatiuneRemedieAfisareCameraReport implements IFlattenOperatiuneRemedieAfisareCameraReport {
    operRemediereNume: string | undefined;
    calculCantitati: string | undefined;
    calculCantitatiVal: string | undefined;
    operRemediereUM: string | undefined;
    operRemediereCPO: number;
    operRemediereCantitate: number;
    operRemediereSubOper: string | undefined;
    operRemediereOrderView: number;
    operRemediereArticolOrderView: number;
    operRemediereId: number;
    numeCamera: string | undefined;
    cameraId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    daunaId: number | undefined;
    articolTip: string | undefined;
    articolTipId: number;
    articolDevizNume: string | undefined;
    artciolDevizOderView: number;
    articolNume: string | undefined;
    articolCantitate: number;
    articolUnitateMasura: string | undefined;

    constructor(data?: IFlattenOperatiuneRemedieAfisareCameraReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operRemediereNume = _data["operRemediereNume"];
            this.calculCantitati = _data["calculCantitati"];
            this.calculCantitatiVal = _data["calculCantitatiVal"];
            this.operRemediereUM = _data["operRemediereUM"];
            this.operRemediereCPO = _data["operRemediereCPO"];
            this.operRemediereCantitate = _data["operRemediereCantitate"];
            this.operRemediereSubOper = _data["operRemediereSubOper"];
            this.operRemediereOrderView = _data["operRemediereOrderView"];
            this.operRemediereArticolOrderView = _data["operRemediereArticolOrderView"];
            this.operRemediereId = _data["operRemediereId"];
            this.numeCamera = _data["numeCamera"];
            this.cameraId = _data["cameraId"];
            this.tipAvarieNume = _data["tipAvarieNume"];
            this.elementConstructivNume = _data["elementConstructivNume"];
            this.daunaId = _data["daunaId"];
            this.articolTip = _data["articolTip"];
            this.articolTipId = _data["articolTipId"];
            this.articolDevizNume = _data["articolDevizNume"];
            this.artciolDevizOderView = _data["artciolDevizOderView"];
            this.articolNume = _data["articolNume"];
            this.articolCantitate = _data["articolCantitate"];
            this.articolUnitateMasura = _data["articolUnitateMasura"];
        }
    }

    static fromJS(data: any): FlattenOperatiuneRemedieAfisareCameraReport {
        data = typeof data === 'object' ? data : {};
        let result = new FlattenOperatiuneRemedieAfisareCameraReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operRemediereNume"] = this.operRemediereNume;
        data["calculCantitati"] = this.calculCantitati;
        data["calculCantitatiVal"] = this.calculCantitatiVal;
        data["operRemediereUM"] = this.operRemediereUM;
        data["operRemediereCPO"] = this.operRemediereCPO;
        data["operRemediereCantitate"] = this.operRemediereCantitate;
        data["operRemediereSubOper"] = this.operRemediereSubOper;
        data["operRemediereOrderView"] = this.operRemediereOrderView;
        data["operRemediereArticolOrderView"] = this.operRemediereArticolOrderView;
        data["operRemediereId"] = this.operRemediereId;
        data["numeCamera"] = this.numeCamera;
        data["cameraId"] = this.cameraId;
        data["tipAvarieNume"] = this.tipAvarieNume;
        data["elementConstructivNume"] = this.elementConstructivNume;
        data["daunaId"] = this.daunaId;
        data["articolTip"] = this.articolTip;
        data["articolTipId"] = this.articolTipId;
        data["articolDevizNume"] = this.articolDevizNume;
        data["artciolDevizOderView"] = this.artciolDevizOderView;
        data["articolNume"] = this.articolNume;
        data["articolCantitate"] = this.articolCantitate;
        data["articolUnitateMasura"] = this.articolUnitateMasura;
        return data;
    }

    clone(): FlattenOperatiuneRemedieAfisareCameraReport {
        const json = this.toJSON();
        let result = new FlattenOperatiuneRemedieAfisareCameraReport();
        result.init(json);
        return result;
    }
}

export interface IFlattenOperatiuneRemedieAfisareCameraReport {
    operRemediereNume: string | undefined;
    calculCantitati: string | undefined;
    calculCantitatiVal: string | undefined;
    operRemediereUM: string | undefined;
    operRemediereCPO: number;
    operRemediereCantitate: number;
    operRemediereSubOper: string | undefined;
    operRemediereOrderView: number;
    operRemediereArticolOrderView: number;
    operRemediereId: number;
    numeCamera: string | undefined;
    cameraId: number;
    tipAvarieNume: string | undefined;
    elementConstructivNume: string | undefined;
    daunaId: number | undefined;
    articolTip: string | undefined;
    articolTipId: number;
    articolDevizNume: string | undefined;
    artciolDevizOderView: number;
    articolNume: string | undefined;
    articolCantitate: number;
    articolUnitateMasura: string | undefined;
}

export class DevizModelDto implements IDevizModelDto {
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    devizTabel1: FlattenOperatiuneRemedieAfisareCameraReport[] | undefined;
    devizTabel2: OperatiuneRemediereTabelCalculReportDto[] | undefined;
    devizCalculExceptii: DevizCalculExceptiiDto[] | undefined;

    constructor(data?: IDevizModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nrConstatare = _data["nrConstatare"];
            this.dataConstatare = _data["dataConstatare"] ? moment(_data["dataConstatare"].toString()) : <any>undefined;
            if (Array.isArray(_data["devizTabel1"])) {
                this.devizTabel1 = [] as any;
                for (let item of _data["devizTabel1"])
                    this.devizTabel1.push(FlattenOperatiuneRemedieAfisareCameraReport.fromJS(item));
            }
            if (Array.isArray(_data["devizTabel2"])) {
                this.devizTabel2 = [] as any;
                for (let item of _data["devizTabel2"])
                    this.devizTabel2.push(OperatiuneRemediereTabelCalculReportDto.fromJS(item));
            }
            if (Array.isArray(_data["devizCalculExceptii"])) {
                this.devizCalculExceptii = [] as any;
                for (let item of _data["devizCalculExceptii"])
                    this.devizCalculExceptii.push(DevizCalculExceptiiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DevizModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new DevizModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nrConstatare"] = this.nrConstatare;
        data["dataConstatare"] = this.dataConstatare ? this.dataConstatare.toISOString() : <any>undefined;
        if (Array.isArray(this.devizTabel1)) {
            data["devizTabel1"] = [];
            for (let item of this.devizTabel1)
                data["devizTabel1"].push(item.toJSON());
        }
        if (Array.isArray(this.devizTabel2)) {
            data["devizTabel2"] = [];
            for (let item of this.devizTabel2)
                data["devizTabel2"].push(item.toJSON());
        }
        if (Array.isArray(this.devizCalculExceptii)) {
            data["devizCalculExceptii"] = [];
            for (let item of this.devizCalculExceptii)
                data["devizCalculExceptii"].push(item.toJSON());
        }
        return data;
    }

    clone(): DevizModelDto {
        const json = this.toJSON();
        let result = new DevizModelDto();
        result.init(json);
        return result;
    }
}

export interface IDevizModelDto {
    nrConstatare: string | undefined;
    dataConstatare: moment.Moment;
    devizTabel1: FlattenOperatiuneRemedieAfisareCameraReport[] | undefined;
    devizTabel2: OperatiuneRemediereTabelCalculReportDto[] | undefined;
    devizCalculExceptii: DevizCalculExceptiiDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = this.features[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    id: number;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;
}

export class TipElementAvariatEditDto implements ITipElementAvariatEditDto {
    id: number;
    nume: string | undefined;
    categorieElementId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;

    constructor(data?: ITipElementAvariatEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nume = _data["nume"];
            this.categorieElementId = _data["categorieElementId"];
            this.dataStart = _data["dataStart"] ? moment(_data["dataStart"].toString()) : <any>undefined;
            this.dataEnd = _data["dataEnd"] ? moment(_data["dataEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TipElementAvariatEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TipElementAvariatEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nume"] = this.nume;
        data["categorieElementId"] = this.categorieElementId;
        data["dataStart"] = this.dataStart ? this.dataStart.toISOString() : <any>undefined;
        data["dataEnd"] = this.dataEnd ? this.dataEnd.toISOString() : <any>undefined;
        return data;
    }

    clone(): TipElementAvariatEditDto {
        const json = this.toJSON();
        let result = new TipElementAvariatEditDto();
        result.init(json);
        return result;
    }
}

export interface ITipElementAvariatEditDto {
    id: number;
    nume: string | undefined;
    categorieElementId: number;
    dataStart: moment.Moment;
    dataEnd: moment.Moment | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

export class UserDto implements IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}